export const SHOP_VERTICAL_STOREFRONT_MESSAGES = {
    "template.shared.chrome.logoTagline": {
        "cs": "VYBRANÝ SORTIMENT",
        "sk": "VYBRANÝ SORTIMENT",
        "en": "SELECTED GOODS",
        "de": "AUSGEWÄHLTES SORTIMENT",
        "es": "SELECCIÓN CUIDADA",
        "pl": "WYBRANY ASORTYMENT",
        "hu": "VÁLOGATOTT KÍNÁLAT",
        "ro": "SELECȚIE CURATĂ"
    },
    "template.shared.chrome.contactPhone": {
        "cs": "+420 777 123 456",
        "sk": "+420 777 123 456",
        "en": "+420 777 123 456",
        "de": "+420 777 123 456",
        "es": "+420 777 123 456",
        "pl": "+420 777 123 456",
        "hu": "+420 777 123 456",
        "ro": "+420 777 123 456"
    },
    "template.shared.chrome.contactEmail": {
        "cs": "info@vasobchod.cz",
        "sk": "info@vasobchod.cz",
        "en": "info@vasobchod.cz",
        "de": "info@vasobchod.cz",
        "es": "info@vasobchod.cz",
        "pl": "info@vasobchod.cz",
        "hu": "info@vasobchod.cz",
        "ro": "info@vasobchod.cz"
    },
    "template.shared.chrome.socialNetworkLabel": {
        "cs": "Sociální síť",
        "sk": "Sociálna sieť",
        "en": "Social network",
        "de": "Soziales Netzwerk",
        "es": "Red social",
        "pl": "Sieć społecznościowa",
        "hu": "Közösségi hálózat",
        "ro": "Rețea socială"
    },
    "template.shared.chrome.heroOriginalPrice": {
        "cs": "2 459 Kč",
        "sk": "2 459 Kč",
        "en": "CZK 2,459",
        "de": "2.459 CZK",
        "es": "2459 CZK",
        "pl": "2459 CZK",
        "hu": "2 459 CZK",
        "ro": "2.459 CZK"
    },
    "template.shared.chrome.heroPrice": {
        "cs": "1 279 Kč",
        "sk": "1 279 Kč",
        "en": "CZK 1,279",
        "de": "1.279 CZK",
        "es": "1279 CZK",
        "pl": "1279 CZK",
        "hu": "1 279 CZK",
        "ro": "1.279 CZK"
    },
    "template.shared.chrome.badgePrice": {
        "cs": "JIŽ OD 1 450 Kč",
        "sk": "UŽ OD 1 450 Kč",
        "en": "FROM CZK 1,450",
        "de": "AB 1.450 CZK",
        "es": "DESDE 1450 CZK",
        "pl": "OD 1450 CZK",
        "hu": "MÁR 1 450 CZK-TÓL",
        "ro": "DE LA 1.450 CZK"
    },
    "template.shared.chrome.ranking1": {
        "cs": "1",
        "sk": "1",
        "en": "1",
        "de": "1",
        "es": "1",
        "pl": "1",
        "hu": "1",
        "ro": "1"
    },
    "template.shared.chrome.ranking2": {
        "cs": "2",
        "sk": "2",
        "en": "2",
        "de": "2",
        "es": "2",
        "pl": "2",
        "hu": "2",
        "ro": "2"
    },
    "template.shared.chrome.ranking3": {
        "cs": "3",
        "sk": "3",
        "en": "3",
        "de": "3",
        "es": "3",
        "pl": "3",
        "hu": "3",
        "ro": "3"
    },
    "template.shared.chrome.ranking4": {
        "cs": "4",
        "sk": "4",
        "en": "4",
        "de": "4",
        "es": "4",
        "pl": "4",
        "hu": "4",
        "ro": "4"
    },
    "template.shared.chrome.ranking5": {
        "cs": "5",
        "sk": "5",
        "en": "5",
        "de": "5",
        "es": "5",
        "pl": "5",
        "hu": "5",
        "ro": "5"
    },
    "template.shared.chrome.reviewStars": {
        "cs": "★★★★★",
        "sk": "★★★★★",
        "en": "★★★★★",
        "de": "★★★★★",
        "es": "★★★★★",
        "pl": "★★★★★",
        "hu": "★★★★★",
        "ro": "★★★★★"
    },
    "template.shared.chrome.reviewsTitle": {
        "cs": "Poslední hodnocení",
        "sk": "Najnovšie hodnotenia",
        "en": "Latest reviews",
        "de": "Neueste Bewertungen",
        "es": "Últimas valoraciones",
        "pl": "Najnowsze opinie",
        "hu": "Legutóbbi értékelések",
        "ro": "Cele mai recente recenzii"
    },
    "template.shared.chrome.reviewDate1": {
        "cs": "30. 7. 2024",
        "sk": "30. 7. 2024",
        "en": "30 Jul 2024",
        "de": "30.07.2024",
        "es": "30/07/2024",
        "pl": "30.07.2024",
        "hu": "2024. 07. 30.",
        "ro": "30.07.2024"
    },
    "template.shared.chrome.reviewDate2": {
        "cs": "28. 11. 2023",
        "sk": "28. 11. 2023",
        "en": "28 Nov 2023",
        "de": "28.11.2023",
        "es": "28/11/2023",
        "pl": "28.11.2023",
        "hu": "2023. 11. 28.",
        "ro": "28.11.2023"
    },
    "template.shared.chrome.reviewDate3": {
        "cs": "5. 7. 2022",
        "sk": "5. 7. 2022",
        "en": "5 Jul 2022",
        "de": "05.07.2022",
        "es": "05/07/2022",
        "pl": "05.07.2022",
        "hu": "2022. 07. 05.",
        "ro": "05.07.2022"
    },
    "template.shared.chrome.reviewDate4": {
        "cs": "30. 11. 2021",
        "sk": "30. 11. 2021",
        "en": "30 Nov 2021",
        "de": "30.11.2021",
        "es": "30/11/2021",
        "pl": "30.11.2021",
        "hu": "2021. 11. 30.",
        "ro": "30.11.2021"
    },
    "template.shared.chrome.reviewAuthor1": {
        "cs": "Anna",
        "sk": "Anna",
        "en": "Anna",
        "de": "Anna",
        "es": "Ana",
        "pl": "Anna",
        "hu": "Anna",
        "ro": "Ana"
    },
    "template.shared.chrome.reviewAuthor2": {
        "cs": "David",
        "sk": "David",
        "en": "David",
        "de": "David",
        "es": "David",
        "pl": "Dawid",
        "hu": "Dávid",
        "ro": "David"
    },
    "template.shared.chrome.reviewAuthor3": {
        "cs": "Ondřej",
        "sk": "Ondrej",
        "en": "Andrew",
        "de": "Andreas",
        "es": "Andrés",
        "pl": "Andrzej",
        "hu": "András",
        "ro": "Andrei"
    },
    "template.shared.chrome.reviewAuthor4": {
        "cs": "Katka",
        "sk": "Katka",
        "en": "Kate",
        "de": "Katja",
        "es": "Catalina",
        "pl": "Kasia",
        "hu": "Kata",
        "ro": "Cătălina"
    },
    "template.shared.chrome.seoAction": {
        "cs": "Více o výběru",
        "sk": "Viac o výbere",
        "en": "More about choosing",
        "de": "Mehr zur Auswahl erfahren",
        "es": "Más sobre cómo elegir",
        "pl": "Więcej o wyborze",
        "hu": "További segítség a választáshoz",
        "ro": "Mai multe despre alegere"
    },
    "template.shared.chrome.newsletterTitle": {
        "cs": "Výběry a novinky na jednom místě",
        "sk": "Výbery a novinky na jednom mieste",
        "en": "Curated picks and new arrivals in one place",
        "de": "Ausgewählte Produkte und Neuheiten an einem Ort",
        "es": "Selecciones cuidadas y novedades en un solo lugar",
        "pl": "Starannie wybrane produkty i nowości w jednym miejscu",
        "hu": "Gondosan válogatott ajánlatok és újdonságok egy helyen",
        "ro": "Selecții atent alese și noutăți într-un singur loc"
    },
    "template.shared.chrome.newsletterAction": {
        "cs": "Prohlédnout novinky",
        "sk": "Pozrieť si novinky",
        "en": "Explore new arrivals",
        "de": "Neuheiten entdecken",
        "es": "Descubre las novedades",
        "pl": "Zobacz nowości",
        "hu": "Fedezze fel az újdonságokat",
        "ro": "Descoperă noutățile"
    },
    "template.shared.chrome.newsletterEmailLabel": {
        "cs": "E-mail *",
        "sk": "E-mail *",
        "en": "Email *",
        "de": "E-Mail *",
        "es": "Correo electrónico *",
        "pl": "E-mail *",
        "hu": "E-mail *",
        "ro": "E-mail *"
    },
    "template.shared.chrome.newsletterConsent": {
        "cs": "Odesláním souhlasíte se zpracováním údajů pro zasílání novinek.",
        "sk": "Odoslaním súhlasíte so spracovaním údajov na zasielanie noviniek.",
        "en": "By submitting, you agree to the processing of your data for newsletter delivery.",
        "de": "Mit dem Absenden stimmen Sie der Verarbeitung Ihrer Daten für den Newsletterversand zu.",
        "es": "Al enviar el formulario, aceptas el tratamiento de tus datos para recibir el boletín.",
        "pl": "Wysyłając formularz, wyrażasz zgodę na przetwarzanie danych w celu wysyłki newslettera.",
        "hu": "A beküldéssel hozzájárul adatai hírlevélküldés céljából történő kezeléséhez.",
        "ro": "Prin trimitere, ești de acord cu prelucrarea datelor pentru expedierea newsletterului."
    },
    "template.shared.chrome.benefitEyebrow": {
        "cs": "PŘEHLEDNĚ PŘED NÁKUPEM",
        "sk": "PREHĽADNE PRED NÁKUPOM",
        "en": "CLEAR BEFORE YOU BUY",
        "de": "KLARHEIT VOR DEM KAUF",
        "es": "TODO CLARO ANTES DE COMPRAR",
        "pl": "WSZYSTKO JASNE PRZED ZAKUPEM",
        "hu": "MINDEN VILÁGOS VÁSÁRLÁS ELŐTT",
        "ro": "TOTUL CLAR ÎNAINTE SĂ CUMPERI"
    },
    "template.shared.chrome.benefitPrimaryAction": {
        "cs": "Prohlédnout nabídku",
        "sk": "Pozrieť si ponuku",
        "en": "Explore the range",
        "de": "Sortiment entdecken",
        "es": "Explora la selección",
        "pl": "Zobacz ofertę",
        "hu": "Fedezze fel a kínálatot",
        "ro": "Descoperă gama"
    },
    "template.shared.chrome.benefitSecondaryAction": {
        "cs": "Jak vybírat",
        "sk": "Ako si vybrať",
        "en": "How to choose",
        "de": "So treffen Sie die richtige Wahl",
        "es": "Cómo elegir",
        "pl": "Jak wybrać",
        "hu": "Hogyan válasszon",
        "ro": "Cum să alegi"
    },
    "template.shared.chrome.categoryTitle": {
        "cs": "Procházet kategorie",
        "sk": "Prehliadať kategórie",
        "en": "Browse categories",
        "de": "Kategorien entdecken",
        "es": "Explora las categorías",
        "pl": "Przeglądaj kategorie",
        "hu": "Kategóriák böngészése",
        "ro": "Explorează categoriile"
    },
    "template.shared.chrome.categoryAction": {
        "cs": "Zobrazit vše",
        "sk": "Zobraziť všetko",
        "en": "View all",
        "de": "Alle anzeigen",
        "es": "Ver todo",
        "pl": "Zobacz wszystko",
        "hu": "Összes megtekintése",
        "ro": "Vezi tot"
    },
    "template.shared.chrome.footerCompanyTitle": {
        "cs": "O obchodě",
        "sk": "O obchode",
        "en": "About the store",
        "de": "Über den Shop",
        "es": "Sobre la tienda",
        "pl": "O sklepie",
        "hu": "Az üzletről",
        "ro": "Despre magazin"
    },
    "template.shared.chrome.footerAbout": {
        "cs": "O sortimentu",
        "sk": "O sortimente",
        "en": "About the range",
        "de": "Über das Sortiment",
        "es": "Sobre nuestra selección",
        "pl": "O asortymencie",
        "hu": "A kínálatról",
        "ro": "Despre gamă"
    },
    "template.shared.chrome.footerTerms": {
        "cs": "Obchodní podmínky",
        "sk": "Obchodné podmienky",
        "en": "Terms and conditions",
        "de": "Allgemeine Geschäftsbedingungen",
        "es": "Términos y condiciones",
        "pl": "Regulamin",
        "hu": "Általános szerződési feltételek",
        "ro": "Termeni și condiții"
    },
    "template.shared.chrome.footerPrivacy": {
        "cs": "Ochrana soukromí",
        "sk": "Ochrana súkromia",
        "en": "Privacy",
        "de": "Datenschutz",
        "es": "Privacidad",
        "pl": "Polityka prywatności",
        "hu": "Adatvédelem",
        "ro": "Confidențialitate"
    },
    "template.shared.chrome.footerCookies": {
        "cs": "Nastavení cookies",
        "sk": "Nastavenia cookies",
        "en": "Cookie settings",
        "de": "Cookie-Einstellungen",
        "es": "Configuración de cookies",
        "pl": "Ustawienia plików cookie",
        "hu": "Sütibeállítások",
        "ro": "Setări cookie"
    },
    "template.shared.chrome.footerContact": {
        "cs": "Kontakt",
        "sk": "Kontakt",
        "en": "Contact",
        "de": "Kontakt",
        "es": "Contacto",
        "pl": "Kontakt",
        "hu": "Kapcsolat",
        "ro": "Date de contact"
    },
    "template.shared.chrome.learningProgressPrimary": {
        "cs": "82%",
        "sk": "82%",
        "en": "82%",
        "de": "82%",
        "es": "82%",
        "pl": "82%",
        "hu": "82%",
        "ro": "82%"
    },
    "template.shared.chrome.learningProgressSecondary": {
        "cs": "96%",
        "sk": "96%",
        "en": "96%",
        "de": "96%",
        "es": "96%",
        "pl": "96%",
        "hu": "96%",
        "ro": "96%"
    },
    "template.beauty-store.home.eyebrow": {
        "cs": "PÉČE PODLE POTŘEBY",
        "sk": "STAROSTLIVOSŤ PODĽA POTREBY",
        "en": "CARE BY CONCERN",
        "de": "PFLEGE NACH HAUTBEDÜRFNIS",
        "es": "CUIDADO SEGÚN CADA NECESIDAD",
        "pl": "PIELĘGNACJA DOPASOWANA DO POTRZEB",
        "hu": "ÁPOLÁS BŐRIGÉNY SZERINT",
        "ro": "ÎNGRIJIRE DUPĂ NEVOILE PIELII"
    },
    "template.beauty-store.home.title": {
        "cs": "Rutina, která dává smysl vaší pleti.",
        "sk": "Rutina, ktorá vašej pleti dáva zmysel.",
        "en": "A routine that makes sense for your skin.",
        "de": "Eine Routine, die zu Ihrer Haut passt.",
        "es": "Una rutina que tiene sentido para tu piel.",
        "pl": "Rutyna, która ma sens dla twojej skóry.",
        "hu": "Egy rutin, amely valóban illik a bőréhez.",
        "ro": "O rutină care are sens pentru pielea ta."
    },
    "template.beauty-store.home.body": {
        "cs": "Vyberte péči podle cíle, textury a ingrediencí. Každý krok je vysvětlený jednoduše a bez přehnaných slibů.",
        "sk": "Vyberte si starostlivosť podľa cieľa, textúry a ingrediencií. Každý krok je vysvetlený jednoducho a bez prehnaných sľubov.",
        "en": "Choose care by goal, texture and ingredient. Every step is explained clearly and without exaggerated promises.",
        "de": "Wählen Sie Pflege nach Ziel, Textur und Inhaltsstoff. Jeder Schritt wird klar und ohne übertriebene Versprechen erklärt.",
        "es": "Elige el cuidado según tu objetivo, la textura y los ingredientes. Cada paso se explica con claridad y sin promesas exageradas.",
        "pl": "Wybieraj pielęgnację według celu, konsystencji i składników. Każdy krok wyjaśniamy jasno i bez przesadnych obietnic.",
        "hu": "Válasszon bőrápolási termékeket cél, textúra és összetevők szerint. Minden lépést világosan, túlzó ígéretek nélkül magyarázunk el.",
        "ro": "Alege produsele de îngrijire în funcție de obiectiv, textură și ingrediente. Fiecare pas este explicat clar, fără promisiuni exagerate."
    },
    "template.beauty-store.home.action": {
        "cs": "Najít svou rutinu",
        "sk": "Nájsť svoju rutinu",
        "en": "Find your routine",
        "de": "Die passende Routine finden",
        "es": "Encuentra tu rutina",
        "pl": "Znajdź swoją rutynę",
        "hu": "Találja meg a saját rutinját",
        "ro": "Găsește-ți rutina"
    },
    "template.beauty-store.home.storyTitle": {
        "cs": "Od ingredience k celému rituálu",
        "sk": "Od ingrediencie k celému rituálu",
        "en": "From one ingredient to a complete ritual",
        "de": "Von einem Inhaltsstoff zum vollständigen Ritual",
        "es": "De un solo ingrediente a un ritual completo",
        "pl": "Od jednego składnika do pełnego rytuału",
        "hu": "Egyetlen összetevőtől a teljes rituáléig",
        "ro": "De la un singur ingredient la un ritual complet"
    },
    "template.beauty-store.home.storyBody": {
        "cs": "Přehledné účinky, pořadí kroků a kombinace produktů pomáhají nakoupit s jistotou.",
        "sk": "Prehľadné účinky, poradie krokov a kombinácie produktov pomáhajú nakupovať s istotou.",
        "en": "Clear benefits, step order and compatible products help customers buy with confidence.",
        "de": "Klare Vorteile, die richtige Reihenfolge und aufeinander abgestimmte Produkte geben Sicherheit bei der Auswahl.",
        "es": "Unos beneficios claros, el orden de los pasos y los productos compatibles ayudan a comprar con confianza.",
        "pl": "Jasno opisane działanie, kolejność kroków i pasujące do siebie produkty pomagają kupować z pewnością.",
        "hu": "Az átlátható hatások, a lépések sorrendje és az egymással kombinálható termékek magabiztos választást tesznek lehetővé.",
        "ro": "Beneficiile explicate clar, ordinea pașilor și produsele compatibile te ajută să cumperi cu încredere."
    },
    "template.beauty-store.home.heroAlt": {
        "cs": "Minimalistická kompozice kosmetických produktů pro každodenní péči",
        "sk": "Minimalistická kompozícia kozmetických produktov na každodennú starostlivosť",
        "en": "Minimal composition of products for an everyday skincare routine",
        "de": "Minimalistische Komposition von Produkten für die tägliche Hautpflegeroutine",
        "es": "Composición minimalista de productos para una rutina diaria de cuidado facial",
        "pl": "Minimalistyczna kompozycja kosmetyków do codziennej pielęgnacji skóry",
        "hu": "Mindennapi bőrápolási rutinhoz készült termékek minimalista kompozíciója",
        "ro": "Compoziție minimalistă de produse pentru rutina zilnică de îngrijire a pielii"
    },
    "template.beauty-store.home.editorialAlt": {
        "cs": "Detail textur a ingrediencí kosmetické rutiny",
        "sk": "Detail textúr a ingrediencií kozmetickej rutiny",
        "en": "Close detail of textures and ingredients in a skincare routine",
        "de": "Nahaufnahme von Texturen und Inhaltsstoffen einer Hautpflegeroutine",
        "es": "Primer plano de las texturas y los ingredientes de una rutina de cuidado facial",
        "pl": "Zbliżenie na konsystencje i składniki codziennej pielęgnacji",
        "hu": "Bőrápolási rutin textúráinak és összetevőinek közeli részlete",
        "ro": "Prim-plan cu texturile și ingredientele unei rutine de îngrijire a pielii"
    },
    "template.beauty-store.chrome.searchPlaceholder": {
        "cs": "Hledat péči, ingredienci nebo potřebu",
        "sk": "Hľadať starostlivosť, ingredienciu alebo potrebu",
        "en": "Search by care, ingredient or concern",
        "de": "Nach Pflege, Inhaltsstoff oder Hautbedürfnis suchen",
        "es": "Buscar por tipo de cuidado, ingrediente o necesidad",
        "pl": "Szukaj według rodzaju pielęgnacji, składnika lub potrzeby",
        "hu": "Keresés ápolás, összetevő vagy bőrigény szerint",
        "ro": "Caută după tipul de îngrijire, ingredient sau nevoie"
    },
    "template.beauty-store.chrome.promoMessage": {
        "cs": "Péče o pleť podle cíle, složení a jednotlivých kroků",
        "sk": "Starostlivosť o pleť podľa cieľa, zloženia a jednotlivých krokov",
        "en": "Skincare organized by goal, ingredients and steps",
        "de": "Hautpflege nach Ziel, Inhaltsstoffen und Pflegeschritten",
        "es": "Cuidado facial organizado por objetivos, ingredientes y pasos",
        "pl": "Pielęgnacja skóry uporządkowana według celu, składników i kolejnych kroków",
        "hu": "Bőrápolás cél, összetevők és lépések szerint",
        "ro": "Îngrijirea pielii organizată după obiectiv, ingrediente și pași"
    },
    "template.beauty-store.chrome.promoTag": {
        "cs": "PRŮVODCE RUTINOU",
        "sk": "SPRIEVODCA RUTINOU",
        "en": "ROUTINE GUIDE",
        "de": "ROUTINEN-RATGEBER",
        "es": "GUÍA DE RUTINA",
        "pl": "PRZEWODNIK PO RUTYNIE",
        "hu": "RUTINÚTMUTATÓ",
        "ro": "GHID PENTRU RUTINĂ"
    },
    "template.beauty-store.chrome.productEyebrow": {
        "cs": "DOPORUČENÉ RUTINY",
        "sk": "ODPORÚČANÉ RUTINY",
        "en": "RECOMMENDED ROUTINES",
        "de": "EMPFOHLENE ROUTINEN",
        "es": "RUTINAS RECOMENDADAS",
        "pl": "POLECANE RUTYNY",
        "hu": "AJÁNLOTT RUTINOK",
        "ro": "RUTINE RECOMANDATE"
    },
    "template.beauty-store.chrome.productTitle": {
        "cs": "Péče, kterou můžete snadno kombinovat",
        "sk": "Starostlivosť, ktorú môžete jednoducho kombinovať",
        "en": "Care designed to work together",
        "de": "Pflege, die aufeinander abgestimmt ist",
        "es": "Cuidados pensados para combinarse entre sí",
        "pl": "Pielęgnacja stworzona do łączenia",
        "hu": "Egymással jól kombinálható bőrápolási termékek",
        "ro": "Produse de îngrijire create să funcționeze împreună"
    },
    "template.beauty-store.chrome.seoTitle": {
        "cs": "Péče o pleť bez zbytečného hádání",
        "sk": "Starostlivosť o pleť bez zbytočného hádania",
        "en": "Skincare without the guesswork",
        "de": "Hautpflege ohne Rätselraten",
        "es": "Cuidado facial sin dudas",
        "pl": "Pielęgnacja skóry bez zgadywania",
        "hu": "Bőrápolás találgatás nélkül",
        "ro": "Îngrijirea pielii fără presupuneri"
    },
    "template.beauty-store.chrome.seoBody": {
        "cs": "Produkty jsou uspořádané podle potřeby pleti, textury a místa v rutině.",
        "sk": "Produkty sú usporiadané podľa potrieb pleti, textúry a miesta v rutine.",
        "en": "Products are organized by skin concern, texture and place in a routine.",
        "de": "Die Produkte sind nach Hautbedürfnis, Textur und ihrer Position in der Routine geordnet.",
        "es": "Los productos se organizan según las necesidades de la piel, la textura y su lugar en la rutina.",
        "pl": "Produkty uporządkowano według potrzeb skóry, konsystencji i miejsca w rutynie.",
        "hu": "A termékeket bőrigény, textúra és a rutinban betöltött szerepük szerint rendeztük.",
        "ro": "Produsele sunt organizate după nevoile pielii, textură și locul lor în rutină."
    },
    "template.beauty-store.chrome.seoDetails": {
        "cs": "U každého kroku lze vysvětlit použití, složení i kombinace s další péčí. Zákazník tak vidí souvislosti ještě před vložením produktu do košíku.",
        "sk": "Pri každom kroku možno vysvetliť použitie, zloženie aj kombinácie s ďalšou starostlivosťou. Zákazník tak vidí súvislosti ešte pred vložením produktu do košíka.",
        "en": "Each step can explain use, ingredients and compatible care, so customers understand the complete routine before adding a product to the cart.",
        "de": "Zu jedem Schritt lassen sich Anwendung, Inhaltsstoffe und passende Pflege erklären. So verstehen Kundinnen und Kunden die gesamte Routine, bevor ein Produkt im Warenkorb landet.",
        "es": "Cada paso puede explicar el uso, los ingredientes y los cuidados compatibles, para que los clientes comprendan la rutina completa antes de añadir un producto al carrito.",
        "pl": "Przy każdym kroku można wyjaśnić sposób użycia, skład i połączenia z innymi kosmetykami. Dzięki temu klient poznaje całą rutynę jeszcze przed dodaniem produktu do koszyka.",
        "hu": "Minden lépésnél elmagyarázható a használat, az összetétel és a hozzá illő ápolás. Így a vásárlók már kosárba helyezés előtt megértik a teljes rutint.",
        "ro": "Fiecare pas poate explica utilizarea, ingredientele și produsele compatibile, astfel încât clienții să înțeleagă întreaga rutină înainte de a adăuga un produs în coș."
    },
    "template.beauty-store.chrome.newsletterBody": {
        "cs": "Nové rutiny, ingredience a praktické návody bez přehnaných slibů.",
        "sk": "Nové rutiny, ingrediencie a praktické návody bez prehnaných sľubov.",
        "en": "New routines, ingredients and practical guidance without exaggerated promises.",
        "de": "Neue Routinen, Inhaltsstoffe und praktische Anleitungen ohne übertriebene Versprechen.",
        "es": "Nuevas rutinas, ingredientes y consejos prácticos sin promesas exageradas.",
        "pl": "Nowe rutyny, składniki i praktyczne wskazówki bez przesadnych obietnic.",
        "hu": "Új rutinok, összetevők és praktikus útmutatók túlzó ígéretek nélkül.",
        "ro": "Rutine noi, ingrediente și recomandări practice, fără promisiuni exagerate."
    },
    "template.beauty-store.chrome.benefitTitle": {
        "cs": "Složení, použití a pořadí kroků na jednom místě",
        "sk": "Zloženie, použitie a poradie krokov na jednom mieste",
        "en": "Ingredients, use and step order in one place",
        "de": "Inhaltsstoffe, Anwendung und Reihenfolge an einem Ort",
        "es": "Ingredientes, uso y orden de los pasos, todo en un mismo lugar",
        "pl": "Skład, stosowanie i kolejność kroków w jednym miejscu",
        "hu": "Összetevők, használat és a lépések sorrendje egy helyen",
        "ro": "Ingrediente, utilizare și ordinea pașilor într-un singur loc"
    },
    "template.beauty-store.chrome.benefitBody": {
        "cs": "Každý produkt může ukázat, kam v rutině patří a s čím jej lze bezpečně kombinovat.",
        "sk": "Každý produkt môže ukázať, kam v rutine patrí a s čím ho možno bezpečne kombinovať.",
        "en": "Every product can show where it belongs in a routine and what it can be safely paired with.",
        "de": "Jedes Produkt zeigt, an welche Stelle der Routine es gehört und womit es sich sicher kombinieren lässt.",
        "es": "Cada producto puede mostrar qué lugar ocupa en la rutina y con qué se puede combinar de forma segura.",
        "pl": "Przy każdym produkcie widać, gdzie pasuje do rutyny i z czym można go bezpiecznie łączyć.",
        "hu": "Minden termék megmutathatja, hol a helye a rutinban, és mivel párosítható biztonságosan.",
        "ro": "Fiecare produs poate arăta unde se încadrează în rutină și cu ce poate fi combinat în siguranță."
    },
    "template.beauty-store.chrome.categoryEyebrow": {
        "cs": "PÉČE PODLE POTŘEBY",
        "sk": "STAROSTLIVOSŤ PODĽA POTREBY",
        "en": "CARE BY CONCERN",
        "de": "PFLEGE NACH HAUTBEDÜRFNIS",
        "es": "CUIDADO SEGÚN CADA NECESIDAD",
        "pl": "PIELĘGNACJA DOPASOWANA DO POTRZEB",
        "hu": "ÁPOLÁS BŐRIGÉNY SZERINT",
        "ro": "ÎNGRIJIRE DUPĂ NEVOILE PIELII"
    },
    "template.beauty-store.chrome.footerGuide": {
        "cs": "Průvodce rutinou",
        "sk": "Sprievodca rutinou",
        "en": "Routine guide",
        "de": "Routinen-Ratgeber",
        "es": "Guía de rutina",
        "pl": "Przewodnik po rutynie",
        "hu": "Útmutató a bőrápolási rutinhoz",
        "ro": "Ghid pentru rutină"
    },
    "template.fashion-store.home.eyebrow": {
        "cs": "NOVÁ EDITACE / 01",
        "sk": "NOVÝ VÝBER / 01",
        "en": "NEW EDIT / 01",
        "de": "NEUE AUSWAHL / 01",
        "es": "NUEVA SELECCIÓN / 01",
        "pl": "NOWA SELEKCJA / 01",
        "hu": "ÚJ VÁLOGATÁS / 01",
        "ro": "SELECȚIE NOUĂ / 01"
    },
    "template.fashion-store.home.title": {
        "cs": "Silné siluety. Věci, které se opravdu nosí.",
        "sk": "Výrazné siluety. Kúsky, ktoré sa naozaj nosia.",
        "en": "Strong silhouettes. Pieces made to be worn.",
        "de": "Starke Silhouetten. Teile, die wirklich getragen werden.",
        "es": "Siluetas con carácter. Prendas hechas para vestir.",
        "pl": "Wyraziste sylwetki. Ubrania stworzone do noszenia.",
        "hu": "Karakteres sziluettek. Viselésre tervezett darabok.",
        "ro": "Siluete puternice. Piese create pentru a fi purtate."
    },
    "template.fashion-store.home.body": {
        "cs": "Kolekce sestavená podle střihu, materiálu a způsobu kombinování — od prvního pohledu až po správnou velikost.",
        "sk": "Kolekcia zostavená podľa strihu, materiálu a spôsobu kombinovania — od prvého pohľadu až po správnu veľkosť.",
        "en": "A collection arranged by fit, fabric and styling, from the first look to the right size.",
        "de": "Eine Kollektion nach Passform, Material und Styling – vom ersten Eindruck bis zur richtigen Größe.",
        "es": "Una colección organizada por corte, tejido y estilo, desde el primer vistazo hasta la talla adecuada.",
        "pl": "Kolekcja uporządkowana według kroju, tkaniny i sposobu stylizacji — od pierwszego spojrzenia aż po właściwy rozmiar.",
        "hu": "Szabás, anyag és styling szerint rendezett kollekció – az első benyomástól a megfelelő méretig.",
        "ro": "O colecție organizată după croială, material și stil, de la prima impresie până la mărimea potrivită."
    },
    "template.fashion-store.home.action": {
        "cs": "Prohlédnout nový drop",
        "sk": "Pozrieť si nový drop",
        "en": "Explore the new drop",
        "de": "Den neuen Drop entdecken",
        "es": "Descubre la nueva colección",
        "pl": "Zobacz najnowszy drop",
        "hu": "Fedezze fel az új dropot",
        "ro": "Descoperă noua colecție"
    },
    "template.fashion-store.home.storyTitle": {
        "cs": "Jeden šatník, více způsobů nošení",
        "sk": "Jeden šatník, viac spôsobov nosenia",
        "en": "One wardrobe, more ways to wear it",
        "de": "Eine Garderobe, viele Styling-Möglichkeiten",
        "es": "Un armario, más formas de llevarlo",
        "pl": "Jedna garderoba, więcej sposobów noszenia",
        "hu": "Egy ruhatár, még több viselési lehetőség",
        "ro": "O garderobă, mai multe feluri de a o purta"
    },
    "template.fashion-store.home.storyBody": {
        "cs": "Lookbook, kompletní outfity a informace o fitu propojují inspiraci s rychlým nákupem.",
        "sk": "Lookbooky, kompletné outfity a informácie o strihu prepájajú inšpiráciu s rýchlym nákupom.",
        "en": "Lookbooks, complete outfits and fit information connect inspiration with a quick purchase.",
        "de": "Lookbooks, komplette Outfits und Passformangaben verbinden Inspiration mit einem schnellen Einkauf.",
        "es": "Los lookbooks, los conjuntos completos y la información sobre el corte conectan la inspiración con una compra rápida.",
        "pl": "Lookbooki, kompletne stylizacje i informacje o kroju łączą inspirację z szybkim zakupem.",
        "hu": "A lookbookok, a teljes szettek és a szabásinformációk az inspirációt gyors vásárlással kapcsolják össze.",
        "ro": "Lookbookurile, ținutele complete și informațiile despre croială leagă inspirația de o achiziție rapidă."
    },
    "template.fashion-store.home.heroAlt": {
        "cs": "Současná módní editorial fotografie nové kolekce",
        "sk": "Módny editoriál k novej kolekcii",
        "en": "Contemporary fashion editorial for a new collection",
        "de": "Zeitgenössisches Fashion-Editorial für eine neue Kollektion",
        "es": "Editorial de moda contemporánea para una nueva colección",
        "pl": "Współczesny edytorial modowy prezentujący nową kolekcję",
        "hu": "Kortárs divatfotó az új kollekcióhoz",
        "ro": "Editorial de modă contemporană pentru o colecție nouă"
    },
    "template.fashion-store.home.editorialAlt": {
        "cs": "Detail materiálu a vrstveného módního outfitu",
        "sk": "Detail materiálu a vrstveného módneho outfitu",
        "en": "Detail of fabric and a layered fashion outfit",
        "de": "Detailaufnahme eines Materials und eines mehrlagigen Outfits",
        "es": "Detalle del tejido y de un conjunto de moda por capas",
        "pl": "Zbliżenie na tkaninę i warstwową stylizację",
        "hu": "Anyagrészlet és réteges divatösszeállítás",
        "ro": "Detaliu de material și ținută în straturi"
    },
    "template.fashion-store.chrome.searchPlaceholder": {
        "cs": "Hledat produkt, střih nebo kategorii",
        "sk": "Hľadať produkt, strih alebo kategóriu",
        "en": "Search by product, fit or category",
        "de": "Nach Produkt, Passform oder Kategorie suchen",
        "es": "Buscar por producto, corte o categoría",
        "pl": "Szukaj według produktu, kroju lub kategorii",
        "hu": "Keresés termék, szabás vagy kategória szerint",
        "ro": "Caută după produs, croială sau categorie"
    },
    "template.fashion-store.chrome.promoMessage": {
        "cs": "Nový edit sestavený podle střihu, materiálu a způsobu nošení",
        "sk": "Nový výber zostavený podľa strihu, materiálu a spôsobu nosenia",
        "en": "A new edit organized by fit, fabric and styling",
        "de": "Eine neue Auswahl nach Passform, Material und Styling",
        "es": "Una nueva selección organizada por corte, tejido y estilo",
        "pl": "Nowa selekcja według kroju, tkaniny i sposobu stylizacji",
        "hu": "Új válogatás szabás, anyag és styling szerint",
        "ro": "O selecție nouă organizată după croială, material și stil"
    },
    "template.fashion-store.chrome.promoTag": {
        "cs": "NOVÝ EDIT",
        "sk": "NOVÝ VÝBER",
        "en": "NEW EDIT",
        "de": "NEUE AUSWAHL",
        "es": "NUEVA SELECCIÓN",
        "pl": "NOWA SELEKCJA",
        "hu": "ÚJ VÁLOGATÁS",
        "ro": "SELECȚIE NOUĂ"
    },
    "template.fashion-store.chrome.productEyebrow": {
        "cs": "PRÁVĚ V EDITU",
        "sk": "PRÁVE VO VÝBERE",
        "en": "IN THE EDIT",
        "de": "IN DER AKTUELLEN AUSWAHL",
        "es": "EN LA SELECCIÓN",
        "pl": "W TEJ SELEKCJI",
        "hu": "A VÁLOGATÁSBAN",
        "ro": "ÎN SELECȚIE"
    },
    "template.fashion-store.chrome.productTitle": {
        "cs": "Kusy pro nové kombinace",
        "sk": "Kúsky pre nové kombinácie",
        "en": "Pieces for new combinations",
        "de": "Teile für neue Kombinationen",
        "es": "Prendas para crear nuevas combinaciones",
        "pl": "Ubrania do nowych stylizacji",
        "hu": "Darabok új összeállításokhoz",
        "ro": "Piese pentru combinații noi"
    },
    "template.fashion-store.chrome.seoTitle": {
        "cs": "Móda uspořádaná podle toho, jak se nosí",
        "sk": "Móda usporiadaná podľa toho, ako sa nosí",
        "en": "Fashion organized around how it is worn",
        "de": "Mode danach geordnet, wie sie getragen wird",
        "es": "Moda organizada según cómo se lleva",
        "pl": "Moda uporządkowana według sposobu noszenia",
        "hu": "A divat aszerint rendezve, ahogyan viseljük",
        "ro": "Moda, organizată după felul în care o porți"
    },
    "template.fashion-store.chrome.seoBody": {
        "cs": "Střih, materiál a informace o velikosti doprovázejí každý produkt od prvního pohledu.",
        "sk": "Strih, materiál a informácie o veľkosti sprevádzajú každý produkt od prvého pohľadu.",
        "en": "Fit, fabric and sizing information stay with each product from the first look.",
        "de": "Passform, Material und Größenangaben begleiten jedes Produkt vom ersten Blick an.",
        "es": "La información sobre el corte, el tejido y las tallas acompaña a cada producto desde el primer vistazo.",
        "pl": "Informacje o kroju, tkaninie i rozmiarze towarzyszą każdemu produktowi od pierwszego spojrzenia.",
        "hu": "A szabásra, az anyagra és a méretre vonatkozó információk az első pillanattól minden terméket elkísérnek.",
        "ro": "Informațiile despre croială, material și mărime însoțesc fiecare produs încă de la prima vedere."
    },
    "template.fashion-store.chrome.seoDetails": {
        "cs": "Kolekce, lookbooky a související produkty propojují inspiraci s konkrétními variantami. Zákazník se může rozhodnout podle siluety i praktických detailů.",
        "sk": "Kolekcie, lookbooky a súvisiace produkty prepájajú inšpiráciu s konkrétnymi variantmi. Zákazník sa môže rozhodnúť podľa siluety aj praktických detailov.",
        "en": "Collections, lookbooks and related products connect inspiration with specific variants, making both silhouette and practical details easy to compare.",
        "de": "Kollektionen, Lookbooks und passende Produkte verbinden Inspiration mit konkreten Varianten. So lassen sich Silhouette und praktische Details leicht vergleichen.",
        "es": "Las colecciones, los lookbooks y los productos relacionados conectan la inspiración con variantes concretas, para que resulte fácil comparar tanto la silueta como los detalles prácticos.",
        "pl": "Kolekcje, lookbooki i powiązane produkty łączą inspirację z konkretnymi wariantami, ułatwiając porównanie zarówno sylwetki, jak i praktycznych detali.",
        "hu": "A kollekciók, lookbookok és kapcsolódó termékek konkrét változatokkal kötik össze az inspirációt. Így a sziluett és a praktikus részletek egyaránt könnyen összehasonlíthatók.",
        "ro": "Colecțiile, lookbookurile și produsele asociate leagă inspirația de variante concrete, astfel încât silueta și detaliile practice să fie ușor de comparat."
    },
    "template.fashion-store.chrome.newsletterBody": {
        "cs": "Nové dropy, stylingové editace a informace o materiálech.",
        "sk": "Nové dropy, stylingové výbery a informácie o materiáloch.",
        "en": "New drops, styling edits and material notes.",
        "de": "Neue Drops, Styling-Auswahlen und Wissenswertes zu Materialien.",
        "es": "Nuevos lanzamientos, selecciones de estilo y notas sobre materiales.",
        "pl": "Nowe dropy, selekcje stylizacji i informacje o materiałach.",
        "hu": "Új dropok, stylingválogatások és anyaginformációk.",
        "ro": "Lansări noi, selecții de stil și detalii despre materiale."
    },
    "template.fashion-store.chrome.benefitTitle": {
        "cs": "Střih, materiál a velikost bez hledání v poznámkách",
        "sk": "Strih, materiál a veľkosť bez hľadania v poznámkach",
        "en": "Fit, fabric and size without digging through notes",
        "de": "Passform, Material und Größe auf einen Blick",
        "es": "Corte, tejido y talla sin rebuscar entre notas",
        "pl": "Krój, tkanina i rozmiar bez szukania w przypisach",
        "hu": "Szabás, anyag és méret hosszas keresés nélkül",
        "ro": "Croială, material și mărime, fără să cauți prin notițe"
    },
    "template.fashion-store.chrome.benefitBody": {
        "cs": "Varianty a doporučení ke kombinování jsou vidět tam, kde pomáhají při rozhodování.",
        "sk": "Varianty a odporúčania na kombinovanie sú viditeľné tam, kde pomáhajú pri rozhodovaní.",
        "en": "Variants and styling guidance appear where they help with the decision.",
        "de": "Varianten und Styling-Empfehlungen erscheinen genau dort, wo sie die Entscheidung erleichtern.",
        "es": "Las variantes y las recomendaciones de estilo aparecen justo donde ayudan a decidir.",
        "pl": "Warianty i wskazówki dotyczące stylizacji pojawiają się tam, gdzie pomagają podjąć decyzję.",
        "hu": "A változatok és stylingajánlások ott jelennek meg, ahol valóban segítik a döntést.",
        "ro": "Variantele și recomandările de asortare apar exact acolo unde te ajută să decizi."
    },
    "template.fashion-store.chrome.categoryEyebrow": {
        "cs": "VÝBĚR PODLE STYLU",
        "sk": "VÝBER PODĽA ŠTÝLU",
        "en": "SHOP BY STYLE",
        "de": "NACH STIL EINKAUFEN",
        "es": "COMPRAR POR ESTILO",
        "pl": "WYBIERAJ WEDŁUG STYLU",
        "hu": "VÁLASSZON STÍLUS SZERINT",
        "ro": "CUMPĂRĂ DUPĂ STIL"
    },
    "template.fashion-store.chrome.footerGuide": {
        "cs": "Velikosti a střihy",
        "sk": "Veľkosti a strihy",
        "en": "Sizes and fits",
        "de": "Größen und Passformen",
        "es": "Guía de tallas y cortes",
        "pl": "Rozmiary i kroje",
        "hu": "Méretek és szabások",
        "ro": "Mărimi și croieli"
    },
    "template.jewelry-store.home.eyebrow": {
        "cs": "SIGNATURE COLLECTION",
        "sk": "SIGNATURE COLLECTION",
        "en": "SIGNATURE COLLECTION",
        "de": "SIGNATURE COLLECTION",
        "es": "SIGNATURE COLLECTION",
        "pl": "SIGNATURE COLLECTION",
        "hu": "SIGNATURE COLLECTION",
        "ro": "SIGNATURE COLLECTION"
    },
    "template.jewelry-store.home.title": {
        "cs": "Šperk jako osobní gesto.",
        "sk": "Šperk ako osobné gesto.",
        "en": "Jewelry as a personal gesture.",
        "de": "Schmuck als persönliche Geste.",
        "es": "La joyería como gesto personal.",
        "pl": "Biżuteria jako osobisty gest.",
        "hu": "Az ékszer mint személyes gesztus.",
        "ro": "O bijuterie ca gest personal."
    },
    "template.jewelry-store.home.body": {
        "cs": "Čistá prezentace materiálu, rozměrů a řemesla dává každému kusu prostor — a zákazníkovi jistotu při výběru.",
        "sk": "Čistá prezentácia materiálu, rozmerov a remeselného spracovania dáva každému kúsku priestor — a zákazníkovi istotu pri výbere.",
        "en": "A clear presentation of material, dimensions and craft gives each piece room and makes selection easier.",
        "de": "Eine klare Präsentation von Material, Maßen und Handwerk gibt jedem Stück Raum und erleichtert die Auswahl.",
        "es": "Una presentación clara de los materiales, las dimensiones y la artesanía da espacio a cada pieza y facilita la elección.",
        "pl": "Przejrzysta prezentacja materiału, wymiarów i rzemiosła daje każdemu modelowi przestrzeń i ułatwia wybór.",
        "hu": "Az anyag, a méretek és a kézműves munka letisztult bemutatása minden darabnak teret ad, és megkönnyíti a választást.",
        "ro": "Prezentarea clară a materialului, dimensiunilor și măiestriei oferă fiecărei piese spațiul meritat și face alegerea mai ușoară."
    },
    "template.jewelry-store.home.action": {
        "cs": "Objevit kolekci",
        "sk": "Objaviť kolekciu",
        "en": "Discover the collection",
        "de": "Kollektion entdecken",
        "es": "Descubre la colección",
        "pl": "Odkryj kolekcję",
        "hu": "Fedezze fel a kollekciót",
        "ro": "Descoperă colecția"
    },
    "template.jewelry-store.home.storyTitle": {
        "cs": "Detail, původ a péče",
        "sk": "Detail, pôvod a starostlivosť",
        "en": "Detail, origin and care",
        "de": "Detail, Herkunft und Pflege",
        "es": "Detalle, origen y cuidado",
        "pl": "Detal, pochodzenie i pielęgnacja",
        "hu": "Részletek, eredet és ápolás",
        "ro": "Detaliu, origine și îngrijire"
    },
    "template.jewelry-store.home.storyBody": {
        "cs": "Příběh výroby, průvodce velikostí a osobní konzultace tvoří přirozenou součást nákupu.",
        "sk": "Príbeh výroby, sprievodca veľkosťami a osobná konzultácia tvoria prirodzenú súčasť nákupu.",
        "en": "The making process, sizing guide and personal consultation are a natural part of the purchase.",
        "de": "Herstellungsprozess, Größenberatung und persönliche Beratung gehören selbstverständlich zum Kauf.",
        "es": "El proceso de creación, la guía de tallas y el asesoramiento personal forman parte natural de la compra.",
        "pl": "Proces powstawania, przewodnik po rozmiarach i osobista konsultacja są naturalną częścią zakupu.",
        "hu": "Az elkészítés folyamata, a méretútmutató és a személyes tanácsadás a vásárlás természetes része.",
        "ro": "Procesul de realizare, ghidul de mărimi și consultanța personală devin o parte firească a achiziției."
    },
    "template.jewelry-store.home.heroAlt": {
        "cs": "Makro detail ručně zpracovaného šperku na tmavém podkladu",
        "sk": "Makrodetail ručne spracovaného šperku na tmavom pozadí",
        "en": "Macro detail of a handcrafted jewel on a dark background",
        "de": "Makroaufnahme eines handgefertigten Schmuckstücks vor dunklem Hintergrund",
        "es": "Macrodetalle de una joya artesanal sobre un fondo oscuro",
        "pl": "Makrodetal ręcznie wykonanego klejnotu na ciemnym tle",
        "hu": "Kézzel készített ékszer makrófelvétele sötét háttér előtt",
        "ro": "Detaliu macro al unei bijuterii lucrate manual, pe fundal întunecat"
    },
    "template.jewelry-store.home.editorialAlt": {
        "cs": "Šperkař při přesné ruční práci v ateliéru",
        "sk": "Šperkár pri precíznej ručnej práci v ateliéri",
        "en": "Jeweler doing precise handwork in a quiet studio",
        "de": "Goldschmied bei präziser Handarbeit in einem ruhigen Atelier",
        "es": "Joyero realizando un trabajo manual de precisión en un taller tranquilo",
        "pl": "Jubiler podczas precyzyjnej pracy ręcznej w spokojnej pracowni",
        "hu": "Ékszerész precíz kézi munkát végez egy csendes műhelyben",
        "ro": "Bijutier realizând o lucrare manuală de precizie într-un atelier liniștit"
    },
    "template.jewelry-store.chrome.searchPlaceholder": {
        "cs": "Hledat šperk, materiál nebo kolekci",
        "sk": "Hľadať šperk, materiál alebo kolekciu",
        "en": "Search by jewel, material or collection",
        "de": "Nach Schmuckstück, Material oder Kollektion suchen",
        "es": "Buscar por joya, material o colección",
        "pl": "Szukaj według rodzaju biżuterii, materiału lub kolekcji",
        "hu": "Keresés ékszer, anyag vagy kollekció szerint",
        "ro": "Caută după bijuterie, material sau colecție"
    },
    "template.jewelry-store.chrome.promoMessage": {
        "cs": "Šperky podle materiálu, významu a příležitosti",
        "sk": "Šperky podľa materiálu, významu a príležitosti",
        "en": "Jewelry organized by material, meaning and occasion",
        "de": "Schmuck nach Material, Bedeutung und Anlass",
        "es": "Joyas organizadas por material, significado y ocasión",
        "pl": "Biżuteria uporządkowana według materiału, znaczenia i okazji",
        "hu": "Ékszerek anyag, jelentés és alkalom szerint",
        "ro": "Bijuterii organizate după material, semnificație și ocazie"
    },
    "template.jewelry-store.chrome.promoTag": {
        "cs": "OSOBNÍ VÝBĚR",
        "sk": "OSOBNÝ VÝBER",
        "en": "PERSONAL EDIT",
        "de": "PERSÖNLICHE AUSWAHL",
        "es": "SELECCIÓN PERSONAL",
        "pl": "OSOBISTA SELEKCJA",
        "hu": "SZEMÉLYES VÁLOGATÁS",
        "ro": "SELECȚIE PERSONALĂ"
    },
    "template.jewelry-store.chrome.productEyebrow": {
        "cs": "SIGNATURE VÝBĚR",
        "sk": "SIGNATURE VÝBER",
        "en": "SIGNATURE EDIT",
        "de": "SIGNATURE-AUSWAHL",
        "es": "SELECCIÓN DE AUTOR",
        "pl": "KOLEKCJA SIGNATURE",
        "hu": "SIGNATURE VÁLOGATÁS",
        "ro": "SELECȚIE DE AUTOR"
    },
    "template.jewelry-store.chrome.productTitle": {
        "cs": "Kusy s prostorem pro detail",
        "sk": "Kúsky s priestorom pre detail",
        "en": "Pieces with room for detail",
        "de": "Stücke mit Raum für Details",
        "es": "Piezas donde cada detalle tiene su espacio",
        "pl": "Modele, w których detal gra główną rolę",
        "hu": "Darabok, amelyek teret adnak a részleteknek",
        "ro": "Piese în care fiecare detaliu are spațiu"
    },
    "template.jewelry-store.chrome.seoTitle": {
        "cs": "Materiál, rozměr a řemeslo v hlavní roli",
        "sk": "Materiál, rozmery a remeslo v hlavnej úlohe",
        "en": "Material, dimensions and craft come first",
        "de": "Material, Maße und Handwerk im Mittelpunkt",
        "es": "Materiales, dimensiones y artesanía en primer plano",
        "pl": "Materiał, wymiary i rzemiosło na pierwszym miejscu",
        "hu": "Anyag, méretek és kézműves munka az első helyen",
        "ro": "Materialul, dimensiunile și măiestria pe primul loc"
    },
    "template.jewelry-store.chrome.seoBody": {
        "cs": "Každý šperk lze představit přesnými parametry, původem i způsobem péče.",
        "sk": "Každý šperk možno predstaviť presnými parametrami, pôvodom aj spôsobom starostlivosti.",
        "en": "Every piece can be presented through exact specifications, origin and care.",
        "de": "Jedes Stück lässt sich mit genauen Angaben, seiner Herkunft und Pflegehinweisen präsentieren.",
        "es": "Cada pieza puede presentarse con sus especificaciones exactas, su origen y sus cuidados.",
        "pl": "Każdy model można przedstawić poprzez dokładne parametry, pochodzenie i sposób pielęgnacji.",
        "hu": "Minden darab pontos adatokkal, származásával és ápolási útmutatójával mutatható be.",
        "ro": "Fiecare piesă poate fi prezentată prin specificații exacte, origine și recomandări de îngrijire."
    },
    "template.jewelry-store.chrome.seoDetails": {
        "cs": "Detailní fotografie, průvodce velikostí a informace o výrobě pomáhají vybrat šperk pro sebe i jako dárek. Osobní konzultace zůstává snadno dostupná.",
        "sk": "Detailné fotografie, sprievodca veľkosťami a informácie o výrobe pomáhajú vybrať šperk pre seba aj ako darček. Osobná konzultácia zostáva ľahko dostupná.",
        "en": "Detailed photography, sizing guidance and making notes support both personal and gift purchases, with consultation kept close at hand.",
        "de": "Detailaufnahmen, Größenberatung und Informationen zur Herstellung helfen bei der Wahl für sich selbst oder als Geschenk. Eine persönliche Beratung bleibt jederzeit leicht erreichbar.",
        "es": "Las fotografías detalladas, la guía de tallas y las notas sobre el proceso de elaboración facilitan tanto las compras personales como los regalos, con el asesoramiento siempre a mano.",
        "pl": "Szczegółowe zdjęcia, przewodnik po rozmiarach i informacje o wykonaniu pomagają wybrać biżuterię dla siebie lub na prezent, a konsultacja pozostaje zawsze pod ręką.",
        "hu": "A részletgazdag fotók, a méretútmutató és az elkészítésről szóló információk akkor is segítik a választást, ha magának, és akkor is, ha ajándékba vásárol. A személyes tanácsadás pedig mindig könnyen elérhető.",
        "ro": "Fotografiile detaliate, ghidul de mărimi și informațiile despre realizare susțin atât alegerile personale, cât și cadourile, iar consultanța rămâne mereu la îndemână."
    },
    "template.jewelry-store.chrome.newsletterBody": {
        "cs": "Nové malé série, příběhy materiálů a tipy pro výběr dárku.",
        "sk": "Nové malé série, príbehy materiálov a tipy na výber darčeka.",
        "en": "New small runs, material stories and guidance for choosing a gift.",
        "de": "Neue Kleinserien, Geschichten zu Materialien und Tipps für die Geschenkauswahl.",
        "es": "Nuevas series limitadas, historias sobre los materiales y consejos para elegir un regalo.",
        "pl": "Nowe krótkie serie, historie materiałów i wskazówki dotyczące wyboru prezentu.",
        "hu": "Új kis szériák, anyagtörténetek és tippek az ajándékválasztáshoz.",
        "ro": "Noi serii mici, povești despre materiale și recomandări pentru alegerea unui cadou."
    },
    "template.jewelry-store.chrome.benefitTitle": {
        "cs": "Původ a péče jako součást každého kusu",
        "sk": "Pôvod a starostlivosť ako súčasť každého kúsku",
        "en": "Origin and care as part of every piece",
        "de": "Herkunft und Pflege gehören zu jedem Stück",
        "es": "Origen y cuidados como parte de cada pieza",
        "pl": "Pochodzenie i pielęgnacja jako część każdego modelu",
        "hu": "Származás és ápolás minden darab részeként",
        "ro": "Originea și îngrijirea, parte din fiecare piesă"
    },
    "template.jewelry-store.chrome.benefitBody": {
        "cs": "Rozměry, materiál a doporučená péče dávají rozhodnutí jasný základ.",
        "sk": "Rozmery, materiál a odporúčaná starostlivosť dávajú rozhodnutiu jasný základ.",
        "en": "Dimensions, material and care instructions give each decision a clear basis.",
        "de": "Maße, Material und Pflegehinweise schaffen eine klare Entscheidungsgrundlage.",
        "es": "Las dimensiones, el material y las instrucciones de cuidado dan una base clara a cada decisión.",
        "pl": "Wymiary, materiał i zalecenia dotyczące pielęgnacji dają każdej decyzji solidną podstawę.",
        "hu": "A méretek, az anyag és az ápolási útmutató világos alapot ad a döntéshez.",
        "ro": "Dimensiunile, materialul și instrucțiunile de îngrijire oferă o bază clară fiecărei decizii."
    },
    "template.jewelry-store.chrome.categoryEyebrow": {
        "cs": "PODLE MATERIÁLU A PŘÍLEŽITOSTI",
        "sk": "PODĽA MATERIÁLU A PRÍLEŽITOSTI",
        "en": "BY MATERIAL AND OCCASION",
        "de": "NACH MATERIAL UND ANLASS",
        "es": "POR MATERIAL Y OCASIÓN",
        "pl": "WEDŁUG MATERIAŁU I OKAZJI",
        "hu": "ANYAG ÉS ALKALOM SZERINT",
        "ro": "DUPĂ MATERIAL ȘI OCAZIE"
    },
    "template.jewelry-store.chrome.footerGuide": {
        "cs": "Průvodce velikostmi šperků",
        "sk": "Sprievodca veľkosťami šperkov",
        "en": "Jewelry sizing guide",
        "de": "Größenratgeber für Schmuck",
        "es": "Guía de tallas para joyas",
        "pl": "Przewodnik po rozmiarach biżuterii",
        "hu": "Ékszerméretezési útmutató",
        "ro": "Ghid de mărimi pentru bijuterii"
    },
    "template.furniture-store.home.eyebrow": {
        "cs": "MÍSTNOST / MATERIÁL / FUNKCE",
        "sk": "MIESTNOSŤ / MATERIÁL / FUNKCIA",
        "en": "ROOM / MATERIAL / FUNCTION",
        "de": "RAUM / MATERIAL / FUNKTION",
        "es": "ESTANCIA / MATERIAL / FUNCIÓN",
        "pl": "WNĘTRZE / MATERIAŁ / FUNKCJA",
        "hu": "SZOBA / ANYAG / FUNKCIÓ",
        "ro": "CAMERĂ / MATERIAL / FUNCȚIE"
    },
    "template.furniture-store.home.title": {
        "cs": "Nábytek, který drží prostor pohromadě.",
        "sk": "Nábytok, ktorý drží priestor pokope.",
        "en": "Furniture that holds a room together.",
        "de": "Möbel, die einen Raum als Ganzes wirken lassen.",
        "es": "Muebles que dan unidad a cada espacio.",
        "pl": "Meble, które spajają całe wnętrze.",
        "hu": "Bútorok, amelyek egységbe rendezik a teret.",
        "ro": "Mobilier care dă coerență spațiului."
    },
    "template.furniture-store.home.body": {
        "cs": "Vybírejte podle místnosti, rozměru a materiálu. Dostupnost, doprava i montáž jsou vidět dřív, než se rozhodnete.",
        "sk": "Vyberajte podľa miestnosti, rozmerov a materiálu. Dostupnosť, dopravu aj montáž uvidíte skôr, než sa rozhodnete.",
        "en": "Shop by room, dimensions and material. Availability, delivery and assembly are visible before you decide.",
        "de": "Wählen Sie nach Raum, Maßen und Material. Verfügbarkeit, Lieferung und Montage sind sichtbar, bevor Sie sich entscheiden.",
        "es": "Compra por estancia, dimensiones y material. Consulta la disponibilidad, la entrega y el montaje antes de decidirte.",
        "pl": "Wybieraj według pomieszczenia, wymiarów i materiału. Dostępność, dostawa i montaż są widoczne, zanim podejmiesz decyzję.",
        "hu": "Válasszon helyiség, méret és anyag szerint. Az elérhetőség, a szállítás és az összeszerelés már a döntés előtt látható.",
        "ro": "Alege după cameră, dimensiuni și material. Disponibilitatea, livrarea și montajul sunt vizibile înainte să te decizi."
    },
    "template.furniture-store.home.action": {
        "cs": "Zařídit místnost",
        "sk": "Zariadiť miestnosť",
        "en": "Furnish a room",
        "de": "Einen Raum einrichten",
        "es": "Amuebla una estancia",
        "pl": "Urządź wnętrze",
        "hu": "Rendezzen be egy helyiséget",
        "ro": "Amenajează o cameră"
    },
    "template.furniture-store.home.storyTitle": {
        "cs": "Celá místnost, ne jen jeden kus",
        "sk": "Celá miestnosť, nielen jeden kus",
        "en": "A complete room, not just one piece",
        "de": "Ein kompletter Raum, nicht nur ein Möbelstück",
        "es": "Una estancia completa, no solo una pieza",
        "pl": "Całe wnętrze, nie tylko jeden mebel",
        "hu": "Egy teljes helyiség, nem csupán egyetlen darab",
        "ro": "O cameră completă, nu doar o singură piesă"
    },
    "template.furniture-store.home.storyBody": {
        "cs": "Scény, kompatibilní produkty a přesné rozměry pomáhají navrhnout promyšlený celek.",
        "sk": "Interiérové scény, kompatibilné produkty a presné rozmery pomáhajú navrhnúť premyslený celok.",
        "en": "Room scenes, compatible products and precise dimensions help shape a considered whole.",
        "de": "Raumszenen, passende Produkte und präzise Maße helfen dabei, ein stimmiges Ganzes zu gestalten.",
        "es": "Los ambientes, los productos compatibles y las medidas precisas ayudan a crear un conjunto bien pensado.",
        "pl": "Aranżacje pomieszczeń, pasujące produkty i dokładne wymiary pomagają stworzyć przemyślaną całość.",
        "hu": "A berendezett enteriőrök, az egymáshoz illő termékek és a pontos méretek segítenek átgondolt egészet kialakítani.",
        "ro": "Imaginile de ambient, produsele compatibile și dimensiunile exacte ajută la conturarea unui ansamblu bine gândit."
    },
    "template.furniture-store.home.heroAlt": {
        "cs": "Vzdušný moderní interiér s nadčasovým nábytkem",
        "sk": "Vzdušný moderný interiér s nadčasovým nábytkom",
        "en": "Airy modern interior furnished with timeless pieces",
        "de": "Helles modernes Interieur mit zeitlosen Möbeln",
        "es": "Interior moderno y luminoso amueblado con piezas atemporales",
        "pl": "Przestronne nowoczesne wnętrze urządzone ponadczasowymi meblami",
        "hu": "Világos, modern enteriőr időtálló bútordarabokkal",
        "ro": "Interior modern și aerisit, amenajat cu piese atemporale"
    },
    "template.furniture-store.home.editorialAlt": {
        "cs": "Detail přírodního materiálu a řemeslného spoje nábytku",
        "sk": "Detail prírodného materiálu a remeselného spoja nábytku",
        "en": "Close detail of natural material and a crafted furniture joint",
        "de": "Nahaufnahme eines natürlichen Materials und einer handwerklichen Möbelverbindung",
        "es": "Primer plano de un material natural y una unión artesanal de mobiliario",
        "pl": "Zbliżenie na naturalny materiał i rzemieślnicze połączenie meblowe",
        "hu": "Természetes anyag és kézműves bútorillesztés közelképe",
        "ro": "Prim-plan cu un material natural și o îmbinare de mobilier realizată artizanal"
    },
    "template.furniture-store.chrome.searchPlaceholder": {
        "cs": "Hledat nábytek, místnost nebo materiál",
        "sk": "Hľadať nábytok, miestnosť alebo materiál",
        "en": "Search by furniture, room or material",
        "de": "Nach Möbel, Raum oder Material suchen",
        "es": "Buscar por mueble, estancia o material",
        "pl": "Szukaj według mebla, pomieszczenia lub materiału",
        "hu": "Keresés bútor, helyiség vagy anyag szerint",
        "ro": "Caută după mobilier, cameră sau material"
    },
    "template.furniture-store.chrome.promoMessage": {
        "cs": "Nábytek podle místnosti, rozměru a skutečné funkce",
        "sk": "Nábytok podľa miestnosti, rozmerov a skutočnej funkcie",
        "en": "Furniture organized by room, dimensions and function",
        "de": "Möbel nach Raum, Maßen und Funktion",
        "es": "Muebles organizados por estancia, dimensiones y función",
        "pl": "Meble uporządkowane według pomieszczenia, wymiarów i funkcji",
        "hu": "Bútorok helyiség, méret és funkció szerint",
        "ro": "Mobilier organizat după cameră, dimensiuni și funcție"
    },
    "template.furniture-store.chrome.promoTag": {
        "cs": "PLÁNOVAČ PROSTORU",
        "sk": "PLÁNOVAČ PRIESTORU",
        "en": "ROOM PLANNER",
        "de": "RAUMPLANER",
        "es": "PLANIFICADOR DE ESPACIOS",
        "pl": "PLANER WNĘTRZA",
        "hu": "TÉRTERVEZŐ",
        "ro": "PLANIFICATOR DE SPAȚIU"
    },
    "template.furniture-store.chrome.productEyebrow": {
        "cs": "PRO CELÝ PROSTOR",
        "sk": "PRE CELÝ PRIESTOR",
        "en": "FOR THE WHOLE ROOM",
        "de": "FÜR DEN GANZEN RAUM",
        "es": "PARA TODA LA ESTANCIA",
        "pl": "DO CAŁEGO WNĘTRZA",
        "hu": "AZ EGÉSZ HELYISÉGHEZ",
        "ro": "PENTRU ÎNTREAGA CAMERĂ"
    },
    "template.furniture-store.chrome.productTitle": {
        "cs": "Kusy, které spolu fungují",
        "sk": "Kúsky, ktoré spolu fungujú",
        "en": "Pieces designed to work together",
        "de": "Möbel, die füreinander gemacht sind",
        "es": "Piezas diseñadas para combinar entre sí",
        "pl": "Meble zaprojektowane tak, by do siebie pasowały",
        "hu": "Egymáshoz tervezett darabok",
        "ro": "Piese create să funcționeze împreună"
    },
    "template.furniture-store.chrome.seoTitle": {
        "cs": "Od rozměru místnosti k promyšlenému celku",
        "sk": "Od rozmerov miestnosti k premyslenému celku",
        "en": "From room dimensions to a considered whole",
        "de": "Von den Raummaßen zum durchdachten Gesamtbild",
        "es": "De las dimensiones de la estancia a un conjunto bien pensado",
        "pl": "Od wymiarów pomieszczenia do przemyślanej całości",
        "hu": "A helyiség méreteitől az átgondolt egészig",
        "ro": "De la dimensiunile camerei la un ansamblu bine gândit"
    },
    "template.furniture-store.chrome.seoBody": {
        "cs": "Rozměry, materiály, dostupnost a služby jsou součástí výběru od začátku.",
        "sk": "Rozmery, materiály, dostupnosť a služby sú súčasťou výberu od začiatku.",
        "en": "Dimensions, materials, availability and services are part of the selection from the start.",
        "de": "Maße, Materialien, Verfügbarkeit und Services gehören von Anfang an zur Auswahl.",
        "es": "Las dimensiones, los materiales, la disponibilidad y los servicios forman parte de la selección desde el principio.",
        "pl": "Wymiary, materiały, dostępność i usługi są częścią wyboru od samego początku.",
        "hu": "A méretek, az anyagok, az elérhetőség és a szolgáltatások már a kezdetektől a választás részét képezik.",
        "ro": "Dimensiunile, materialele, disponibilitatea și serviciile fac parte din selecție încă de la început."
    },
    "template.furniture-store.chrome.seoDetails": {
        "cs": "Interiérové scény ukazují měřítko a vzájemné kombinace, zatímco technické údaje pomáhají ověřit konkrétní prostor. Dopravu a montáž lze vysvětlit přímo u produktu.",
        "sk": "Interiérové scény ukazujú mierku a vzájomné kombinácie, zatiaľ čo technické údaje pomáhajú overiť konkrétny priestor. Dopravu a montáž možno vysvetliť priamo pri produkte.",
        "en": "Interior scenes show scale and combinations while specifications help verify the actual space. Delivery and assembly details can stay directly with the product.",
        "de": "Interieurszenen zeigen Proportionen und Kombinationen, technische Angaben helfen bei der Prüfung des tatsächlichen Raums. Details zu Lieferung und Montage stehen direkt beim Produkt.",
        "es": "Las imágenes de ambientes muestran la escala y las combinaciones, mientras que las especificaciones ayudan a comprobar el espacio real. La información sobre entrega y montaje puede aparecer directamente junto al producto.",
        "pl": "Aranżacje wnętrz pokazują skalę i możliwe połączenia, a dane techniczne pomagają sprawdzić rzeczywistą przestrzeń. Informacje o dostawie i montażu mogą pozostać bezpośrednio przy produkcie.",
        "hu": "Az enteriőrképek megmutatják az arányokat és a kombinációkat, a műszaki adatok pedig segítenek felmérni a rendelkezésre álló teret. A szállítási és összeszerelési részletek közvetlenül a terméknél találhatók.",
        "ro": "Imaginile de ambient arată scara și combinațiile, iar specificațiile ajută la verificarea spațiului real. Detaliile despre livrare și montaj pot rămâne direct lângă produs."
    },
    "template.furniture-store.chrome.newsletterBody": {
        "cs": "Nové materiály, pokojové sestavy a praktické plánovací tipy.",
        "sk": "Nové materiály, interiérové zostavy a praktické tipy na plánovanie.",
        "en": "New materials, room sets and practical planning notes.",
        "de": "Neue Materialien, Raumkonzepte und praktische Planungstipps.",
        "es": "Nuevos materiales, conjuntos para cada estancia y consejos prácticos de planificación.",
        "pl": "Nowe materiały, zestawy do wnętrz i praktyczne wskazówki dotyczące planowania.",
        "hu": "Új anyagok, komplett berendezési összeállítások és praktikus tervezési tippek.",
        "ro": "Materiale noi, ansambluri pentru camere și recomandări practice de planificare."
    },
    "template.furniture-store.chrome.benefitTitle": {
        "cs": "Rozměry, doprava a montáž dřív než rozhodnutí",
        "sk": "Rozmery, doprava a montáž ešte pred rozhodnutím",
        "en": "Dimensions, delivery and assembly before the decision",
        "de": "Maße, Lieferung und Montage vor der Entscheidung",
        "es": "Dimensiones, entrega y montaje antes de decidir",
        "pl": "Wymiary, dostawa i montaż przed podjęciem decyzji",
        "hu": "Méretek, szállítás és összeszerelés már a döntés előtt",
        "ro": "Dimensiuni, livrare și montaj înainte de decizie"
    },
    "template.furniture-store.chrome.benefitBody": {
        "cs": "Technické informace a související kusy pomáhají ověřit, že nábytek zapadne do prostoru i způsobu používání.",
        "sk": "Technické informácie a súvisiace kúsky pomáhajú overiť, že nábytok zapadne do priestoru aj spôsobu používania.",
        "en": "Specifications and related pieces help confirm that furniture fits both the room and its intended use.",
        "de": "Technische Angaben und passende Möbel helfen zu prüfen, ob ein Stück zum Raum und zur geplanten Nutzung passt.",
        "es": "Las especificaciones y las piezas relacionadas ayudan a confirmar que el mueble encaja tanto en el espacio como en el uso previsto.",
        "pl": "Specyfikacje i powiązane produkty pomagają upewnić się, że meble pasują zarówno do wnętrza, jak i planowanego zastosowania.",
        "hu": "A műszaki adatok és a kapcsolódó darabok segítenek ellenőrizni, hogy a bútor illik-e a térhez és a tervezett használathoz.",
        "ro": "Specificațiile și piesele asociate te ajută să confirmi că mobilierul se potrivește atât spațiului, cât și utilizării dorite."
    },
    "template.furniture-store.chrome.categoryEyebrow": {
        "cs": "VYBÍRAT PODLE MÍSTNOSTI",
        "sk": "VYBERAŤ PODĽA MIESTNOSTI",
        "en": "SHOP BY ROOM",
        "de": "NACH RAUM EINKAUFEN",
        "es": "COMPRAR POR ESTANCIA",
        "pl": "WYBIERAJ WEDŁUG POMIESZCZENIA",
        "hu": "VÁLASSZON HELYISÉG SZERINT",
        "ro": "CUMPĂRĂ DUPĂ CAMERĂ"
    },
    "template.furniture-store.chrome.footerGuide": {
        "cs": "Průvodce rozměry",
        "sk": "Sprievodca rozmermi",
        "en": "Dimensions guide",
        "de": "Maßratgeber",
        "es": "Guía de dimensiones",
        "pl": "Przewodnik po wymiarach",
        "hu": "Méretútmutató",
        "ro": "Ghid de dimensiuni"
    },
    "template.home-decor-store.home.eyebrow": {
        "cs": "THE HOME EDIT",
        "sk": "THE HOME EDIT",
        "en": "THE HOME EDIT",
        "de": "THE HOME EDIT",
        "es": "THE HOME EDIT",
        "pl": "THE HOME EDIT",
        "hu": "THE HOME EDIT",
        "ro": "THE HOME EDIT"
    },
    "template.home-decor-store.home.title": {
        "cs": "Malé věci mění rytmus celého domova.",
        "sk": "Drobnosti menia rytmus celého domova.",
        "en": "Small objects change the rhythm of a whole home.",
        "de": "Kleine Dinge verändern den Rhythmus eines ganzen Zuhauses.",
        "es": "Los pequeños objetos cambian el ritmo de todo un hogar.",
        "pl": "Małe przedmioty zmieniają rytm całego domu.",
        "hu": "Apró tárgyak változtatják meg az egész otthon ritmusát.",
        "ro": "Obiectele mici schimbă ritmul întregii case."
    },
    "template.home-decor-store.home.body": {
        "cs": "Novinky, sezónní kolekce a výběry podle nálady propojují inspiraci s konkrétními produkty.",
        "sk": "Novinky, sezónne kolekcie a výbery podľa nálady prepájajú inšpiráciu s konkrétnymi produktmi.",
        "en": "New arrivals, seasonal collections and mood edits connect inspiration with real products.",
        "de": "Neuheiten, saisonale Kollektionen und stimmungsvolle Auswahlen verbinden Inspiration mit konkreten Produkten.",
        "es": "Las novedades, las colecciones de temporada y las selecciones por ambiente conectan la inspiración con productos reales.",
        "pl": "Nowości, kolekcje sezonowe i selekcje według nastroju łączą inspirację z konkretnymi produktami.",
        "hu": "Az újdonságok, a szezonális kollekciók és a hangulat szerinti válogatások konkrét termékekkel kapcsolják össze az inspirációt.",
        "ro": "Noutățile, colecțiile de sezon și selecțiile după atmosferă leagă inspirația de produse reale."
    },
    "template.home-decor-store.home.action": {
        "cs": "Prohlédnout nový edit",
        "sk": "Pozrieť si nový edit",
        "en": "Explore the new edit",
        "de": "Die neue Auswahl entdecken",
        "es": "Descubre la nueva selección",
        "pl": "Zobacz nową selekcję",
        "hu": "Fedezze fel az új válogatást",
        "ro": "Descoperă noua selecție"
    },
    "template.home-decor-store.home.storyTitle": {
        "cs": "Kolekce poskládané jako editoriál",
        "sk": "Kolekcie zostavené ako editoriál",
        "en": "Collections composed like an editorial",
        "de": "Kollektionen, komponiert wie ein Editorial",
        "es": "Colecciones concebidas como un editorial",
        "pl": "Kolekcje skomponowane jak edytorial",
        "hu": "Magazinszerűen komponált kollekciók",
        "ro": "Colecții compuse ca un editorial"
    },
    "template.home-decor-store.home.storyBody": {
        "cs": "Barva, materiál a měřítko vedou zákazníka od jedné dekorace k harmonickému celku.",
        "sk": "Farba, materiál a mierka vedú zákazníka od jednej dekorácie k harmonickému celku.",
        "en": "Color, material and scale guide customers from one object to a harmonious room.",
        "de": "Farbe, Material und Proportion führen von einem einzelnen Objekt zu einem harmonischen Raum.",
        "es": "El color, el material y la escala guían al cliente desde un solo objeto hasta una estancia armoniosa.",
        "pl": "Kolor, materiał i skala prowadzą od jednego dodatku do harmonijnego wnętrza.",
        "hu": "A szín, az anyag és az arány egyetlen tárgytól egy harmonikus helyiségig vezeti a vásárlót.",
        "ro": "Culoarea, materialul și proporțiile îi ghidează pe clienți de la un singur obiect la o cameră armonioasă."
    },
    "template.home-decor-store.home.heroAlt": {
        "cs": "Editorální zátiší s moderními bytovými doplňky",
        "sk": "Editoriálne zátišie s modernými bytovými doplnkami",
        "en": "Editorial still life of contemporary home accessories",
        "de": "Editorial-Stillleben mit modernen Wohnaccessoires",
        "es": "Bodegón editorial de accesorios contemporáneos para el hogar",
        "pl": "Edytorialowa martwa natura ze współczesnymi dodatkami do domu",
        "hu": "Kortárs lakáskiegészítők gondosan komponált csendélete",
        "ro": "Natură statică în stil editorial, cu accesorii contemporane pentru casă"
    },
    "template.home-decor-store.home.editorialAlt": {
        "cs": "Detail prostřeného stolu a vrstvených bytových textilií",
        "sk": "Detail prestretého stola a vrstvených bytových textílií",
        "en": "Detail of a set table and layered home textiles",
        "de": "Detailaufnahme eines gedeckten Tisches und geschichteter Wohntextilien",
        "es": "Detalle de una mesa puesta y textiles para el hogar combinados en capas",
        "pl": "Zbliżenie na nakryty stół i warstwowo ułożone tekstylia domowe",
        "hu": "Megterített asztal és rétegzett lakástextilek részlete",
        "ro": "Detaliu cu o masă aranjată și textile de casă suprapuse"
    },
    "template.home-decor-store.chrome.searchPlaceholder": {
        "cs": "Hledat dekoraci, barvu nebo místnost",
        "sk": "Hľadať dekoráciu, farbu alebo miestnosť",
        "en": "Search by decor, color or room",
        "de": "Nach Wohnaccessoire, Farbe oder Raum suchen",
        "es": "Buscar por decoración, color o estancia",
        "pl": "Szukaj według dekoracji, koloru lub pomieszczenia",
        "hu": "Keresés lakásdekoráció, szín vagy helyiség szerint",
        "ro": "Caută după decorațiune, culoare sau cameră"
    },
    "template.home-decor-store.chrome.promoMessage": {
        "cs": "Doplňky poskládané podle nálady, barvy a materiálu",
        "sk": "Doplnky zostavené podľa nálady, farby a materiálu",
        "en": "Decor curated by mood, color and material",
        "de": "Wohnaccessoires nach Stimmung, Farbe und Material kuratiert",
        "es": "Decoración elegida por ambiente, color y material",
        "pl": "Dodatki wybrane według nastroju, koloru i materiału",
        "hu": "Hangulat, szín és anyag szerint válogatott lakáskiegészítők",
        "ro": "Decorațiuni selectate după atmosferă, culoare și material"
    },
    "template.home-decor-store.chrome.promoTag": {
        "cs": "THE HOME EDIT",
        "sk": "THE HOME EDIT",
        "en": "THE HOME EDIT",
        "de": "THE HOME EDIT",
        "es": "THE HOME EDIT",
        "pl": "THE HOME EDIT",
        "hu": "THE HOME EDIT",
        "ro": "THE HOME EDIT"
    },
    "template.home-decor-store.chrome.productEyebrow": {
        "cs": "NOVÝ HOME EDIT",
        "sk": "NOVÝ HOME EDIT",
        "en": "NEW HOME EDIT",
        "de": "NEUE HOME-AUSWAHL",
        "es": "NUEVA SELECCIÓN PARA EL HOGAR",
        "pl": "NOWA SELEKCJA DO DOMU",
        "hu": "ÚJ HOME EDIT",
        "ro": "SELECȚIE NOUĂ PENTRU CASĂ"
    },
    "template.home-decor-store.chrome.productTitle": {
        "cs": "Detaily pro novou náladu domova",
        "sk": "Detaily pre novú atmosféru domova",
        "en": "Details for a new mood at home",
        "de": "Details für eine neue Stimmung zu Hause",
        "es": "Detalles para renovar el ambiente de casa",
        "pl": "Detale, które tworzą nowy klimat wnętrza",
        "hu": "Részletek az otthon új hangulatához",
        "ro": "Detalii pentru o atmosferă nouă acasă"
    },
    "template.home-decor-store.chrome.seoTitle": {
        "cs": "Bytové doplňky sestavené jako editoriál",
        "sk": "Bytové doplnky zostavené ako editoriál",
        "en": "Home decor composed like an editorial",
        "de": "Wohnaccessoires, komponiert wie ein Editorial",
        "es": "Decoración para el hogar concebida como un editorial",
        "pl": "Dodatki do domu skomponowane jak edytorial",
        "hu": "Magazinszerűen komponált lakásdekoráció",
        "ro": "Decorațiuni pentru casă compuse ca un editorial"
    },
    "template.home-decor-store.chrome.seoBody": {
        "cs": "Barva, materiál a měřítko propojují jednotlivé objekty s celou místností.",
        "sk": "Farba, materiál a mierka prepájajú jednotlivé objekty s celou miestnosťou.",
        "en": "Color, material and scale connect individual objects with the whole room.",
        "de": "Farbe, Material und Proportion verbinden einzelne Objekte mit dem gesamten Raum.",
        "es": "El color, el material y la escala conectan cada objeto con el conjunto de la estancia.",
        "pl": "Kolor, materiał i skala łączą pojedyncze przedmioty z całym wnętrzem.",
        "hu": "A szín, az anyag és az arány az egyes tárgyakat az egész helyiséghez kapcsolja.",
        "ro": "Culoarea, materialul și proporțiile leagă fiecare obiect de întreaga cameră."
    },
    "template.home-decor-store.chrome.seoDetails": {
        "cs": "Výběry podle místnosti a nálady ukazují, jak lze dekorace kombinovat. Každý produkt přitom zůstává dostupný s praktickými rozměry a materiálovými informacemi.",
        "sk": "Výbery podľa miestnosti a nálady ukazujú, ako možno dekorácie kombinovať. Pri každom produkte pritom zostávajú poruke praktické rozmery a informácie o materiáli.",
        "en": "Room and mood edits show how objects can be combined while each product keeps practical dimensions and material information close by.",
        "de": "Auswahlen nach Raum und Stimmung zeigen, wie sich Objekte kombinieren lassen. Praktische Maße und Materialangaben bleiben bei jedem Produkt griffbereit.",
        "es": "Las selecciones por estancia y ambiente muestran cómo combinar los objetos, y cada producto presenta de forma accesible sus dimensiones y la información sobre los materiales.",
        "pl": "Selekcje według pomieszczenia i nastroju pokazują, jak łączyć dodatki, a przy każdym produkcie pozostają łatwo dostępne praktyczne wymiary i informacje o materiale.",
        "hu": "A helyiség és hangulat szerinti válogatások megmutatják, hogyan kombinálhatók a tárgyak. A praktikus méretek és anyaginformációk minden terméknél könnyen elérhetők.",
        "ro": "Selecțiile după cameră și atmosferă arată cum pot fi combinate obiectele, iar dimensiunile practice și informațiile despre materiale rămân la îndemână pentru fiecare produs."
    },
    "template.home-decor-store.chrome.newsletterBody": {
        "cs": "Sezónní editace, nové objekty a inspirace pro jednotlivé místnosti.",
        "sk": "Sezónne výbery, nové objekty a inšpirácia pre jednotlivé miestnosti.",
        "en": "Seasonal edits, new objects and room-by-room inspiration.",
        "de": "Saisonale Auswahlen, neue Objekte und Inspiration für jeden Raum.",
        "es": "Selecciones de temporada, nuevos objetos e inspiración estancia por estancia.",
        "pl": "Sezonowe selekcje, nowe przedmioty i inspiracje do każdego pomieszczenia.",
        "hu": "Szezonális válogatások, új tárgyak és inspiráció helyiségről helyiségre.",
        "ro": "Selecții de sezon, obiecte noi și inspirație pentru fiecare cameră."
    },
    "template.home-decor-store.chrome.benefitTitle": {
        "cs": "Barva, materiál a měřítko v jednom výběru",
        "sk": "Farba, materiál a mierka v jednom výbere",
        "en": "Color, material and scale in one edit",
        "de": "Farbe, Material und Proportion in einer Auswahl",
        "es": "Color, material y escala en una sola selección",
        "pl": "Kolor, materiał i skala w jednej selekcji",
        "hu": "Szín, anyag és arány egy válogatásban",
        "ro": "Culoare, material și proporții într-o singură selecție"
    },
    "template.home-decor-store.chrome.benefitBody": {
        "cs": "Kontextové fotografie a přesné rozměry pomáhají představit si každý objekt doma.",
        "sk": "Kontextové fotografie a presné rozmery pomáhajú predstaviť si každý objekt doma.",
        "en": "Context photography and exact dimensions help customers picture every object at home.",
        "de": "Stimmungsbilder und genaue Maße helfen dabei, sich jedes Objekt im eigenen Zuhause vorzustellen.",
        "es": "Las fotografías en contexto y las medidas exactas ayudan a imaginar cada objeto en casa.",
        "pl": "Zdjęcia aranżacyjne i dokładne wymiary pomagają wyobrazić sobie każdy przedmiot we własnym domu.",
        "hu": "A környezetben készült fotók és a pontos méretek segítenek minden tárgyat elképzelni az otthonában.",
        "ro": "Fotografiile în context și dimensiunile exacte îi ajută pe clienți să-și imagineze fiecare obiect acasă."
    },
    "template.home-decor-store.chrome.categoryEyebrow": {
        "cs": "PODLE MÍSTNOSTI A NÁLADY",
        "sk": "PODĽA MIESTNOSTI A NÁLADY",
        "en": "BY ROOM AND MOOD",
        "de": "NACH RAUM UND STIMMUNG",
        "es": "POR ESTANCIA Y AMBIENTE",
        "pl": "WEDŁUG POMIESZCZENIA I NASTROJU",
        "hu": "HELYISÉG ÉS HANGULAT SZERINT",
        "ro": "DUPĂ CAMERĂ ȘI ATMOSFERĂ"
    },
    "template.home-decor-store.chrome.footerGuide": {
        "cs": "Průvodce kombinováním",
        "sk": "Sprievodca kombinovaním",
        "en": "Styling guide",
        "de": "Styling-Ratgeber",
        "es": "Guía de estilo",
        "pl": "Przewodnik po stylizacji wnętrz",
        "hu": "Stílusútmutató",
        "ro": "Ghid de amenajare"
    },
    "template.pet-store.home.eyebrow": {
        "cs": "PRO KOHO DNES NAKUPUJETE?",
        "sk": "PRE KOHO DNES NAKUPUJETE?",
        "en": "WHO ARE YOU SHOPPING FOR?",
        "de": "FÜR WEN KAUFEN SIE HEUTE EIN?",
        "es": "¿PARA QUIÉN ESTÁS COMPRANDO?",
        "pl": "DLA KOGO DZIŚ KUPUJESZ?",
        "hu": "KINEK VÁSÁROL MA?",
        "ro": "PENTRU CINE CUMPERI?"
    },
    "template.pet-store.home.title": {
        "cs": "Každý den se počítá. Procházka, hra i klid.",
        "sk": "Každý deň sa počíta. Prechádzka, hra aj oddych.",
        "en": "Every day matters. Walk, play and rest.",
        "de": "Jeder Tag zählt. Spaziergang, Spiel und Ruhe.",
        "es": "Cada día cuenta. Paseos, juego y descanso.",
        "pl": "Każdy dzień ma znaczenie. Spacer, zabawa i odpoczynek.",
        "hu": "Minden nap számít. Séta, játék és pihenés.",
        "ro": "Fiecare zi contează. Plimbare, joacă și odihnă."
    },
    "template.pet-store.home.body": {
        "cs": "Vyberte podle zvířete a skutečné potřeby. Velikosti, použití a vhodné sety jsou jasné už při procházení.",
        "sk": "Vyberte si podľa zvieraťa a skutočnej potreby. Veľkosti, použitie a vhodné súpravy sú jasné už pri prehliadaní.",
        "en": "Choose by pet and genuine need. Sizes, uses and useful bundles are clear while browsing.",
        "de": "Wählen Sie nach Tier und echtem Bedarf. Größen, Einsatzzwecke und sinnvolle Sets sind schon beim Stöbern klar ersichtlich.",
        "es": "Elige según tu mascota y sus necesidades reales. Las tallas, los usos y las combinaciones recomendadas quedan claros mientras navegas.",
        "pl": "Wybieraj według zwierzęcia i jego rzeczywistych potrzeb. Rozmiary, zastosowania i przydatne zestawy są jasne już podczas przeglądania.",
        "hu": "Válasszon aszerint, milyen kedvence van, és mire van valóban szüksége. A méretek, a felhasználási módok és a praktikus csomagok már böngészés közben is egyértelműek.",
        "ro": "Alege în funcție de animalul tău și nevoia reală. Mărimile, utilizările și pachetele potrivite sunt clare încă din timpul navigării."
    },
    "template.pet-store.home.action": {
        "cs": "Vybrat podle mazlíčka",
        "sk": "Vybrať podľa miláčika",
        "en": "Shop by pet",
        "de": "Nach Haustier auswählen",
        "es": "Comprar por mascota",
        "pl": "Wybierz według pupila",
        "hu": "Válasszon kedvence szerint",
        "ro": "Cumpără după animal"
    },
    "template.pet-store.home.storyTitle": {
        "cs": "Výbava podle každodenní rutiny",
        "sk": "Výbava podľa každodennej rutiny",
        "en": "Gear organized around daily routines",
        "de": "Ausstattung für den täglichen Rhythmus",
        "es": "Equipamiento organizado en torno a las rutinas diarias",
        "pl": "Wyposażenie dopasowane do codziennych rytuałów",
        "hu": "Felszerelés a mindennapi rutinokhoz igazítva",
        "ro": "Echipament organizat în jurul rutinelor zilnice"
    },
    "template.pet-store.home.storyBody": {
        "cs": "Krmivo, hra, procházka a péče jsou propojené tak, aby šel správný produkt najít rychle.",
        "sk": "Krmivo, hra, prechádzka a starostlivosť sú prepojené tak, aby ste správny produkt našli rýchlo.",
        "en": "Food, play, walks and care connect so the right product is quick to find.",
        "de": "Fütterung, Spiel, Spaziergang und Pflege sind so verbunden, dass sich das richtige Produkt schnell finden lässt.",
        "es": "Alimentación, juego, paseos y cuidados se conectan para que encuentres rápido el producto adecuado.",
        "pl": "Karma, zabawa, spacery i pielęgnacja łączą się tak, aby właściwy produkt można było znaleźć szybko.",
        "hu": "Az etetés, a játék, a séta és az ápolás úgy kapcsolódik össze, hogy gyorsan megtalálható legyen a megfelelő termék.",
        "ro": "Hrana, joaca, plimbările și îngrijirea se completează, astfel încât produsul potrivit să fie ușor de găsit."
    },
    "template.pet-store.home.heroAlt": {
        "cs": "Spokojený pes a kočka s moderními chovatelskými potřebami",
        "sk": "Spokojný pes a mačka s modernými chovateľskými potrebami",
        "en": "Happy dog and cat with modern pet essentials",
        "de": "Glücklicher Hund und zufriedene Katze mit modernem Tierbedarf",
        "es": "Perro y gato felices con accesorios modernos para mascotas",
        "pl": "Szczęśliwy pies i kot z nowoczesnymi akcesoriami dla zwierząt",
        "hu": "Boldog kutya és macska modern kisállat-felszerelésekkel",
        "ro": "Câine și pisică fericiți, alături de accesorii moderne pentru animale"
    },
    "template.pet-store.home.editorialAlt": {
        "cs": "Detail odolného vodítka, misky a hraček pro mazlíčky",
        "sk": "Detail odolnej vôdzky, misky a hračiek pre domácich miláčikov",
        "en": "Detail of a durable leash, bowl and pet toys",
        "de": "Detailaufnahme einer robusten Leine, eines Napfs und von Tierspielzeug",
        "es": "Detalle de una correa resistente, un cuenco y juguetes para mascotas",
        "pl": "Zbliżenie na wytrzymałą smycz, miskę i zabawki dla zwierząt",
        "hu": "Tartós póráz, etetőtál és kisállatjátékok részlete",
        "ro": "Detaliu cu o lesă rezistentă, un bol și jucării pentru animale"
    },
    "template.pet-store.chrome.searchPlaceholder": {
        "cs": "Hledat podle zvířete, potřeby nebo produktu",
        "sk": "Hľadať podľa zvieraťa, potreby alebo produktu",
        "en": "Search by pet, need or product",
        "de": "Nach Tier, Bedarf oder Produkt suchen",
        "es": "Buscar por mascota, necesidad o producto",
        "pl": "Szukaj według zwierzęcia, potrzeby lub produktu",
        "hu": "Keresés állatfaj, igény vagy termék szerint",
        "ro": "Caută după animal, nevoie sau produs"
    },
    "template.pet-store.chrome.promoMessage": {
        "cs": "Výbava uspořádaná kolem krmení, hry, procházek a péče",
        "sk": "Výbava usporiadaná podľa kŕmenia, hry, prechádzok a starostlivosti",
        "en": "Essentials organized around feeding, play, walks and care",
        "de": "Ausstattung für Fütterung, Spiel, Spaziergang und Pflege",
        "es": "Todo lo esencial organizado por alimentación, juego, paseos y cuidados",
        "pl": "Akcesoria uporządkowane wokół karmienia, zabawy, spacerów i pielęgnacji",
        "hu": "Alapfelszerelések etetéshez, játékhoz, sétához és ápoláshoz",
        "ro": "Produse esențiale organizate în jurul hrănirii, jocului, plimbărilor și îngrijirii"
    },
    "template.pet-store.chrome.promoTag": {
        "cs": "PODLE MAZLÍČKA",
        "sk": "PODĽA MILÁČIKA",
        "en": "SHOP BY PET",
        "de": "NACH HAUSTIER EINKAUFEN",
        "es": "COMPRAR POR MASCOTA",
        "pl": "WYBIERAJ WEDŁUG PUPILA",
        "hu": "VÁLASSZON KEDVENCE SZERINT",
        "ro": "ALEGE DUPĂ ANIMAL"
    },
    "template.pet-store.chrome.productEyebrow": {
        "cs": "PRO KAŽDODENNÍ RUTINU",
        "sk": "PRE KAŽDODENNÚ RUTINU",
        "en": "FOR DAILY ROUTINES",
        "de": "FÜR DEN TÄGLICHEN RHYTHMUS",
        "es": "PARA LAS RUTINAS DIARIAS",
        "pl": "DO CODZIENNYCH RYTUAŁÓW",
        "hu": "A MINDENNAPI RUTINOKHOZ",
        "ro": "PENTRU RUTINELE ZILNICE"
    },
    "template.pet-store.chrome.productTitle": {
        "cs": "Výbava pro hru, procházku i odpočinek",
        "sk": "Výbava na hru, prechádzku aj oddych",
        "en": "Gear for play, walks and rest",
        "de": "Ausstattung für Spiel, Spaziergang und Ruhe",
        "es": "Equipamiento para jugar, pasear y descansar",
        "pl": "Wyposażenie do zabawy, spacerów i odpoczynku",
        "hu": "Felszerelés játékhoz, sétához és pihenéshez",
        "ro": "Echipament pentru joacă, plimbări și odihnă"
    },
    "template.pet-store.chrome.seoTitle": {
        "cs": "Chovatelské potřeby podle skutečné situace",
        "sk": "Chovateľské potreby podľa konkrétnej situácie",
        "en": "Pet supplies organized around real situations",
        "de": "Tierbedarf nach konkreten Alltagssituationen",
        "es": "Productos para mascotas organizados según situaciones reales",
        "pl": "Artykuły dla zwierząt dopasowane do rzeczywistych sytuacji",
        "hu": "Kisállat-felszerelések valós helyzetek szerint",
        "ro": "Produse pentru animale organizate după situații reale"
    },
    "template.pet-store.chrome.seoBody": {
        "cs": "Velikost, věk a způsob použití pomáhají rychle zúžit výběr.",
        "sk": "Veľkosť, vek a spôsob použitia pomáhajú rýchlo zúžiť výber.",
        "en": "Size, age and intended use help narrow the selection quickly.",
        "de": "Größe, Alter und Verwendungszweck helfen, die Auswahl schnell einzugrenzen.",
        "es": "El tamaño, la edad y el uso previsto ayudan a acotar rápidamente la selección.",
        "pl": "Rozmiar, wiek i przeznaczenie pomagają szybko zawęzić wybór.",
        "hu": "A méret, az életkor és a felhasználási mód gyorsan leszűkíti a választékot.",
        "ro": "Mărimea, vârsta și utilizarea prevăzută ajută la restrângerea rapidă a selecției."
    },
    "template.pet-store.chrome.seoDetails": {
        "cs": "Krmivo, péče, hračky a vybavení na procházku lze propojit do srozumitelných rutin. U variant zůstávají viditelné rozměry i vhodnost pro konkrétní zvíře.",
        "sk": "Krmivo, starostlivosť, hračky a výbavu na prechádzku možno prepojiť do zrozumiteľných rutín. Pri variantoch zostávajú viditeľné rozmery aj vhodnosť pre konkrétne zviera.",
        "en": "Food, care, toys and walking gear can be connected into clear routines, with dimensions and pet suitability visible on each variant.",
        "de": "Futter, Pflege, Spielzeug und Spazierausstattung lassen sich zu klaren Routinen verbinden. Maße und Eignung für das jeweilige Tier bleiben bei jeder Variante sichtbar.",
        "es": "La alimentación, los cuidados, los juguetes y el equipamiento de paseo pueden integrarse en rutinas claras, con las dimensiones y la idoneidad para cada mascota visibles en cada variante.",
        "pl": "Karmę, pielęgnację, zabawki i akcesoria spacerowe można połączyć w przejrzyste rytuały. Przy każdym wariancie widoczne są wymiary i informacja, dla jakiego zwierzęcia jest odpowiedni.",
        "hu": "Az eledel, az ápolás, a játékok és a sétafelszerelés átlátható rutinokká kapcsolhatók össze. A méretek és az adott állatnak való megfelelőség minden változatnál látható marad.",
        "ro": "Hrana, produsele de îngrijire, jucăriile și echipamentul pentru plimbare pot fi reunite în rutine clare, iar dimensiunile și compatibilitatea cu fiecare animal sunt vizibile pentru fiecare variantă."
    },
    "template.pet-store.chrome.newsletterBody": {
        "cs": "Praktické výběry podle zvířete, věku a každodenní potřeby.",
        "sk": "Praktické výbery podľa zvieraťa, veku a každodenných potrieb.",
        "en": "Practical picks by pet, age and everyday need.",
        "de": "Praktische Empfehlungen nach Tier, Alter und täglichem Bedarf.",
        "es": "Selecciones prácticas por mascota, edad y necesidad cotidiana.",
        "pl": "Praktyczne wybory według zwierzęcia, wieku i codziennych potrzeb.",
        "hu": "Praktikus válogatások állatfaj, életkor és mindennapi igény szerint.",
        "ro": "Selecții practice după animal, vârstă și nevoie zilnică."
    },
    "template.pet-store.chrome.benefitTitle": {
        "cs": "Správná velikost a použití bez odhadování",
        "sk": "Správna veľkosť a použitie bez odhadovania",
        "en": "The right size and use without guessing",
        "de": "Die richtige Größe und der passende Einsatzzweck ohne Rätselraten",
        "es": "La talla y el uso adecuados, sin tener que adivinar",
        "pl": "Właściwy rozmiar i zastosowanie bez zgadywania",
        "hu": "Megfelelő méret és felhasználás találgatás nélkül",
        "ro": "Mărimea și utilizarea potrivite, fără presupuneri"
    },
    "template.pet-store.chrome.benefitBody": {
        "cs": "Přehled variant a doporučených kombinací pomáhá vybrat výbavu pro konkrétní rutinu.",
        "sk": "Prehľad variantov a odporúčaných kombinácií pomáha vybrať výbavu pre konkrétnu rutinu.",
        "en": "Clear variants and useful combinations support the needs of each routine.",
        "de": "Klare Varianten und sinnvolle Kombinationen unterstützen jede Alltagsroutine.",
        "es": "Unas variantes claras y combinaciones útiles ayudan a cubrir las necesidades de cada rutina.",
        "pl": "Przejrzyste warianty i przydatne połączenia pomagają dobrać wyposażenie do każdego rytuału.",
        "hu": "Az átlátható változatok és a hasznos kombinációk segítenek megtalálni az egyes rutinokhoz illő felszerelést.",
        "ro": "Variantele clare și combinațiile utile răspund nevoilor fiecărei rutine."
    },
    "template.pet-store.chrome.categoryEyebrow": {
        "cs": "PRO KOHO DNES NAKUPUJETE",
        "sk": "PRE KOHO DNES NAKUPUJETE",
        "en": "WHO ARE YOU SHOPPING FOR",
        "de": "FÜR WEN KAUFEN SIE HEUTE EIN",
        "es": "PARA QUIÉN ESTÁS COMPRANDO",
        "pl": "DLA KOGO DZIŚ KUPUJESZ",
        "hu": "KINEK VÁSÁROL MA",
        "ro": "PENTRU CINE CUMPERI"
    },
    "template.pet-store.chrome.footerGuide": {
        "cs": "Průvodce velikostmi",
        "sk": "Sprievodca veľkosťami",
        "en": "Sizing guide",
        "de": "Größenratgeber",
        "es": "Guía de tallas",
        "pl": "Przewodnik po rozmiarach",
        "hu": "Méretútmutató",
        "ro": "Ghid de mărimi"
    },
    "template.pet-store.chrome.bestsellerTitle": {
        "cs": "Nejprodávanější",
        "sk": "Najpredávanejšie",
        "en": "Best selling",
        "de": "Bestseller",
        "es": "Más vendidos",
        "pl": "Bestsellery",
        "hu": "Legnépszerűbb",
        "ro": "Cele mai vândute"
    },
    "template.pet-store.chrome.bestsellerAction": {
        "cs": "Zobrazit produkty",
        "sk": "Zobraziť produkty",
        "en": "Show products",
        "de": "Produkte anzeigen",
        "es": "Mostrar productos",
        "pl": "Pokaż produkty",
        "hu": "Termékek megjelenítése",
        "ro": "Afișați produsele"
    },
    "template.sports-store.home.eyebrow": {
        "cs": "READY FOR THE NEXT KM",
        "sk": "READY FOR THE NEXT KM",
        "en": "READY FOR THE NEXT KM",
        "de": "READY FOR THE NEXT KM",
        "es": "READY FOR THE NEXT KM",
        "pl": "READY FOR THE NEXT KM",
        "hu": "READY FOR THE NEXT KM",
        "ro": "READY FOR THE NEXT KM"
    },
    "template.sports-store.home.title": {
        "cs": "Výbava, která pracuje ve stejném tempu jako vy.",
        "sk": "Výbava, ktorá s vami drží tempo.",
        "en": "Gear that works at the same pace as you.",
        "de": "Ausrüstung, die mit Ihrem Tempo mithält.",
        "es": "Equipamiento que sigue tu ritmo.",
        "pl": "Sprzęt, który dotrzymuje ci kroku.",
        "hu": "Felszerelés, amely lépést tart Önnel.",
        "ro": "Echipament care ține pasul cu tine."
    },
    "template.sports-store.home.body": {
        "cs": "Sport, terén a podmínky jsou důležitější než nekonečný seznam produktů. Začněte tím, kde a jak se hýbete.",
        "sk": "Šport, terén a podmienky sú dôležitejšie než nekonečný zoznam produktov. Začnite tým, kde a ako sa hýbete.",
        "en": "Sport, terrain and conditions matter more than an endless list. Start with where and how you move.",
        "de": "Sportart, Gelände und Bedingungen sind wichtiger als eine endlose Produktliste. Beginnen Sie damit, wo und wie Sie sich bewegen.",
        "es": "El deporte, el terreno y las condiciones importan más que una lista interminable. Empieza por dónde y cómo te mueves.",
        "pl": "Dyscyplina, teren i warunki mają większe znaczenie niż nieskończona lista produktów. Zacznij od tego, gdzie i jak się poruszasz.",
        "hu": "A sportág, a terep és a körülmények fontosabbak egy végtelen terméklistánál. Induljon ki abból, hol és hogyan mozog.",
        "ro": "Sportul, terenul și condițiile contează mai mult decât o listă nesfârșită. Începe cu locul și felul în care te miști."
    },
    "template.sports-store.home.action": {
        "cs": "Vybrat svůj sport",
        "sk": "Vybrať si svoj šport",
        "en": "Choose your sport",
        "de": "Sportart auswählen",
        "es": "Elige tu deporte",
        "pl": "Wybierz swoją dyscyplinę",
        "hu": "Válassza ki sportágát",
        "ro": "Alege-ți sportul"
    },
    "template.sports-store.home.storyTitle": {
        "cs": "Technologie přeložená do výkonu",
        "sk": "Technológie premenené na výkon",
        "en": "Technology translated into performance",
        "de": "Technologie, die Leistung bringt",
        "es": "Tecnología convertida en rendimiento",
        "pl": "Technologia przełożona na osiągi",
        "hu": "Technológia teljesítményre fordítva",
        "ro": "Tehnologie transformată în performanță"
    },
    "template.sports-store.home.storyBody": {
        "cs": "Fit, materiál a konkrétní použití vysvětlujeme tak, aby šla kompletní výbava sestavit bez hádání.",
        "sk": "Strih, materiál a konkrétne použitie vysvetľujeme tak, aby sa dala kompletná výbava zostaviť bez hádania.",
        "en": "Fit, material and intended use are explained so a complete kit is easy to build.",
        "de": "Passform, Material und Einsatzzweck werden so erklärt, dass sich eine komplette Ausrüstung leicht zusammenstellen lässt.",
        "es": "El corte, el material y el uso previsto se explican para que resulte fácil componer una equipación completa.",
        "pl": "Dopasowanie, materiał i przeznaczenie wyjaśniamy tak, aby bez zgadywania można było skompletować cały zestaw.",
        "hu": "A szabást, az anyagot és a felhasználási célt úgy magyarázzuk el, hogy könnyű legyen összeállítani a teljes felszerelést.",
        "ro": "Croiala, materialul și utilizarea prevăzută sunt explicate astfel încât să alcătuiești ușor un echipament complet."
    },
    "template.sports-store.home.heroAlt": {
        "cs": "Sportovec v pohybu s moderním outdoorovým vybavením",
        "sk": "Športovec v pohybe s modernou outdoorovou výbavou",
        "en": "Athlete in motion with contemporary outdoor equipment",
        "de": "Sportler in Bewegung mit moderner Outdoor-Ausrüstung",
        "es": "Deportista en movimiento con equipamiento contemporáneo para actividades al aire libre",
        "pl": "Sportowiec w ruchu z nowoczesnym sprzętem outdoorowym",
        "hu": "Sportoló mozgás közben modern outdoor felszereléssel",
        "ro": "Sportiv în mișcare cu echipament contemporan pentru activități în aer liber"
    },
    "template.sports-store.home.editorialAlt": {
        "cs": "Technický detail sportovní obuvi a funkčního materiálu",
        "sk": "Technický detail športovej obuvi a funkčného materiálu",
        "en": "Technical detail of sports footwear and performance fabric",
        "de": "Technische Detailaufnahme eines Sportschuhs und funktionalen Materials",
        "es": "Detalle técnico de calzado deportivo y tejido de alto rendimiento",
        "pl": "Techniczne zbliżenie na obuwie sportowe i funkcjonalną tkaninę",
        "hu": "Sportcipő és teljesítményre tervezett anyag technikai részlete",
        "ro": "Detaliu tehnic al încălțămintei sportive și al materialului performant"
    },
    "template.sports-store.chrome.searchPlaceholder": {
        "cs": "Hledat sport, terén nebo typ výbavy",
        "sk": "Hľadať šport, terén alebo typ výbavy",
        "en": "Search by sport, terrain or gear",
        "de": "Nach Sportart, Gelände oder Ausrüstung suchen",
        "es": "Buscar por deporte, terreno o equipamiento",
        "pl": "Szukaj według dyscypliny, terenu lub rodzaju sprzętu",
        "hu": "Keresés sportág, terep vagy felszerelés szerint",
        "ro": "Caută după sport, teren sau echipament"
    },
    "template.sports-store.chrome.promoMessage": {
        "cs": "Výbava podle disciplíny, terénu a podmínek",
        "sk": "Výbava podľa disciplíny, terénu a podmienok",
        "en": "Gear organized by discipline, terrain and conditions",
        "de": "Ausrüstung nach Disziplin, Gelände und Bedingungen",
        "es": "Equipamiento organizado por disciplina, terreno y condiciones",
        "pl": "Sprzęt uporządkowany według dyscypliny, terenu i warunków",
        "hu": "Felszerelés sportág, terep és körülmények szerint",
        "ro": "Echipament organizat după disciplină, teren și condiții"
    },
    "template.sports-store.chrome.promoTag": {
        "cs": "READY FOR NEXT KM",
        "sk": "READY FOR NEXT KM",
        "en": "READY FOR NEXT KM",
        "de": "READY FOR NEXT KM",
        "es": "READY FOR NEXT KM",
        "pl": "READY FOR NEXT KM",
        "hu": "READY FOR NEXT KM",
        "ro": "READY FOR NEXT KM"
    },
    "template.sports-store.chrome.productEyebrow": {
        "cs": "VYBRAT PODLE POHYBU",
        "sk": "VYBRAŤ PODĽA POHYBU",
        "en": "CHOOSE BY MOVEMENT",
        "de": "NACH BEWEGUNG AUSWÄHLEN",
        "es": "ELIGE SEGÚN EL MOVIMIENTO",
        "pl": "WYBIERAJ WEDŁUG RODZAJU RUCHU",
        "hu": "VÁLASSZON MOZGÁSFORMA SZERINT",
        "ro": "ALEGE DUPĂ TIPUL DE MIȘCARE"
    },
    "template.sports-store.chrome.productTitle": {
        "cs": "Výbava pro další trénink i trasu",
        "sk": "Výbava na ďalší tréning aj trasu",
        "en": "Gear for the next session and route",
        "de": "Ausrüstung für die nächste Einheit und Strecke",
        "es": "Equipamiento para tu próximo entrenamiento y recorrido",
        "pl": "Sprzęt na kolejny trening i trasę",
        "hu": "Felszerelés a következő edzéshez és útvonalhoz",
        "ro": "Echipament pentru următorul antrenament și traseu"
    },
    "template.sports-store.chrome.seoTitle": {
        "cs": "Technické parametry převedené do pohybu",
        "sk": "Technické parametre premenené na pohyb",
        "en": "Technical features translated into movement",
        "de": "Technische Eigenschaften für echte Bewegung",
        "es": "Características técnicas convertidas en movimiento",
        "pl": "Parametry techniczne przełożone na ruch",
        "hu": "Műszaki jellemzők a mozgás szolgálatában",
        "ro": "Caracteristici tehnice transformate în mișcare"
    },
    "template.sports-store.chrome.seoBody": {
        "cs": "Fit, materiál, terén a počasí ukazují, pro jaké použití je výbava navržená.",
        "sk": "Strih, materiál, terén a počasie ukazujú, na aké použitie je výbava navrhnutá.",
        "en": "Fit, material, terrain and weather show what each piece of gear is designed for.",
        "de": "Passform, Material, Gelände und Wetter zeigen, wofür jedes Ausrüstungsteil entwickelt wurde.",
        "es": "El corte, el material, el terreno y el clima muestran para qué está diseñada cada pieza.",
        "pl": "Dopasowanie, materiał, teren i pogoda pokazują, do czego zaprojektowano każdy element wyposażenia.",
        "hu": "A szabás, az anyag, a terep és az időjárás megmutatja, milyen használatra tervezték az egyes felszereléseket.",
        "ro": "Croiala, materialul, terenul și vremea arată pentru ce este concepută fiecare piesă de echipament."
    },
    "template.sports-store.chrome.seoDetails": {
        "cs": "Disciplíny a podmínky propojují obuv, oblečení i vybavení do jednoho funkčního celku. Srovnání variant zůstává konkrétní a snadno čitelné.",
        "sk": "Disciplíny a podmienky prepájajú obuv, oblečenie aj vybavenie do jedného funkčného celku. Porovnanie variantov zostáva konkrétne a ľahko čitateľné.",
        "en": "Disciplines and conditions connect footwear, clothing and equipment into one functional kit, with concrete variant comparisons.",
        "de": "Disziplinen und Bedingungen verbinden Schuhe, Bekleidung und Equipment zu einer funktionalen Ausrüstung. Konkrete Varianten lassen sich leicht vergleichen.",
        "es": "Las disciplinas y las condiciones conectan el calzado, la ropa y el material en un conjunto funcional, con comparaciones concretas entre variantes.",
        "pl": "Dyscypliny i warunki łączą obuwie, odzież i sprzęt w jeden funkcjonalny zestaw, a porównanie konkretnych wariantów pozostaje proste.",
        "hu": "A sportágak és a körülmények a cipőket, a ruházatot és az eszközöket egyetlen funkcionális szetté kapcsolják össze, miközben a változatok konkrétan összehasonlíthatók.",
        "ro": "Disciplinele și condițiile reunesc încălțămintea, îmbrăcămintea și accesoriile într-un echipament funcțional, cu comparații concrete între variante."
    },
    "template.sports-store.chrome.newsletterBody": {
        "cs": "Nová výbava, technické materiály a výběry podle disciplíny.",
        "sk": "Nová výbava, technické materiály a výbery podľa disciplíny.",
        "en": "New gear, technical materials and picks by discipline.",
        "de": "Neue Ausrüstung, technische Materialien und Empfehlungen nach Disziplin.",
        "es": "Nuevo equipamiento, materiales técnicos y selecciones por disciplina.",
        "pl": "Nowy sprzęt, techniczne materiały i wybory według dyscypliny.",
        "hu": "Új felszerelések, technikai anyagok és sportág szerinti válogatások.",
        "ro": "Echipament nou, materiale tehnice și selecții după disciplină."
    },
    "template.sports-store.chrome.benefitTitle": {
        "cs": "Fit, materiál a podmínky před prvním kilometrem",
        "sk": "Strih, materiál a podmienky ešte pred prvým kilometrom",
        "en": "Fit, material and conditions before the first kilometer",
        "de": "Passform, Material und Bedingungen vor dem ersten Kilometer",
        "es": "Corte, material y condiciones antes del primer kilómetro",
        "pl": "Dopasowanie, materiał i warunki przed pierwszym kilometrem",
        "hu": "Szabás, anyag és körülmények az első kilométer előtt",
        "ro": "Croială, material și condiții înainte de primul kilometru"
    },
    "template.sports-store.chrome.benefitBody": {
        "cs": "Určení produktu a kompatibilní výbava pomáhají sestavit celek bez zbytečných kompromisů.",
        "sk": "Určenie produktu a kompatibilná výbava pomáhajú zostaviť celok bez zbytočných kompromisov.",
        "en": "Intended use and compatible gear help build a complete kit without unnecessary compromise.",
        "de": "Einsatzzweck und kompatible Ausrüstung helfen, ein komplettes Set ohne unnötige Kompromisse zusammenzustellen.",
        "es": "El uso previsto y el equipamiento compatible ayudan a crear un conjunto completo sin concesiones innecesarias.",
        "pl": "Przeznaczenie i kompatybilny sprzęt pomagają skompletować cały zestaw bez zbędnych kompromisów.",
        "hu": "A felhasználási cél és az egymással kompatibilis felszerelések segítenek felesleges kompromisszumok nélkül teljes szettet összeállítani.",
        "ro": "Utilizarea prevăzută și echipamentul compatibil te ajută să construiești un set complet, fără compromisuri inutile."
    },
    "template.sports-store.chrome.categoryEyebrow": {
        "cs": "VYBÍRAT PODLE DISCIPLÍNY",
        "sk": "VYBERAŤ PODĽA DISCIPLÍNY",
        "en": "SHOP BY DISCIPLINE",
        "de": "NACH DISZIPLIN EINKAUFEN",
        "es": "COMPRAR POR DISCIPLINA",
        "pl": "WYBIERAJ WEDŁUG DYSCYPLINY",
        "hu": "VÁLASSZON SPORTÁG SZERINT",
        "ro": "CUMPĂRĂ DUPĂ DISCIPLINĂ"
    },
    "template.sports-store.chrome.footerGuide": {
        "cs": "Průvodce výběrem a velikostí",
        "sk": "Sprievodca výberom a veľkosťami",
        "en": "Gear and sizing guide",
        "de": "Ausrüstungs- und Größenratgeber",
        "es": "Guía de equipamiento y tallas",
        "pl": "Przewodnik po sprzęcie i rozmiarach",
        "hu": "Felszerelés- és méretútmutató",
        "ro": "Ghid pentru echipament și mărimi"
    },
    "template.baby-store.home.eyebrow": {
        "cs": "HRANÍ, TVOŘENÍ A OBJEVOVÁNÍ",
        "sk": "HRA, TVORENIE A OBJAVOVANIE",
        "en": "PLAY, CREATE AND DISCOVER",
        "de": "SPIELEN, GESTALTEN UND ENTDECKEN",
        "es": "JUGAR, CREAR Y DESCUBRIR",
        "pl": "ZABAWA, TWORZENIE I ODKRYWANIE",
        "hu": "JÁTÉK, ALKOTÁS ÉS FELFEDEZÉS",
        "ro": "JOACĂ, CREAȚIE ȘI DESCOPERIRE"
    },
    "template.baby-store.home.title": {
        "cs": "Barevný svět pro malé objevitele.",
        "sk": "Farebný svet pre malých objaviteľov.",
        "en": "A colorful world for little explorers.",
        "de": "Eine bunte Welt für kleine Entdecker.",
        "es": "Un mundo de color para pequeños exploradores.",
        "pl": "Kolorowy świat dla małych odkrywców.",
        "hu": "Színes világ kis felfedezőknek.",
        "ro": "O lume colorată pentru micii exploratori."
    },
    "template.baby-store.home.body": {
        "cs": "Hračky, tvořivé sady a dětská výbava vybrané podle věku, zájmů a společných dobrodružství.",
        "sk": "Hračky, tvorivé sady a detská výbava vybrané podľa veku, záujmov a spoločných dobrodružstiev.",
        "en": "Toys, creative kits and children's essentials chosen by age, interests and shared adventures.",
        "de": "Spielzeug, Kreativsets und Kinderausstattung, ausgewählt nach Alter, Interessen und gemeinsamen Abenteuern.",
        "es": "Juguetes, kits creativos y artículos infantiles elegidos por edad, intereses y aventuras compartidas.",
        "pl": "Zabawki, zestawy kreatywne i dziecięce akcesoria dobrane według wieku, zainteresowań i wspólnych przygód.",
        "hu": "Játékok, kreatív készletek és gyermekholmik életkor, érdeklődés és közös kalandok szerint válogatva.",
        "ro": "Jucării, seturi creative și articole pentru copii alese după vârstă, interese și aventuri împreună."
    },
    "template.baby-store.home.action": {
        "cs": "Objevit hravý svět",
        "sk": "Objaviť hravý svet",
        "en": "Explore the playful world",
        "de": "Die spielerische Welt entdecken",
        "es": "Descubrir el mundo de juego",
        "pl": "Odkryj świat zabawy",
        "hu": "Fedezze fel a játékos világot",
        "ro": "Descoperă lumea jocului"
    },
    "template.baby-store.home.storyTitle": {
        "cs": "Každý den přináší nový nápad ke hře",
        "sk": "Každý deň prináša nový nápad na hru",
        "en": "Every day brings a new idea for play",
        "de": "Jeder Tag bringt eine neue Spielidee",
        "es": "Cada día trae una nueva idea para jugar",
        "pl": "Każdy dzień przynosi nowy pomysł na zabawę",
        "hu": "Minden nap új játékötletet hoz",
        "ro": "Fiecare zi aduce o nouă idee de joacă"
    },
    "template.baby-store.home.storyBody": {
        "cs": "Přehledné výběry propojují pohyb, fantazii, učení i klidné chvíle, aby si každé dítě našlo svou oblíbenou zábavu.",
        "sk": "Prehľadné výbery prepájajú pohyb, fantáziu, učenie aj pokojné chvíle, aby si každé dieťa našlo svoju obľúbenú zábavu.",
        "en": "Clear collections connect movement, imagination, learning and quiet moments, so every child can find a favorite activity.",
        "de": "Übersichtliche Kollektionen verbinden Bewegung, Fantasie, Lernen und ruhige Momente, damit jedes Kind seine Lieblingsbeschäftigung findet.",
        "es": "Colecciones claras conectan movimiento, imaginación, aprendizaje y momentos tranquilos para que cada niño encuentre su actividad favorita.",
        "pl": "Przejrzyste kolekcje łączą ruch, wyobraźnię, naukę i spokojne chwile, aby każde dziecko znalazło ulubione zajęcie.",
        "hu": "Átlátható válogatások kapcsolják össze a mozgást, a képzeletet, a tanulást és a nyugodt pillanatokat, hogy minden gyermek megtalálja kedvenc elfoglaltságát.",
        "ro": "Colecțiile clare reunesc mișcarea, imaginația, învățarea și momentele liniștite, astfel încât fiecare copil să-și găsească activitatea preferată."
    },
    "template.baby-store.home.heroAlt": {
        "cs": "Veselé dítě objevující barevný svět her a tvoření",
        "sk": "Veselé dieťa objavujúce farebný svet hier a tvorenia",
        "en": "Happy child exploring a colorful world of play and creativity",
        "de": "Fröhliches Kind in einer bunten Welt voller Spiel und Kreativität",
        "es": "Niño feliz explorando un mundo colorido de juego y creatividad",
        "pl": "Radosne dziecko odkrywające kolorowy świat zabawy i kreatywności",
        "hu": "Vidám gyermek a játék és kreativitás színes világában",
        "ro": "Copil vesel explorând o lume colorată de joacă și creativitate"
    },
    "template.baby-store.home.editorialAlt": {
        "cs": "Barevné hračky a tvořivé potřeby připravené pro dětské dobrodružství",
        "sk": "Farebné hračky a tvorivé potreby pripravené na detské dobrodružstvo",
        "en": "Colorful toys and creative supplies ready for a child's adventure",
        "de": "Buntes Spielzeug und Kreativmaterial für ein Kinderabenteuer",
        "es": "Juguetes de colores y materiales creativos listos para una aventura infantil",
        "pl": "Kolorowe zabawki i materiały kreatywne gotowe na dziecięcą przygodę",
        "hu": "Színes játékok és kreatív eszközök egy gyermeki kalandhoz",
        "ro": "Jucării colorate și materiale creative pregătite pentru o aventură de copil"
    },
    "template.baby-store.chrome.searchPlaceholder": {
        "cs": "Hledat hračku, tvoření nebo věk",
        "sk": "Hľadať hračku, tvorenie alebo vek",
        "en": "Search by toy, activity or age",
        "de": "Nach Spielzeug, Aktivität oder Alter suchen",
        "es": "Buscar por juguete, actividad o edad",
        "pl": "Szukaj zabawki, aktywności lub wieku",
        "hu": "Keresés játék, tevékenység vagy életkor szerint",
        "ro": "Caută după jucărie, activitate sau vârstă"
    },
    "template.baby-store.chrome.promoMessage": {
        "cs": "Místo, kde malé nápady rostou hrou",
        "sk": "Miesto, kde malé nápady rastú hrou",
        "en": "A place where little ideas grow through play",
        "de": "Ein Ort, an dem kleine Ideen spielerisch wachsen",
        "es": "Un lugar donde las pequeñas ideas crecen jugando",
        "pl": "Miejsce, w którym małe pomysły rosną przez zabawę",
        "hu": "Egy hely, ahol a kis ötletek játékkal növekednek",
        "ro": "Un loc unde ideile mici cresc prin joacă"
    },
    "template.baby-store.chrome.promoTag": {
        "cs": "PO–PÁ 9:00–17:00",
        "sk": "PO–PI 9:00–17:00",
        "en": "MON–FRI 9:00–17:00",
        "de": "MO–FR 9:00–17:00",
        "es": "LUN–VIE 9:00–17:00",
        "pl": "PON–PT 9:00–17:00",
        "hu": "H–P 9:00–17:00",
        "ro": "LUN–VIN 9:00–17:00"
    },
    "template.baby-store.chrome.productEyebrow": {
        "cs": "OBLÍBENÉ U MALÝCH OBJEVITELŮ",
        "sk": "OBĽÚBENÉ U MALÝCH OBJAVITEĽOV",
        "en": "LOVED BY LITTLE EXPLORERS",
        "de": "BELIEBT BEI KLEINEN ENTDECKERN",
        "es": "FAVORITOS DE PEQUEÑOS EXPLORADORES",
        "pl": "ULUBIONE PRZEZ MAŁYCH ODKRYWCÓW",
        "hu": "A KIS FELFEDEZŐK KEDVENCEI",
        "ro": "PREFERATELE MICILOR EXPLORATORI"
    },
    "template.baby-store.chrome.productTitle": {
        "cs": "Tvořivé sady pro zvídavé ruce",
        "sk": "Tvorivé sady pre zvedavé ruky",
        "en": "Creative kits for curious hands",
        "de": "Kreativsets für neugierige Hände",
        "es": "Kits creativos para manos curiosas",
        "pl": "Kreatywne zestawy dla ciekawych rąk",
        "hu": "Kreatív készletek kíváncsi kezeknek",
        "ro": "Seturi creative pentru mâini curioase"
    },
    "template.baby-store.chrome.seoTitle": {
        "cs": "Hra, která roste s každou novou dovedností",
        "sk": "Hra, ktorá rastie s každou novou zručnosťou",
        "en": "Play that grows with every new skill",
        "de": "Spiel, das mit jeder neuen Fähigkeit wächst",
        "es": "Juego que crece con cada nueva habilidad",
        "pl": "Zabawa, która rośnie z każdą nową umiejętnością",
        "hu": "Játék, amely minden új készséggel együtt fejlődik",
        "ro": "Joacă ce evoluează cu fiecare abilitate nouă"
    },
    "template.baby-store.chrome.seoBody": {
        "cs": "Věk, zájem a způsob hry jsou vidět u každého produktu.",
        "sk": "Vek, záujem a spôsob hry sú uvedené pri každom produkte.",
        "en": "Age, interests and ways to play are visible on every product.",
        "de": "Alter, Interessen und Spielweise sind bei jedem Produkt sichtbar.",
        "es": "La edad, los intereses y la forma de jugar aparecen en cada producto.",
        "pl": "Wiek, zainteresowania i sposób zabawy są widoczne przy każdym produkcie.",
        "hu": "Az életkor, az érdeklődés és a játék módja minden terméknél látható.",
        "ro": "Vârsta, interesele și felul de a se juca sunt vizibile la fiecare produs."
    },
    "template.baby-store.chrome.seoDetails": {
        "cs": "Pohyb, tvoření, hudba i klidné objevování se propojují v přehledných výběrech. Rodiče snadno poznají, co dítě zabaví dnes a co podpoří jeho další krok.",
        "sk": "Pohyb, tvorenie, hudba aj pokojné objavovanie sa prepájajú v prehľadných výberoch. Rodičia ľahko spoznajú, čo dieťa zabaví dnes a čo podporí jeho ďalší krok.",
        "en": "Movement, making, music and quiet discovery come together in clear collections, helping parents see what will delight a child today and support the next step.",
        "de": "Bewegung, Gestalten, Musik und ruhiges Entdecken kommen in übersichtlichen Kollektionen zusammen. Eltern erkennen schnell, was heute Freude macht und den nächsten Schritt unterstützt.",
        "es": "Movimiento, creación, música y descubrimiento tranquilo se unen en colecciones claras. Las familias ven fácilmente qué ilusiona hoy y qué apoya el siguiente paso.",
        "pl": "Ruch, tworzenie, muzyka i spokojne odkrywanie łączą się w przejrzystych kolekcjach. Rodzice łatwo widzą, co cieszy dziś i wspiera kolejny krok.",
        "hu": "Mozgás, alkotás, zene és nyugodt felfedezés találkozik az átlátható válogatásokban. A szülők könnyen látják, mi okoz örömet ma és mi támogatja a következő lépést.",
        "ro": "Mișcarea, creația, muzica și descoperirea liniștită se întâlnesc în colecții clare. Părinții văd ușor ce aduce bucurie astăzi și ce susține următorul pas."
    },
    "template.baby-store.chrome.newsletterBody": {
        "cs": "Nové tvořivé nápady, hravé výběry a inspirace pro společné chvíle.",
        "sk": "Nové tvorivé nápady, hravé výbery a inšpirácia na spoločné chvíle.",
        "en": "New creative ideas, playful collections and inspiration for time together.",
        "de": "Neue kreative Ideen, spielerische Kollektionen und Inspiration für gemeinsame Zeit.",
        "es": "Nuevas ideas creativas, selecciones de juego e inspiración para compartir tiempo juntos.",
        "pl": "Nowe kreatywne pomysły, kolekcje do zabawy i inspiracje na wspólny czas.",
        "hu": "Új kreatív ötletek, játékos válogatások és inspiráció a közös időhöz.",
        "ro": "Idei creative noi, colecții jucăușe și inspirație pentru timpul petrecut împreună."
    },
    "template.baby-store.chrome.benefitTitle": {
        "cs": "Volná hra plná vlastních nápadů",
        "sk": "Voľná hra plná vlastných nápadov",
        "en": "Open-ended play full of original ideas",
        "de": "Freies Spiel voller eigener Ideen",
        "es": "Juego libre lleno de ideas propias",
        "pl": "Swobodna zabawa pełna własnych pomysłów",
        "hu": "Szabad játék saját ötletekkel",
        "ro": "Joacă liberă plină de idei proprii"
    },
    "template.baby-store.chrome.benefitBody": {
        "cs": "Materiály a témata vybíráme tak, aby děti mohly zkoušet, kombinovat a tvořit po svém.",
        "sk": "Materiály a témy vyberáme tak, aby deti mohli skúšať, kombinovať a tvoriť po svojom.",
        "en": "Materials and themes are chosen so children can experiment, combine and create in their own way.",
        "de": "Materialien und Themen sind so gewählt, dass Kinder selbst ausprobieren, kombinieren und gestalten können.",
        "es": "Los materiales y temas permiten que los niños prueben, combinen y creen a su manera.",
        "pl": "Materiały i tematy pozwalają dzieciom próbować, łączyć i tworzyć po swojemu.",
        "hu": "Az anyagok és témák lehetővé teszik, hogy a gyerekek saját módjukon próbáljanak, kombináljanak és alkossanak.",
        "ro": "Materialele și temele îi lasă pe copii să încerce, să combine și să creeze în felul lor."
    },
    "template.baby-store.chrome.categoryEyebrow": {
        "cs": "PRO POHYB, FANTAZII I UČENÍ",
        "sk": "PRE POHYB, FANTÁZIU AJ UČENIE",
        "en": "FOR MOVEMENT, IMAGINATION AND LEARNING",
        "de": "FÜR BEWEGUNG, FANTASIE UND LERNEN",
        "es": "PARA MOVERSE, IMAGINAR Y APRENDER",
        "pl": "DLA RUCHU, WYOBRAŹNI I NAUKI",
        "hu": "MOZGÁSHOZ, KÉPZELETHEZ ÉS TANULÁSHOZ",
        "ro": "PENTRU MIȘCARE, IMAGINAȚIE ȘI ÎNVĂȚARE"
    },
    "template.baby-store.chrome.footerGuide": {
        "cs": "Průvodce podle věku",
        "sk": "Sprievodca podľa veku",
        "en": "Guide by age",
        "de": "Altersratgeber",
        "es": "Guía por edades",
        "pl": "Przewodnik według wieku",
        "hu": "Életkor szerinti útmutató",
        "ro": "Ghid pe vârste"
    },
    "template.baby-store.chrome.bestsellerTitle": {
        "cs": "Nejoblíbenější hračky",
        "sk": "Najobľúbenejšie hračky",
        "en": "Most-loved toys",
        "de": "Beliebteste Spielzeuge",
        "es": "Juguetes favoritos",
        "pl": "Najbardziej lubiane zabawki",
        "hu": "Legkedveltebb játékok",
        "ro": "Cele mai iubite jucării"
    },
    "template.baby-store.chrome.bestsellerAction": {
        "cs": "Objevit oblíbené",
        "sk": "Objaviť obľúbené",
        "en": "Explore favorites",
        "de": "Favoriten entdecken",
        "es": "Descubrir favoritos",
        "pl": "Odkryj ulubione",
        "hu": "Kedvencek felfedezése",
        "ro": "Descoperă preferatele"
    },
    "template.food-store.home.eyebrow": {
        "cs": "PRÁVĚ V SEZÓNĚ",
        "sk": "PRÁVE V SEZÓNE",
        "en": "IN SEASON NOW",
        "de": "JETZT SAISONAL",
        "es": "AHORA, EN TEMPORADA",
        "pl": "TERAZ W SEZONIE",
        "hu": "MOST VAN SZEZONJA",
        "ro": "ACUM ÎN SEZON"
    },
    "template.food-store.home.title": {
        "cs": "Dobré jídlo začíná tím, odkud přichází.",
        "sk": "Dobré jedlo sa začína tým, odkiaľ pochádza.",
        "en": "Good food starts with where it comes from.",
        "de": "Gutes Essen beginnt mit seiner Herkunft.",
        "es": "La buena comida empieza por su origen.",
        "pl": "Dobre jedzenie zaczyna się od miejsca pochodzenia.",
        "hu": "A jó étel a származásánál kezdődik.",
        "ro": "Mâncarea bună începe cu locul din care provine."
    },
    "template.food-store.home.body": {
        "cs": "Čerstvé suroviny, zásoby do spíže a řešení pro dnešní večeři — s jasným původem i podmínkami doručení.",
        "sk": "Čerstvé suroviny, zásoby do špajze a riešenie na dnešnú večeru — s jasným pôvodom aj podmienkami doručenia.",
        "en": "Fresh produce, pantry staples and tonight's dinner, with clear provenance and delivery terms.",
        "de": "Frische Lebensmittel, Vorräte für die Speisekammer und Ideen für das heutige Abendessen – mit klarer Herkunft und transparenten Lieferbedingungen.",
        "es": "Productos frescos, básicos de despensa y la cena de hoy, con información clara sobre su origen y las condiciones de entrega.",
        "pl": "Świeże produkty, zapasy do spiżarni i pomysł na dzisiejszą kolację — z jasną informacją o pochodzeniu i warunkach dostawy.",
        "hu": "Friss alapanyagok, kamrai alaptermékek és ötletek a mai vacsorához – egyértelmű származással és szállítási feltételekkel.",
        "ro": "Produse proaspete, alimente de bază pentru cămară și cina din această seară, cu origine și condiții de livrare prezentate clar."
    },
    "template.food-store.home.action": {
        "cs": "Nakoupit sezonní výběr",
        "sk": "Nakúpiť sezónny výber",
        "en": "Shop the seasonal edit",
        "de": "Saisonale Auswahl einkaufen",
        "es": "Comprar la selección de temporada",
        "pl": "Kup produkty sezonowe",
        "hu": "Szezonális válogatás vásárlása",
        "ro": "Descoperă selecția de sezon"
    },
    "template.food-store.home.storyTitle": {
        "cs": "Od producenta rovnou do košíku",
        "sk": "Od producenta rovno do košíka",
        "en": "From the producer straight to the basket",
        "de": "Direkt vom Erzeuger in den Warenkorb",
        "es": "Del productor directamente a tu cesta",
        "pl": "Od producenta prosto do koszyka",
        "hu": "A termelőtől egyenesen a kosárba",
        "ro": "De la producător direct în coș"
    },
    "template.food-store.home.storyBody": {
        "cs": "Původ, čerstvost, alergeny a tipy na přípravu zůstávají propojené s konkrétním produktem.",
        "sk": "Pôvod, čerstvosť, alergény a tipy na prípravu zostávajú prepojené s konkrétnym produktom.",
        "en": "Origin, freshness, allergens and preparation ideas stay connected to each product.",
        "de": "Herkunft, Frische, Allergene und Zubereitungsideen bleiben mit jedem Produkt verknüpft.",
        "es": "El origen, la frescura, los alérgenos y las ideas de preparación acompañan a cada producto.",
        "pl": "Pochodzenie, świeżość, alergeny i pomysły na przygotowanie pozostają powiązane z każdym produktem.",
        "hu": "A származás, a frissesség, az allergének és az elkészítési ötletek minden terméknél együtt maradnak.",
        "ro": "Originea, prospețimea, alergenii și ideile de preparare rămân alături de fiecare produs."
    },
    "template.food-store.home.heroAlt": {
        "cs": "Čerstvá sezonní zelenina a pečivo v moderním farmářském marketu",
        "sk": "Čerstvá sezónna zelenina a pečivo na modernom farmárskom trhu",
        "en": "Fresh seasonal vegetables and bread in a modern farmers market",
        "de": "Frisches saisonales Gemüse und Brot auf einem modernen Bauernmarkt",
        "es": "Verduras de temporada y pan fresco en un mercado agrícola moderno",
        "pl": "Świeże sezonowe warzywa i pieczywo na nowoczesnym targu rolniczym",
        "hu": "Friss szezonális zöldségek és kenyér egy modern termelői piacon",
        "ro": "Legume proaspete de sezon și pâine într-o piață modernă a producătorilor"
    },
    "template.food-store.home.editorialAlt": {
        "cs": "Producent připravující čerstvé potraviny k doručení",
        "sk": "Producent pripravujúci čerstvé potraviny na doručenie",
        "en": "Producer preparing fresh food for delivery",
        "de": "Erzeuger bereitet frische Lebensmittel für die Lieferung vor",
        "es": "Productor preparando alimentos frescos para su entrega",
        "pl": "Producent przygotowujący świeżą żywność do dostawy",
        "hu": "Termelő friss élelmiszert készít elő kiszállításra",
        "ro": "Producător pregătind alimente proaspete pentru livrare"
    },
    "template.food-store.chrome.searchPlaceholder": {
        "cs": "Hledat potravinu, producenta nebo jídlo",
        "sk": "Hľadať potravinu, producenta alebo jedlo",
        "en": "Search by food, producer or meal",
        "de": "Nach Lebensmittel, Erzeuger oder Gericht suchen",
        "es": "Buscar por alimento, productor o plato",
        "pl": "Szukaj według produktu, producenta lub potrawy",
        "hu": "Keresés élelmiszer, termelő vagy fogás szerint",
        "ro": "Caută după aliment, producător sau preparat"
    },
    "template.food-store.chrome.promoMessage": {
        "cs": "Potraviny podle sezóny, původu a dnešního jídla",
        "sk": "Potraviny podľa sezóny, pôvodu a dnešného jedla",
        "en": "Food organized by season, origin and tonight's meal",
        "de": "Lebensmittel nach Saison, Herkunft und heutiger Mahlzeit",
        "es": "Alimentos por temporada, origen y la cena de hoy",
        "pl": "Żywność uporządkowana według sezonu, pochodzenia i pomysłu na dzisiejszy posiłek",
        "hu": "Élelmiszerek szezon, származás és a mai fogás szerint",
        "ro": "Alimente organizate după sezon, origine și masa din această seară"
    },
    "template.food-store.chrome.promoTag": {
        "cs": "PRÁVĚ V SEZÓNĚ",
        "sk": "PRÁVE V SEZÓNE",
        "en": "IN SEASON",
        "de": "JETZT SAISONAL",
        "es": "DE TEMPORADA",
        "pl": "TERAZ W SEZONIE",
        "hu": "SZEZONÁLIS AJÁNLAT",
        "ro": "ÎN SEZON"
    },
    "template.food-store.chrome.productEyebrow": {
        "cs": "SEZÓNNÍ VÝBĚR",
        "sk": "SEZÓNNY VÝBER",
        "en": "SEASONAL EDIT",
        "de": "SAISONALE AUSWAHL",
        "es": "SELECCIÓN DE TEMPORADA",
        "pl": "SEZONOWA SELEKCJA",
        "hu": "SZEZONÁLIS VÁLOGATÁS",
        "ro": "SELECȚIE DE SEZON"
    },
    "template.food-store.chrome.productTitle": {
        "cs": "Suroviny s jasným původem",
        "sk": "Suroviny s jasným pôvodom",
        "en": "Ingredients with a clear origin",
        "de": "Zutaten mit klarer Herkunft",
        "es": "Ingredientes con un origen claro",
        "pl": "Składniki o jasno określonym pochodzeniu",
        "hu": "Alapanyagok egyértelmű származással",
        "ro": "Ingrediente cu origine clară"
    },
    "template.food-store.chrome.seoTitle": {
        "cs": "Původ, složení a doručení bez drobného písma",
        "sk": "Pôvod, zloženie a doručenie bez drobného písma",
        "en": "Origin, ingredients and delivery without the small print",
        "de": "Herkunft, Zutaten und Lieferung ohne Kleingedrucktes",
        "es": "Origen, ingredientes y entrega sin letra pequeña",
        "pl": "Pochodzenie, skład i dostawa bez drobnego druku",
        "hu": "Származás, összetevők és szállítás apró betűs részek nélkül",
        "ro": "Origine, ingrediente și livrare, fără detalii ascunse"
    },
    "template.food-store.chrome.seoBody": {
        "cs": "Čerstvé potraviny i zásoby do spíže mají přehledné informace o původu a alergenech.",
        "sk": "Čerstvé potraviny aj zásoby do špajze majú prehľadné informácie o pôvode a alergénoch.",
        "en": "Fresh food and pantry staples include clear origin and allergen information.",
        "de": "Frische Lebensmittel und Vorräte enthalten klare Angaben zu Herkunft und Allergenen.",
        "es": "Los alimentos frescos y los básicos de despensa incluyen información clara sobre el origen y los alérgenos.",
        "pl": "Świeża żywność i zapasy do spiżarni mają przejrzyste informacje o pochodzeniu i alergenach.",
        "hu": "A friss élelmiszerekhez és a kamrai alaptermékekhez egyértelmű származási és allergéninformációk tartoznak.",
        "ro": "Alimentele proaspete și produsele de bază pentru cămară includ informații clare despre origine și alergeni."
    },
    "template.food-store.chrome.seoDetails": {
        "cs": "Sezónní výběry a tipy na přípravu propojují produkty s konkrétním jídlem. Podmínky skladování a doručení jsou dostupné ještě před objednávkou.",
        "sk": "Sezónne výbery a tipy na prípravu prepájajú produkty s konkrétnym jedlom. Podmienky skladovania a doručenia sú dostupné ešte pred objednávkou.",
        "en": "Seasonal edits and preparation notes connect products with real meals, while storage and delivery conditions are available before ordering.",
        "de": "Saisonale Auswahlen und Zubereitungstipps verbinden Produkte mit konkreten Gerichten. Lager- und Lieferbedingungen sind bereits vor der Bestellung verfügbar.",
        "es": "Las selecciones de temporada y los consejos de preparación conectan los productos con platos reales, mientras que las condiciones de conservación y entrega están disponibles antes de hacer el pedido.",
        "pl": "Sezonowe selekcje i wskazówki dotyczące przygotowania łączą produkty z konkretnymi posiłkami, a warunki przechowywania i dostawy są dostępne przed złożeniem zamówienia.",
        "hu": "A szezonális válogatások és elkészítési tippek valódi fogásokhoz kapcsolják a termékeket. A tárolási és szállítási feltételek már rendelés előtt elérhetők.",
        "ro": "Selecțiile de sezon și sugestiile de preparare leagă produsele de mese reale, iar condițiile de păstrare și livrare sunt disponibile înainte de comandă."
    },
    "template.food-store.chrome.newsletterBody": {
        "cs": "Sezónní suroviny, noví producenti a praktické nápady pro vaření.",
        "sk": "Sezónne suroviny, noví producenti a praktické nápady na varenie.",
        "en": "Seasonal ingredients, new producers and practical cooking ideas.",
        "de": "Saisonale Zutaten, neue Erzeuger und praktische Kochideen.",
        "es": "Ingredientes de temporada, nuevos productores e ideas prácticas para cocinar.",
        "pl": "Sezonowe składniki, nowi producenci i praktyczne pomysły na gotowanie.",
        "hu": "Szezonális alapanyagok, új termelők és praktikus főzési ötletek.",
        "ro": "Ingrediente de sezon, producători noi și idei practice pentru gătit."
    },
    "template.food-store.chrome.benefitTitle": {
        "cs": "Původ, alergeny a zacházení s produktem přehledně",
        "sk": "Pôvod, alergény a zaobchádzanie s produktom prehľadne",
        "en": "Origin, allergens and handling made clear",
        "de": "Herkunft, Allergene und Handhabung klar erklärt",
        "es": "Origen, alérgenos y manipulación explicados con claridad",
        "pl": "Pochodzenie, alergeny i zasady przechowywania podane jasno",
        "hu": "Származás, allergének és kezelés átláthatóan",
        "ro": "Originea, alergenii și manipularea, explicate clar"
    },
    "template.food-store.chrome.benefitBody": {
        "cs": "Důležité informace zůstávají dostupné při výběru i před dokončením objednávky.",
        "sk": "Dôležité informácie zostávajú dostupné pri výbere aj pred dokončením objednávky.",
        "en": "Important information remains available while choosing and before completing the order.",
        "de": "Wichtige Informationen bleiben bei der Auswahl und vor Abschluss der Bestellung verfügbar.",
        "es": "La información importante permanece disponible durante la elección y antes de finalizar el pedido.",
        "pl": "Ważne informacje pozostają dostępne podczas wyboru i przed dokończeniem zamówienia.",
        "hu": "A fontos információk a választás során és a rendelés lezárása előtt is elérhetők maradnak.",
        "ro": "Informațiile importante rămân disponibile în timpul alegerii și înainte de finalizarea comenzii."
    },
    "template.food-store.chrome.categoryEyebrow": {
        "cs": "PODLE SEZÓNY A JÍDLA",
        "sk": "PODĽA SEZÓNY A JEDLA",
        "en": "BY SEASON AND MEAL",
        "de": "NACH SAISON UND MAHLZEIT",
        "es": "POR TEMPORADA Y PLATO",
        "pl": "WEDŁUG SEZONU I POSIŁKU",
        "hu": "SZEZON ÉS ÉTKEZÉS SZERINT",
        "ro": "DUPĂ SEZON ȘI PREPARAT"
    },
    "template.food-store.chrome.footerGuide": {
        "cs": "Doručení a čerstvost",
        "sk": "Doručenie a čerstvosť",
        "en": "Delivery and freshness",
        "de": "Lieferung und Frische",
        "es": "Entrega y frescura",
        "pl": "Dostawa i świeżość",
        "hu": "Szállítás és frissesség",
        "ro": "Livrare și prospețime"
    },
    "template.food-store.chrome.bestsellerTitle": {
        "cs": "Nejprodávanější",
        "sk": "Najpredávanejšie",
        "en": "Best selling",
        "de": "Bestseller",
        "es": "Más vendidos",
        "pl": "Bestsellery",
        "hu": "Legnépszerűbb",
        "ro": "Cele mai vândute"
    },
    "template.food-store.chrome.bestsellerAction": {
        "cs": "Zobrazit produkty",
        "sk": "Zobraziť produkty",
        "en": "Show products",
        "de": "Produkte anzeigen",
        "es": "Mostrar productos",
        "pl": "Pokaż produkty",
        "hu": "Termékek megjelenítése",
        "ro": "Afișați produsele"
    },
    "template.coffee-store.home.eyebrow": {
        "cs": "CURRENT ROAST / 04",
        "sk": "CURRENT ROAST / 04",
        "en": "CURRENT ROAST / 04",
        "de": "CURRENT ROAST / 04",
        "es": "CURRENT ROAST / 04",
        "pl": "CURRENT ROAST / 04",
        "hu": "CURRENT ROAST / 04",
        "ro": "CURRENT ROAST / 04"
    },
    "template.coffee-store.home.title": {
        "cs": "Najděte kávu podle chuti, ne podle obalu.",
        "sk": "Nájdite kávu podľa chuti, nie podľa obalu.",
        "en": "Find coffee by flavor, not by packaging.",
        "de": "Kaffee nach Geschmack finden, nicht nach Verpackung.",
        "es": "Encuentra el café por su sabor, no por el envase.",
        "pl": "Znajdź kawę według smaku, nie opakowania.",
        "hu": "Íz alapján válasszon kávét, ne a csomagolás alapján.",
        "ro": "Găsește cafeaua după gust, nu după ambalaj."
    },
    "template.coffee-store.home.body": {
        "cs": "Původ, zpracování, pražení a metoda přípravy tvoří jeden srozumitelný chuťový profil.",
        "sk": "Pôvod, spracovanie, praženie a spôsob prípravy tvoria jeden zrozumiteľný chuťový profil.",
        "en": "Origin, process, roast and brew method combine into one understandable flavor profile.",
        "de": "Herkunft, Aufbereitung, Röstung und Zubereitungsart ergeben gemeinsam ein verständliches Geschmacksprofil.",
        "es": "El origen, el proceso, el tueste y el método de preparación se combinan en un perfil de sabor fácil de entender.",
        "pl": "Pochodzenie, obróbka, stopień palenia i metoda parzenia składają się na jeden zrozumiały profil smakowy.",
        "hu": "A származás, a feldolgozás, a pörkölés és az elkészítési mód egyetlen érthető ízprofilt alkot.",
        "ro": "Originea, procesarea, prăjirea și metoda de preparare se reunesc într-un profil aromatic ușor de înțeles."
    },
    "template.coffee-store.home.action": {
        "cs": "Projít chuťový profil",
        "sk": "Objaviť chuťový profil",
        "en": "Explore the flavor profile",
        "de": "Geschmacksprofil entdecken",
        "es": "Explorar el perfil de sabor",
        "pl": "Poznaj profil smakowy",
        "hu": "Fedezze fel az ízprofilt",
        "ro": "Descoperă profilul aromatic"
    },
    "template.coffee-store.home.storyTitle": {
        "cs": "Každá sklizeň má svůj záznam",
        "sk": "Každá úroda má svoj záznam",
        "en": "Every harvest has a record",
        "de": "Jede Ernte hat ihren eigenen Steckbrief",
        "es": "Cada cosecha tiene su propia ficha",
        "pl": "Każdy zbiór ma udokumentowaną historię",
        "hu": "Minden szüretnek megvan a saját története",
        "ro": "Fiecare recoltă are un istoric"
    },
    "template.coffee-store.home.storyBody": {
        "cs": "Transparentní původ, recept a čerstvost propojují pražírnu s každým šálkem.",
        "sk": "Transparentný pôvod, recept a čerstvosť prepájajú pražiareň s každou šálkou.",
        "en": "Transparent origin, a brew recipe and freshness connect the roastery to every cup.",
        "de": "Transparente Herkunft, ein Zubereitungsrezept und Frische verbinden die Rösterei mit jeder Tasse.",
        "es": "Un origen transparente, una receta de preparación y la frescura conectan el tostador con cada taza.",
        "pl": "Przejrzyste informacje o pochodzeniu, receptura parzenia i świeżość łączą palarnię z każdą filiżanką.",
        "hu": "Az átlátható származás, az elkészítési recept és a frissesség minden csészét a pörkölőhöz kapcsol.",
        "ro": "Originea transparentă, rețeta de preparare și prospețimea leagă prăjitoria de fiecare ceașcă."
    },
    "template.coffee-store.home.heroAlt": {
        "cs": "Čerstvě pražená výběrová káva a minimalistické balení bez značky",
        "sk": "Čerstvo pražená výberová káva a minimalistické balenie bez značky",
        "en": "Fresh specialty coffee and unbranded minimalist packaging",
        "de": "Frisch gerösteter Spezialitätenkaffee in minimalistischer Verpackung ohne Marke",
        "es": "Café de especialidad recién tostado y envase minimalista sin marca",
        "pl": "Świeżo palona kawa specialty i minimalistyczne opakowanie bez marki",
        "hu": "Frissen pörkölt specialty kávé márkajelzés nélküli minimalista csomagolásban",
        "ro": "Cafea de specialitate proaspăt prăjită și ambalaj minimalist fără marcă"
    },
    "template.coffee-store.home.editorialAlt": {
        "cs": "Barista připravující filtrovanou kávu s přesným receptem",
        "sk": "Barista pripravujúci filtrovanú kávu podľa presného receptu",
        "en": "Barista preparing filter coffee with a precise recipe",
        "de": "Barista bereitet Filterkaffee nach einem präzisen Rezept zu",
        "es": "Barista preparando café de filtro con una receta precisa",
        "pl": "Barista przygotowujący kawę filtrowaną według precyzyjnej receptury",
        "hu": "Barista pontos recept alapján filterkávét készít",
        "ro": "Barista preparând cafea la filtru după o rețetă exactă"
    },
    "template.coffee-store.chrome.searchPlaceholder": {
        "cs": "Hledat kávu, původ nebo metodu přípravy",
        "sk": "Hľadať kávu, pôvod alebo spôsob prípravy",
        "en": "Search by coffee, origin or brew method",
        "de": "Nach Kaffee, Herkunft oder Zubereitungsart suchen",
        "es": "Buscar por café, origen o método de preparación",
        "pl": "Szukaj według kawy, pochodzenia lub metody parzenia",
        "hu": "Keresés kávé, származás vagy elkészítési mód szerint",
        "ro": "Caută după cafea, origine sau metodă de preparare"
    },
    "template.coffee-store.chrome.promoMessage": {
        "cs": "Káva podle chuti, původu a způsobu přípravy",
        "sk": "Káva podľa chuti, pôvodu a spôsobu prípravy",
        "en": "Coffee organized by flavor, origin and brew method",
        "de": "Kaffee nach Geschmack, Herkunft und Zubereitungsart",
        "es": "Cafés organizados por sabor, origen y método de preparación",
        "pl": "Kawy uporządkowane według smaku, pochodzenia i metody parzenia",
        "hu": "Kávé íz, származás és elkészítési mód szerint",
        "ro": "Cafea organizată după gust, origine și metodă de preparare"
    },
    "template.coffee-store.chrome.promoTag": {
        "cs": "CURRENT ROAST",
        "sk": "CURRENT ROAST",
        "en": "CURRENT ROAST",
        "de": "CURRENT ROAST",
        "es": "CURRENT ROAST",
        "pl": "CURRENT ROAST",
        "hu": "CURRENT ROAST",
        "ro": "CURRENT ROAST"
    },
    "template.coffee-store.chrome.productEyebrow": {
        "cs": "AKTUÁLNÍ PRAŽENÍ",
        "sk": "AKTUÁLNE PRAŽENIA",
        "en": "CURRENT ROASTS",
        "de": "AKTUELLE RÖSTUNGEN",
        "es": "TUESTES ACTUALES",
        "pl": "AKTUALNE WYPALENIA",
        "hu": "AKTUÁLIS PÖRKÖLÉSEK",
        "ro": "PRĂJIRI ACTUALE"
    },
    "template.coffee-store.chrome.productTitle": {
        "cs": "Kávy s čitelným chuťovým profilem",
        "sk": "Kávy s čitateľným chuťovým profilom",
        "en": "Coffee with a readable flavor profile",
        "de": "Kaffee mit klarem Geschmacksprofil",
        "es": "Cafés con un perfil de sabor claro",
        "pl": "Kawy z czytelnym profilem smakowym",
        "hu": "Kávék jól érthető ízprofillal",
        "ro": "Cafea cu un profil aromatic ușor de citit"
    },
    "template.coffee-store.chrome.seoTitle": {
        "cs": "Od farmy a zpracování až po recept",
        "sk": "Od farmy a spracovania až po recept",
        "en": "From farm and process to brew recipe",
        "de": "Von Farm und Aufbereitung bis zum Rezept",
        "es": "De la finca y el proceso a la receta de preparación",
        "pl": "Od plantacji i obróbki po recepturę parzenia",
        "hu": "A termőhelytől és feldolgozástól az elkészítési receptig",
        "ro": "De la fermă și procesare la rețeta de preparare"
    },
    "template.coffee-store.chrome.seoBody": {
        "cs": "Původ, odrůda, zpracování a pražení tvoří srozumitelný profil každé kávy.",
        "sk": "Pôvod, odroda, spracovanie a praženie tvoria zrozumiteľný profil každej kávy.",
        "en": "Origin, variety, processing and roast form a clear profile for every coffee.",
        "de": "Herkunft, Sorte, Aufbereitung und Röstung ergeben ein klares Profil für jeden Kaffee.",
        "es": "El origen, la variedad, el proceso y el tueste crean un perfil claro para cada café.",
        "pl": "Pochodzenie, odmiana, obróbka i stopień palenia tworzą czytelny profil każdej kawy.",
        "hu": "A származás, a fajta, a feldolgozás és a pörkölés minden kávénak egyértelmű profilt ad.",
        "ro": "Originea, varietatea, procesarea și prăjirea formează un profil clar pentru fiecare cafea."
    },
    "template.coffee-store.chrome.seoDetails": {
        "cs": "Doporučené metody přípravy a přesné recepty pomáhají převést chuťový popis do výsledného šálku. Datum pražení a dostupné varianty zůstávají snadno dohledatelné.",
        "sk": "Odporúčané spôsoby prípravy a presné recepty pomáhajú preniesť chuťový opis do výslednej šálky. Dátum praženia a dostupné varianty zostávajú ľahko dohľadateľné.",
        "en": "Recommended brew methods and precise recipes turn flavor notes into a real cup, with roast information and variants easy to find.",
        "de": "Empfohlene Zubereitungsarten und präzise Rezepte machen Geschmacksnoten in der Tasse erlebbar. Röstdatum und Varianten sind leicht zu finden.",
        "es": "Los métodos recomendados y las recetas precisas convierten las notas de cata en una taza real, con la información de tueste y las variantes siempre fáciles de encontrar.",
        "pl": "Zalecane metody parzenia i precyzyjne receptury przekładają nuty smakowe na gotową filiżankę, a informacje o dacie palenia i dostępnych wariantach są łatwe do znalezienia.",
        "hu": "Az ajánlott elkészítési módok és pontos receptek az ízjegyeket valódi csészeélménnyé teszik. A pörkölési adatok és a változatok könnyen megtalálhatók.",
        "ro": "Metodele de preparare recomandate și rețetele exacte transformă notele aromatice într-o ceașcă reală, iar informațiile despre prăjire și variante sunt ușor de găsit."
    },
    "template.coffee-store.chrome.newsletterBody": {
        "cs": "Aktuální sklizně, nové pražení a recepty pro různé metody.",
        "sk": "Aktuálne zbery, nové praženia a recepty pre rôzne spôsoby prípravy.",
        "en": "Current harvests, new roasts and recipes for different methods.",
        "de": "Aktuelle Ernten, neue Röstungen und Rezepte für verschiedene Zubereitungsarten.",
        "es": "Cosechas actuales, nuevos tuestes y recetas para distintos métodos.",
        "pl": "Aktualne zbiory, nowe wypalenia i receptury dla różnych metod parzenia.",
        "hu": "Aktuális szüretek, új pörkölések és receptek különböző elkészítési módokhoz.",
        "ro": "Recolte actuale, prăjiri noi și rețete pentru metode diferite."
    },
    "template.coffee-store.chrome.benefitTitle": {
        "cs": "Původ, profil a recept v jednom záznamu",
        "sk": "Pôvod, profil a recept v jednom zázname",
        "en": "Origin, profile and recipe in one record",
        "de": "Herkunft, Profil und Rezept in einem Steckbrief",
        "es": "Origen, perfil y receta en una sola ficha",
        "pl": "Pochodzenie, profil i receptura w jednej karcie",
        "hu": "Származás, profil és recept egy helyen",
        "ro": "Origine, profil și rețetă într-o singură fișă"
    },
    "template.coffee-store.chrome.benefitBody": {
        "cs": "Každá káva může ukázat cestu od zpracování až po doporučenou přípravu.",
        "sk": "Každá káva môže ukázať cestu od spracovania až po odporúčanú prípravu.",
        "en": "Every coffee can show its path from processing to the recommended brew.",
        "de": "Jeder Kaffee zeigt seinen Weg von der Aufbereitung bis zur empfohlenen Zubereitung.",
        "es": "Cada café puede mostrar su recorrido desde el proceso hasta la preparación recomendada.",
        "pl": "Każda kawa może pokazać swoją drogę od obróbki po zalecaną metodę parzenia.",
        "hu": "Minden kávé bemutathatja az útját a feldolgozástól az ajánlott elkészítésig.",
        "ro": "Fiecare cafea își poate arăta parcursul de la procesare la prepararea recomandată."
    },
    "template.coffee-store.chrome.categoryEyebrow": {
        "cs": "PODLE CHUTI A PŘÍPRAVY",
        "sk": "PODĽA CHUTI A PRÍPRAVY",
        "en": "BY FLAVOR AND BREW",
        "de": "NACH GESCHMACK UND ZUBEREITUNG",
        "es": "POR SABOR Y PREPARACIÓN",
        "pl": "WEDŁUG SMAKU I METODY PARZENIA",
        "hu": "ÍZ ÉS ELKÉSZÍTÉS SZERINT",
        "ro": "DUPĂ AROMĂ ȘI METODĂ DE PREPARARE"
    },
    "template.coffee-store.chrome.footerGuide": {
        "cs": "Průvodce přípravou",
        "sk": "Sprievodca prípravou",
        "en": "Brewing guide",
        "de": "Zubereitungsratgeber",
        "es": "Guía de preparación",
        "pl": "Przewodnik po parzeniu",
        "hu": "Elkészítési útmutató",
        "ro": "Ghid de preparare"
    },
    "template.wellness-supplements.home.eyebrow": {
        "cs": "RUTINA / SLOŽENÍ / DŮKAZY",
        "sk": "RUTINA / ZLOŽENIE / DÔKAZY",
        "en": "ROUTINE / LABEL / EVIDENCE",
        "de": "ROUTINE / ETIKETT / NACHWEISE",
        "es": "RUTINA / ETIQUETA / EVIDENCIA",
        "pl": "RUTYNA / ETYKIETA / DOWODY",
        "hu": "RUTIN / CÍMKE / BIZONYÍTÉKOK",
        "ro": "RUTINĂ / ETICHETĂ / DOVEZI"
    },
    "template.wellness-supplements.home.title": {
        "cs": "Wellness bez mlhy kolem etikety.",
        "sk": "Wellness bez hmly okolo etikety.",
        "en": "Wellness without the fog around the label.",
        "de": "Wellness ohne Unklarheiten rund ums Etikett.",
        "es": "Bienestar sin confusión en la etiqueta.",
        "pl": "Wellness bez niejasności na etykiecie.",
        "hu": "Wellness a címkék körüli homály nélkül.",
        "ro": "Wellness fără confuzia din jurul etichetei."
    },
    "template.wellness-supplements.home.body": {
        "cs": "Přesné složení, dávkování, testování a vhodnost pro konkrétní cíl vysvětlujeme bez léčebných slibů.",
        "sk": "Presné zloženie, dávkovanie, testovanie a vhodnosť pre konkrétny cieľ vysvetľujeme bez liečebných sľubov.",
        "en": "Exact ingredients, dosage, testing and suitability are explained without medical cure claims.",
        "de": "Genaue Inhaltsstoffe, Dosierung, Prüfungen und Eignung werden ohne Heilversprechen erklärt.",
        "es": "Explicamos con precisión los ingredientes, la dosis, las pruebas y para quién es adecuado, sin afirmaciones terapéuticas.",
        "pl": "Dokładny skład, dawkowanie, badania i informacje o tym, dla kogo produkt jest odpowiedni, wyjaśniamy bez obietnic działania leczniczego.",
        "hu": "A pontos összetevőket, az adagolást, a bevizsgálást és az alkalmasságot gyógyhatást ígérő állítások nélkül magyarázzuk el.",
        "ro": "Compoziția exactă, dozajul, testarea și recomandările de utilizare sunt explicate fără promisiuni medicale de vindecare."
    },
    "template.wellness-supplements.home.action": {
        "cs": "Sestavit rutinu",
        "sk": "Zostaviť rutinu",
        "en": "Build a routine",
        "de": "Routine zusammenstellen",
        "es": "Crear una rutina",
        "pl": "Zbuduj rutynę",
        "hu": "Állítson össze egy rutint",
        "ro": "Construiește o rutină"
    },
    "template.wellness-supplements.home.storyTitle": {
        "cs": "Každá složka má dohledatelný důvod",
        "sk": "Každá zložka má dohľadateľný dôvod",
        "en": "Every ingredient has a traceable reason",
        "de": "Jeder Inhaltsstoff hat einen nachvollziehbaren Grund",
        "es": "Cada ingrediente tiene una razón verificable",
        "pl": "Każdy składnik ma uzasadnienie, które można sprawdzić",
        "hu": "Minden összetevő szerepe nyomon követhető",
        "ro": "Fiecare ingredient are un motiv care poate fi verificat"
    },
    "template.wellness-supplements.home.storyBody": {
        "cs": "Původ, množství, certifikace a bezpečnostní informace jsou dostupné dřív než nákupní tlačítko.",
        "sk": "Pôvod, množstvo, certifikácie a bezpečnostné informácie sú dostupné skôr než nákupné tlačidlo.",
        "en": "Origin, quantity, certifications and safety information are available before purchase.",
        "de": "Herkunft, Menge, Zertifizierungen und Sicherheitshinweise sind vor dem Kauf verfügbar.",
        "es": "El origen, la cantidad, las certificaciones y la información de seguridad están disponibles antes de comprar.",
        "pl": "Informacje o pochodzeniu, ilości, certyfikatach i bezpieczeństwie są dostępne jeszcze przed zakupem.",
        "hu": "A származás, a mennyiség, a tanúsítványok és a biztonsági információk már vásárlás előtt elérhetők.",
        "ro": "Originea, cantitatea, certificările și informațiile de siguranță sunt disponibile înainte de cumpărare."
    },
    "template.wellness-supplements.home.heroAlt": {
        "cs": "Čistá kompozice wellness doplňků s transparentním složením",
        "sk": "Čistá kompozícia wellness doplnkov s transparentným zložením",
        "en": "Clean composition of wellness supplements with transparent ingredients",
        "de": "Klare Komposition von Wellness-Nahrungsergänzungen mit transparenten Inhaltsstoffen",
        "es": "Composición limpia de complementos para el bienestar con ingredientes claramente identificados",
        "pl": "Czysta kompozycja suplementów wellness z przejrzyście opisanym składem",
        "hu": "Wellnesscélú étrend-kiegészítők letisztult kompozíciója átlátható összetevőkkel",
        "ro": "Compoziție curată de suplimente wellness, cu ingrediente prezentate transparent"
    },
    "template.wellness-supplements.home.editorialAlt": {
        "cs": "Laboratorně přesné suroviny a kontrola kvality doplňků stravy",
        "sk": "Laboratórne presné suroviny a kontrola kvality výživových doplnkov",
        "en": "Precisely measured ingredients and quality control for supplements",
        "de": "Präzise abgemessene Inhaltsstoffe und Qualitätskontrolle für Nahrungsergänzungsmittel",
        "es": "Ingredientes medidos con precisión y control de calidad de complementos",
        "pl": "Precyzyjnie odmierzone składniki i kontrola jakości suplementów",
        "hu": "Pontosan kimért összetevők és étrend-kiegészítők minőség-ellenőrzése",
        "ro": "Ingrediente măsurate cu precizie și controlul calității pentru suplimente"
    },
    "template.wellness-supplements.chrome.searchPlaceholder": {
        "cs": "Hledat složku, rutinu nebo produkt",
        "sk": "Hľadať zložku, rutinu alebo produkt",
        "en": "Search by ingredient, routine or product",
        "de": "Nach Inhaltsstoff, Routine oder Produkt suchen",
        "es": "Buscar por ingrediente, rutina o producto",
        "pl": "Szukaj według składnika, rutyny lub produktu",
        "hu": "Keresés összetevő, rutin vagy termék szerint",
        "ro": "Caută după ingredient, rutină sau produs"
    },
    "template.wellness-supplements.chrome.promoMessage": {
        "cs": "Doplňky podle složení, rutiny a způsobu užívání",
        "sk": "Doplnky podľa zloženia, rutiny a spôsobu užívania",
        "en": "Supplements organized by ingredients, routine and use",
        "de": "Nahrungsergänzungen nach Inhaltsstoffen, Routine und Anwendung",
        "es": "Complementos organizados por ingredientes, rutina y forma de uso",
        "pl": "Suplementy uporządkowane według składników, rutyny i zastosowania",
        "hu": "Étrend-kiegészítők összetevők, rutin és használat szerint",
        "ro": "Suplimente organizate după ingrediente, rutină și utilizare"
    },
    "template.wellness-supplements.chrome.promoTag": {
        "cs": "ČÍST ETIKETU",
        "sk": "ČÍTAŤ ETIKETU",
        "en": "READ THE LABEL",
        "de": "ETIKETT LESEN",
        "es": "LEE LA ETIQUETA",
        "pl": "CZYTAJ ETYKIETĘ",
        "hu": "OLVASSA EL A CÍMKÉT",
        "ro": "CITEȘTE ETICHETA"
    },
    "template.wellness-supplements.chrome.productEyebrow": {
        "cs": "SESTAVIT RUTINU",
        "sk": "ZOSTAVIŤ RUTINU",
        "en": "BUILD A ROUTINE",
        "de": "ROUTINE ZUSAMMENSTELLEN",
        "es": "CREA UNA RUTINA",
        "pl": "ZBUDUJ RUTYNĘ",
        "hu": "ÁLLÍTSON ÖSSZE EGY RUTINT",
        "ro": "CONSTRUIEȘTE O RUTINĂ"
    },
    "template.wellness-supplements.chrome.productTitle": {
        "cs": "Složení, kterému lze rozumět",
        "sk": "Zloženie, ktorému možno rozumieť",
        "en": "Ingredients made understandable",
        "de": "Verständlich erklärte Inhaltsstoffe",
        "es": "Ingredientes fáciles de entender",
        "pl": "Składniki wyjaśnione w zrozumiały sposób",
        "hu": "Érthetően bemutatott összetevők",
        "ro": "Ingrediente explicate pe înțelesul tuturor"
    },
    "template.wellness-supplements.chrome.seoTitle": {
        "cs": "Přesné složení bez léčebných slibů",
        "sk": "Presné zloženie bez liečebných sľubov",
        "en": "Exact ingredients without treatment claims",
        "de": "Genaue Inhaltsstoffe ohne Heilversprechen",
        "es": "Ingredientes exactos, sin afirmaciones terapéuticas",
        "pl": "Dokładny skład bez obietnic leczenia",
        "hu": "Pontos összetevők gyógyhatásra utaló ígéretek nélkül",
        "ro": "Ingrediente exacte, fără promisiuni de tratament"
    },
    "template.wellness-supplements.chrome.seoBody": {
        "cs": "Množství, dávkování, testování a vhodnost jsou součástí každého produktového záznamu.",
        "sk": "Množstvo, dávkovanie, testovanie a vhodnosť sú súčasťou každého produktového záznamu.",
        "en": "Amounts, dosage, testing and suitability are part of every product record.",
        "de": "Mengen, Dosierung, Prüfungen und Eignung gehören zu jeder Produktinformation.",
        "es": "Las cantidades, la dosis, las pruebas y la idoneidad forman parte de la ficha de cada producto.",
        "pl": "Ilości, dawkowanie, badania i informacje o tym, dla kogo produkt jest odpowiedni, są częścią każdej karty produktu.",
        "hu": "A mennyiségek, az adagolás, a bevizsgálás és az alkalmasság minden termékleírás része.",
        "ro": "Cantitățile, dozajul, testarea și recomandările de utilizare fac parte din fișa fiecărui produs."
    },
    "template.wellness-supplements.chrome.seoDetails": {
        "cs": "Produkty lze porovnávat podle konkrétních složek a místa v rutině. Bezpečnostní informace a upozornění zůstávají viditelné před nákupem.",
        "sk": "Produkty možno porovnávať podľa konkrétnych zložiek a miesta v rutine. Bezpečnostné informácie a upozornenia zostávajú viditeľné pred nákupom.",
        "en": "Products can be compared by exact ingredients and place in a routine, with safety information and notices visible before purchase.",
        "de": "Produkte lassen sich anhand genauer Inhaltsstoffe und ihrer Rolle in einer Routine vergleichen. Sicherheitshinweise und Warnungen bleiben vor dem Kauf sichtbar.",
        "es": "Los productos pueden compararse por sus ingredientes exactos y su lugar en una rutina, con la información y las advertencias de seguridad visibles antes de comprar.",
        "pl": "Produkty można porównywać według dokładnego składu i miejsca w rutynie, a informacje oraz ostrzeżenia dotyczące bezpieczeństwa są widoczne przed zakupem.",
        "hu": "A termékek pontos összetételük és a rutinban betöltött helyük alapján hasonlíthatók össze. A biztonsági információk és figyelmeztetések vásárlás előtt is láthatók.",
        "ro": "Produsele pot fi comparate după ingredientele exacte și locul lor într-o rutină, iar informațiile de siguranță și avertismentele sunt vizibile înainte de cumpărare."
    },
    "template.wellness-supplements.chrome.newsletterBody": {
        "cs": "Nové složení, praktické rutiny a srozumitelné informace z etiket.",
        "sk": "Nové receptúry, praktické rutiny a zrozumiteľné informácie z etikiet.",
        "en": "New formulas, practical routines and understandable label information.",
        "de": "Neue Rezepturen, praktische Routinen und verständliche Informationen vom Etikett.",
        "es": "Nuevas fórmulas, rutinas prácticas e información clara sobre las etiquetas.",
        "pl": "Nowe formuły, praktyczne rutyny i zrozumiałe informacje z etykiet.",
        "hu": "Új formulák, praktikus rutinok és közérthető információk a címkékről.",
        "ro": "Formule noi, rutine practice și informații ușor de înțeles de pe etichetă."
    },
    "template.wellness-supplements.chrome.benefitTitle": {
        "cs": "Množství, dávkování a testování na jednom místě",
        "sk": "Množstvo, dávkovanie a testovanie na jednom mieste",
        "en": "Amounts, dosage and testing in one place",
        "de": "Mengen, Dosierung und Prüfungen an einem Ort",
        "es": "Cantidades, dosis y pruebas en un solo lugar",
        "pl": "Ilości, dawkowanie i badania w jednym miejscu",
        "hu": "Mennyiségek, adagolás és bevizsgálás egy helyen",
        "ro": "Cantități, dozaj și testare într-un singur loc"
    },
    "template.wellness-supplements.chrome.benefitBody": {
        "cs": "Transparentní produktové informace pomáhají porovnat varianty bez zjednodušujících zdravotních tvrzení.",
        "sk": "Transparentné produktové informácie pomáhajú porovnať varianty bez zjednodušujúcich zdravotných tvrdení.",
        "en": "Transparent product information supports comparison without simplistic health claims.",
        "de": "Transparente Produktinformationen ermöglichen Vergleiche ohne vereinfachende Gesundheitsversprechen.",
        "es": "La información transparente de cada producto facilita la comparación sin afirmaciones simplistas sobre la salud.",
        "pl": "Przejrzyste informacje o produkcie ułatwiają porównanie bez uproszczonych obietnic zdrowotnych.",
        "hu": "Az átlátható termékinformációk leegyszerűsítő egészségügyi állítások nélkül segítik az összehasonlítást.",
        "ro": "Informațiile transparente despre produse susțin comparația fără afirmații simpliste despre sănătate."
    },
    "template.wellness-supplements.chrome.categoryEyebrow": {
        "cs": "PODLE SLOŽENÍ A RUTINY",
        "sk": "PODĽA ZLOŽENIA A RUTINY",
        "en": "BY INGREDIENT AND ROUTINE",
        "de": "NACH INHALTSSTOFF UND ROUTINE",
        "es": "POR INGREDIENTE Y RUTINA",
        "pl": "WEDŁUG SKŁADNIKA I RUTYNY",
        "hu": "ÖSSZETEVŐ ÉS RUTIN SZERINT",
        "ro": "DUPĂ INGREDIENT ȘI RUTINĂ"
    },
    "template.wellness-supplements.chrome.footerGuide": {
        "cs": "Složení a užívání",
        "sk": "Zloženie a užívanie",
        "en": "Ingredients and use",
        "de": "Inhaltsstoffe und Anwendung",
        "es": "Ingredientes y uso",
        "pl": "Składniki i stosowanie",
        "hu": "Összetevők és használat",
        "ro": "Ingrediente și utilizare"
    },
    "template.electronics-store.home.eyebrow": {
        "cs": "NEW DEVICE / CONNECTED",
        "sk": "NEW DEVICE / CONNECTED",
        "en": "NEW DEVICE / CONNECTED",
        "de": "NEW DEVICE / CONNECTED",
        "es": "NEW DEVICE / CONNECTED",
        "pl": "NEW DEVICE / CONNECTED",
        "hu": "NEW DEVICE / CONNECTED",
        "ro": "NEW DEVICE / CONNECTED"
    },
    "template.electronics-store.home.title": {
        "cs": "Technologie, která zapadá do celého ekosystému.",
        "sk": "Technológia, ktorá zapadá do celého ekosystému.",
        "en": "Technology designed for the whole ecosystem.",
        "de": "Technologie für das gesamte Ökosystem.",
        "es": "Tecnología diseñada para todo el ecosistema.",
        "pl": "Technologia zaprojektowana z myślą o całym ekosystemie.",
        "hu": "Az egész ökoszisztémára tervezett technológia.",
        "ro": "Tehnologie concepută pentru întregul ecosistem."
    },
    "template.electronics-store.home.body": {
        "cs": "Porovnejte hlavní parametry, použití a kompatibilitu bez marketingového šumu. Příslušenství i podpora navazují přirozeně.",
        "sk": "Porovnajte hlavné parametre, použitie a kompatibilitu bez marketingového šumu. Príslušenstvo aj podpora prirodzene nadväzujú.",
        "en": "Compare key specifications, uses and compatibility without marketing noise. Accessories and support follow naturally.",
        "de": "Vergleichen Sie wichtige technische Daten, Einsatzzwecke und Kompatibilität ohne Werberauschen. Zubehör und Support schließen nahtlos an.",
        "es": "Compara las especificaciones clave, los usos y la compatibilidad sin ruido publicitario. Los accesorios y la asistencia encajan de forma natural.",
        "pl": "Porównuj kluczowe parametry, zastosowania i kompatybilność bez marketingowego szumu. Akcesoria i wsparcie stanowią naturalne uzupełnienie.",
        "hu": "Hasonlítsa össze a legfontosabb műszaki adatokat, felhasználási módokat és kompatibilitást marketingzaj nélkül. A tartozékok és a támogatás természetesen kapcsolódnak hozzájuk.",
        "ro": "Compară specificațiile esențiale, utilizările și compatibilitatea fără zgomot de marketing. Accesoriile și asistența se leagă firesc."
    },
    "template.electronics-store.home.action": {
        "cs": "Vybrat zařízení",
        "sk": "Vybrať zariadenie",
        "en": "Choose a device",
        "de": "Gerät auswählen",
        "es": "Elegir un dispositivo",
        "pl": "Wybierz urządzenie",
        "hu": "Válasszon készüléket",
        "ro": "Alege un dispozitiv"
    },
    "template.electronics-store.home.storyTitle": {
        "cs": "Parametry převedené do běžného použití",
        "sk": "Parametre premenené na bežné používanie",
        "en": "Specifications translated into everyday use",
        "de": "Technische Daten im Alltag erklärt",
        "es": "Especificaciones traducidas al uso diario",
        "pl": "Parametry przełożone na codzienne użytkowanie",
        "hu": "Műszaki adatok a mindennapi használat nyelvén",
        "ro": "Specificații transformate în utilizări de zi cu zi"
    },
    "template.electronics-store.home.storyBody": {
        "cs": "Výdrž, výkon, připojení a servis ukazujeme ve chvíli, kdy skutečně pomáhají rozhodnout.",
        "sk": "Výdrž, výkon, pripojenie a servis ukazujeme vo chvíli, keď skutočne pomáhajú pri rozhodovaní.",
        "en": "Battery, performance, connections and service appear where they genuinely help a decision.",
        "de": "Akkulaufzeit, Leistung, Anschlüsse und Service erscheinen dort, wo sie die Entscheidung wirklich erleichtern.",
        "es": "La batería, el rendimiento, las conexiones y el servicio aparecen justo donde realmente ayudan a decidir.",
        "pl": "Czas pracy baterii, wydajność, łączność i serwis pojawiają się tam, gdzie naprawdę pomagają podjąć decyzję.",
        "hu": "Az akkumulátor-üzemidő, a teljesítmény, a csatlakozások és a szerviz ott jelennek meg, ahol valóban segítik a döntést.",
        "ro": "Autonomia, performanța, conexiunile și service-ul apar acolo unde ajută cu adevărat la luarea unei decizii."
    },
    "template.electronics-store.home.heroAlt": {
        "cs": "Moderní chytré zařízení v precizní technické produktové scéně",
        "sk": "Moderné inteligentné zariadenie v precíznej technickej produktovej scéne",
        "en": "Modern smart device in a precise technical product scene",
        "de": "Modernes Smart-Gerät in einer präzisen technischen Produktinszenierung",
        "es": "Dispositivo inteligente moderno en una escena de producto técnica y precisa",
        "pl": "Nowoczesne inteligentne urządzenie w precyzyjnie zaaranżowanej scenie produktowej",
        "hu": "Modern okoseszköz precíz technikai termékkompozícióban",
        "ro": "Dispozitiv inteligent modern într-o scenă tehnică de produs, realizată cu precizie"
    },
    "template.electronics-store.home.editorialAlt": {
        "cs": "Detail konstrukce a modulárních součástí elektronického zařízení",
        "sk": "Detail konštrukcie a modulárnych súčastí elektronického zariadenia",
        "en": "Detail of the construction and modular parts of an electronic device",
        "de": "Detailaufnahme der Konstruktion und modularen Bauteile eines elektronischen Geräts",
        "es": "Detalle de la construcción y las piezas modulares de un dispositivo electrónico",
        "pl": "Zbliżenie na konstrukcję i modułowe części urządzenia elektronicznego",
        "hu": "Elektronikus eszköz felépítésének és moduláris alkatrészeinek részlete",
        "ro": "Detaliu al construcției și componentelor modulare ale unui dispozitiv electronic"
    },
    "template.electronics-store.chrome.searchPlaceholder": {
        "cs": "Hledat zařízení, parametr nebo kompatibilitu",
        "sk": "Hľadať zariadenie, parameter alebo kompatibilitu",
        "en": "Search by device, specification or compatibility",
        "de": "Nach Gerät, technischem Merkmal oder Kompatibilität suchen",
        "es": "Buscar por dispositivo, especificación o compatibilidad",
        "pl": "Szukaj według urządzenia, parametru lub kompatybilności",
        "hu": "Keresés készülék, műszaki adat vagy kompatibilitás szerint",
        "ro": "Caută după dispozitiv, specificație sau compatibilitate"
    },
    "template.electronics-store.chrome.promoMessage": {
        "cs": "Zařízení podle použití, parametrů a kompatibility",
        "sk": "Zariadenia podľa použitia, parametrov a kompatibility",
        "en": "Devices organized by use, specifications and compatibility",
        "de": "Geräte nach Einsatz, technischen Daten und Kompatibilität",
        "es": "Dispositivos organizados por uso, especificaciones y compatibilidad",
        "pl": "Urządzenia uporządkowane według zastosowania, parametrów i kompatybilności",
        "hu": "Készülékek felhasználás, műszaki adatok és kompatibilitás szerint",
        "ro": "Dispozitive organizate după utilizare, specificații și compatibilitate"
    },
    "template.electronics-store.chrome.promoTag": {
        "cs": "CONNECTED",
        "sk": "CONNECTED",
        "en": "CONNECTED",
        "de": "CONNECTED",
        "es": "CONNECTED",
        "pl": "CONNECTED",
        "hu": "CONNECTED",
        "ro": "CONNECTED"
    },
    "template.electronics-store.chrome.productEyebrow": {
        "cs": "NOVÁ ZAŘÍZENÍ",
        "sk": "NOVÉ ZARIADENIA",
        "en": "NEW DEVICES",
        "de": "NEUE GERÄTE",
        "es": "NUEVOS DISPOSITIVOS",
        "pl": "NOWE URZĄDZENIA",
        "hu": "ÚJ KÉSZÜLÉKEK",
        "ro": "DISPOZITIVE NOI"
    },
    "template.electronics-store.chrome.productTitle": {
        "cs": "Technologie pro celý ekosystém",
        "sk": "Technológia pre celý ekosystém",
        "en": "Technology for the whole ecosystem",
        "de": "Technologie für das gesamte Ökosystem",
        "es": "Tecnología para todo el ecosistema",
        "pl": "Technologia dla całego ekosystemu",
        "hu": "Technológia az egész ökoszisztémához",
        "ro": "Tehnologie pentru întregul ecosistem"
    },
    "template.electronics-store.chrome.seoTitle": {
        "cs": "Parametry vysvětlené přes reálné použití",
        "sk": "Parametre vysvetlené na reálnom použití",
        "en": "Specifications explained through real use",
        "de": "Technische Daten anhand realer Nutzung erklärt",
        "es": "Especificaciones explicadas mediante usos reales",
        "pl": "Parametry wyjaśnione przez rzeczywiste zastosowania",
        "hu": "Műszaki adatok valós használaton keresztül elmagyarázva",
        "ro": "Specificații explicate prin utilizări reale"
    },
    "template.electronics-store.chrome.seoBody": {
        "cs": "Výkon, výdrž, připojení a kompatibilita jsou připravené pro rychlé srovnání.",
        "sk": "Výkon, výdrž, pripojenie a kompatibilita sú pripravené na rýchle porovnanie.",
        "en": "Performance, battery, connections and compatibility are ready for quick comparison.",
        "de": "Leistung, Akkulaufzeit, Anschlüsse und Kompatibilität lassen sich schnell vergleichen.",
        "es": "El rendimiento, la batería, las conexiones y la compatibilidad se presentan para poder compararlos rápidamente.",
        "pl": "Wydajność, czas pracy baterii, łączność i kompatybilność można szybko porównać.",
        "hu": "A teljesítmény, az akkumulátor-üzemidő, a csatlakozások és a kompatibilitás gyorsan összehasonlíthatók.",
        "ro": "Performanța, bateria, conexiunile și compatibilitatea sunt pregătite pentru o comparație rapidă."
    },
    "template.electronics-store.chrome.seoDetails": {
        "cs": "Produktové rodiny propojují zařízení s příslušenstvím a podporou. Technické údaje zůstávají čitelné a dávají smysl i mimo tabulku parametrů.",
        "sk": "Produktové rodiny prepájajú zariadenia s príslušenstvom a podporou. Technické údaje zostávajú čitateľné a dávajú zmysel aj mimo tabuľky parametrov.",
        "en": "Product families connect devices with accessories and support, while technical details stay readable beyond a specification table.",
        "de": "Produktfamilien verbinden Geräte mit Zubehör und Support. Technische Details bleiben auch außerhalb einer Datentabelle verständlich.",
        "es": "Las familias de productos conectan los dispositivos con sus accesorios y asistencia, mientras que los detalles técnicos siguen siendo claros más allá de una tabla de especificaciones.",
        "pl": "Rodziny produktów łączą urządzenia z akcesoriami i wsparciem, a dane techniczne pozostają czytelne także poza tabelą parametrów.",
        "hu": "A termékcsaládok összekapcsolják a készülékeket a tartozékokkal és a támogatással. A műszaki részletek az adattáblázaton túl is könnyen érthetők maradnak.",
        "ro": "Familiile de produse leagă dispozitivele de accesorii și asistență, iar detaliile tehnice rămân ușor de înțeles și dincolo de un tabel de specificații."
    },
    "template.electronics-store.chrome.newsletterBody": {
        "cs": "Nová zařízení, užitečná srovnání a informace o kompatibilitě.",
        "sk": "Nové zariadenia, užitočné porovnania a informácie o kompatibilite.",
        "en": "New devices, useful comparisons and compatibility information.",
        "de": "Neue Geräte, hilfreiche Vergleiche und Informationen zur Kompatibilität.",
        "es": "Nuevos dispositivos, comparativas útiles e información de compatibilidad.",
        "pl": "Nowe urządzenia, przydatne porównania i informacje o kompatybilności.",
        "hu": "Új készülékek, hasznos összehasonlítások és kompatibilitási információk.",
        "ro": "Dispozitive noi, comparații utile și informații despre compatibilitate."
    },
    "template.electronics-store.chrome.benefitTitle": {
        "cs": "Kompatibilita a servis dřív než objednávka",
        "sk": "Kompatibilita a servis ešte pred objednávkou",
        "en": "Compatibility and service before ordering",
        "de": "Kompatibilität und Service vor der Bestellung",
        "es": "Compatibilidad y servicio antes de hacer el pedido",
        "pl": "Kompatybilność i serwis jeszcze przed zamówieniem",
        "hu": "Kompatibilitás és szerviz már rendelés előtt",
        "ro": "Compatibilitate și service înainte de comandă"
    },
    "template.electronics-store.chrome.benefitBody": {
        "cs": "Příslušenství, připojení a možnosti podpory navazují přímo na konkrétní zařízení.",
        "sk": "Príslušenstvo, pripojenie a možnosti podpory priamo nadväzujú na konkrétne zariadenie.",
        "en": "Accessories, connections and support options stay directly connected to each device.",
        "de": "Zubehör, Anschlüsse und Supportoptionen bleiben direkt mit dem jeweiligen Gerät verknüpft.",
        "es": "Los accesorios, las conexiones y las opciones de asistencia permanecen vinculados directamente a cada dispositivo.",
        "pl": "Akcesoria, możliwości łączności i opcje wsparcia pozostają bezpośrednio powiązane z każdym urządzeniem.",
        "hu": "A tartozékok, csatlakozások és támogatási lehetőségek közvetlenül az adott készülékhez kapcsolódnak.",
        "ro": "Accesoriile, conexiunile și opțiunile de asistență rămân direct legate de fiecare dispozitiv."
    },
    "template.electronics-store.chrome.categoryEyebrow": {
        "cs": "PODLE POUŽITÍ A EKOSYSTÉMU",
        "sk": "PODĽA POUŽITIA A EKOSYSTÉMU",
        "en": "BY USE AND ECOSYSTEM",
        "de": "NACH EINSATZ UND ÖKOSYSTEM",
        "es": "POR USO Y ECOSISTEMA",
        "pl": "WEDŁUG ZASTOSOWANIA I EKOSYSTEMU",
        "hu": "FELHASZNÁLÁS ÉS ÖKOSZISZTÉMA SZERINT",
        "ro": "DUPĂ UTILIZARE ȘI ECOSISTEM"
    },
    "template.electronics-store.chrome.footerGuide": {
        "cs": "Kompatibilita a podpora",
        "sk": "Kompatibilita a podpora",
        "en": "Compatibility and support",
        "de": "Kompatibilität und Support",
        "es": "Compatibilidad y asistencia",
        "pl": "Kompatybilność i wsparcie",
        "hu": "Kompatibilitás és támogatás",
        "ro": "Compatibilitate și asistență"
    },
    "template.electronics-store.chrome.bestsellerTitle": {
        "cs": "Nejprodávanější",
        "sk": "Najpredávanejšie",
        "en": "Best selling",
        "de": "Bestseller",
        "es": "Más vendidos",
        "pl": "Bestsellery",
        "hu": "Legnépszerűbb",
        "ro": "Cele mai vândute"
    },
    "template.electronics-store.chrome.bestsellerAction": {
        "cs": "Zobrazit produkty",
        "sk": "Zobraziť produkty",
        "en": "Show products",
        "de": "Produkte anzeigen",
        "es": "Mostrar productos",
        "pl": "Pokaż produkty",
        "hu": "Termékek megjelenítése",
        "ro": "Afișați produsele"
    },
    "template.one-product-store.home.eyebrow": {
        "cs": "ONE PRODUCT / MANY DAYS",
        "sk": "ONE PRODUCT / MANY DAYS",
        "en": "ONE PRODUCT / MANY DAYS",
        "de": "ONE PRODUCT / MANY DAYS",
        "es": "ONE PRODUCT / MANY DAYS",
        "pl": "ONE PRODUCT / MANY DAYS",
        "hu": "ONE PRODUCT / MANY DAYS",
        "ro": "ONE PRODUCT / MANY DAYS"
    },
    "template.one-product-store.home.title": {
        "cs": "Čerstvý nápoj. Kdekoli. Bez kabelu.",
        "sk": "Čerstvý nápoj. Kdekoľvek. Bez kábla.",
        "en": "A fresh drink. Anywhere. No cable.",
        "de": "Ein frisches Getränk. Überall. Ohne Kabel.",
        "es": "Una bebida fresca. En cualquier lugar. Sin cables.",
        "pl": "Świeży napój. Gdziekolwiek jesteś. Bez kabla.",
        "hu": "Friss ital. Bárhol. Kábel nélkül.",
        "ro": "O băutură proaspătă. Oriunde. Fără cablu."
    },
    "template.one-product-store.home.body": {
        "cs": "Přenosný mixér ukazujeme v reálném použití: výkon, výdrž, čištění, varianty i to, co přesně najdete v balení.",
        "sk": "Prenosný mixér ukazujeme pri reálnom používaní: výkon, výdrž, čistenie, varianty aj to, čo presne nájdete v balení.",
        "en": "The portable blender is shown in real use, including power, battery, cleaning, variants and box contents.",
        "de": "Der tragbare Mixer wird im echten Einsatz gezeigt – mit Leistung, Akkulaufzeit, Reinigung, Varianten und Lieferumfang.",
        "es": "Mostramos la batidora portátil en situaciones reales, incluida su potencia, batería, limpieza, variantes y el contenido de la caja.",
        "pl": "Przenośny blender pokazujemy w rzeczywistym użyciu — od mocy i czasu pracy baterii po czyszczenie, warianty i zawartość opakowania.",
        "hu": "A hordozható turmixgépet valós használat közben mutatjuk be: teljesítmény, üzemidő, tisztítás, változatok és a csomag pontos tartalma.",
        "ro": "Blenderul portabil este prezentat în utilizare reală, inclusiv puterea, bateria, curățarea, variantele și conținutul cutiei."
    },
    "template.one-product-store.home.action": {
        "cs": "Vybrat svou variantu",
        "sk": "Vybrať si svoj variant",
        "en": "Choose your version",
        "de": "Variante auswählen",
        "es": "Elegir tu versión",
        "pl": "Wybierz swój wariant",
        "hu": "Válassza ki a változatot",
        "ro": "Alege-ți varianta"
    },
    "template.one-product-store.home.storyTitle": {
        "cs": "Jeden problém, promyšlené řešení",
        "sk": "Jeden problém, premyslené riešenie",
        "en": "One problem, a considered solution",
        "de": "Ein Problem, eine durchdachte Lösung",
        "es": "Un problema, una solución bien pensada",
        "pl": "Jeden problem, przemyślane rozwiązanie",
        "hu": "Egy probléma, egy átgondolt megoldás",
        "ro": "O problemă, o soluție bine gândită"
    },
    "template.one-product-store.home.storyBody": {
        "cs": "Demonstrace, srovnání a jasné parametry vedou k nákupu bez zbytečného katalogového šumu.",
        "sk": "Ukážky, porovnanie a jasné parametre vedú k nákupu bez zbytočného katalógového šumu.",
        "en": "Demonstrations, comparison and clear specifications lead to purchase without catalog noise.",
        "de": "Anwendungsbeispiele, Vergleiche und klare technische Daten führen ohne unnötiges Katalograuschen zum Kauf.",
        "es": "Las demostraciones, la comparación y unas especificaciones claras conducen a la compra sin el ruido de un catálogo.",
        "pl": "Pokazy działania, porównanie i jasne parametry prowadzą do zakupu bez katalogowego szumu.",
        "hu": "A bemutatók, az összehasonlítások és az egyértelmű műszaki adatok felesleges katalóguszaj nélkül vezetnek a vásárláshoz.",
        "ro": "Demonstrațiile, comparațiile și specificațiile clare conduc spre cumpărare fără zgomotul unui catalog."
    },
    "template.one-product-store.home.heroAlt": {
        "cs": "Prémiový bezdrátový přenosný mixér v čisté produktové scéně",
        "sk": "Prémiový bezdrôtový prenosný mixér v čistej produktovej scéne",
        "en": "Premium cordless portable blender in a clean product scene",
        "de": "Hochwertiger kabelloser tragbarer Mixer in einer klaren Produktinszenierung",
        "es": "Batidora portátil prémium e inalámbrica en una escena de producto limpia",
        "pl": "Bezprzewodowy przenośny blender klasy premium w minimalistycznej aranżacji produktowej",
        "hu": "Prémium vezeték nélküli hordozható turmixgép letisztult termékkompozícióban",
        "ro": "Blender portabil premium, fără fir, într-o scenă de produs aerisită"
    },
    "template.one-product-store.home.editorialAlt": {
        "cs": "Přenosný mixér při přípravě čerstvého nápoje mimo domov",
        "sk": "Prenosný mixér pri príprave čerstvého nápoja mimo domova",
        "en": "Portable blender preparing a fresh drink away from home",
        "de": "Tragbarer Mixer bei der Zubereitung eines frischen Getränks unterwegs",
        "es": "Batidora portátil preparando una bebida fresca fuera de casa",
        "pl": "Przenośny blender przygotowujący świeży napój poza domem",
        "hu": "Hordozható turmixgép friss italt készít otthontól távol",
        "ro": "Blender portabil pregătind o băutură proaspătă departe de casă"
    },
    "template.one-product-store.chrome.searchPlaceholder": {
        "cs": "Hledat parametr, použití nebo příslušenství",
        "sk": "Hľadať parameter, použitie alebo príslušenstvo",
        "en": "Search by specification, use or accessory",
        "de": "Nach technischem Merkmal, Anwendung oder Zubehör suchen",
        "es": "Buscar por especificación, uso o accesorio",
        "pl": "Szukaj według parametru, zastosowania lub akcesorium",
        "hu": "Keresés műszaki adat, felhasználás vagy tartozék szerint",
        "ro": "Caută după specificație, utilizare sau accesoriu"
    },
    "template.one-product-store.chrome.promoMessage": {
        "cs": "Jeden přenosný mixér vysvětlený do posledního detailu",
        "sk": "Jeden prenosný mixér vysvetlený do posledného detailu",
        "en": "One portable blender explained down to the details",
        "de": "Ein tragbarer Mixer bis ins Detail erklärt",
        "es": "Una batidora portátil explicada hasta el último detalle",
        "pl": "Jeden przenośny blender omówiony w każdym szczególe",
        "hu": "Egy hordozható turmixgép az utolsó részletig bemutatva",
        "ro": "Un singur blender portabil, explicat până la ultimul detaliu"
    },
    "template.one-product-store.chrome.promoTag": {
        "cs": "ONE PRODUCT",
        "sk": "ONE PRODUCT",
        "en": "ONE PRODUCT",
        "de": "ONE PRODUCT",
        "es": "ONE PRODUCT",
        "pl": "ONE PRODUCT",
        "hu": "ONE PRODUCT",
        "ro": "ONE PRODUCT"
    },
    "template.one-product-store.chrome.productEyebrow": {
        "cs": "VYBRAT VARIANTU",
        "sk": "VYBRAŤ VARIANT",
        "en": "CHOOSE A VERSION",
        "de": "VARIANTE AUSWÄHLEN",
        "es": "ELIGE UNA VERSIÓN",
        "pl": "WYBIERZ WARIANT",
        "hu": "VÁLASSZON VÁLTOZATOT",
        "ro": "ALEGE O VARIANTĂ"
    },
    "template.one-product-store.chrome.productTitle": {
        "cs": "Přenosný mixér a vše, co k němu patří",
        "sk": "Prenosný mixér a všetko, čo k nemu patrí",
        "en": "The portable blender and everything around it",
        "de": "Der tragbare Mixer und alles, was dazugehört",
        "es": "La batidora portátil y todo lo que la acompaña",
        "pl": "Przenośny blender i wszystko, co do niego pasuje",
        "hu": "A hordozható turmixgép és minden, ami hozzá tartozik",
        "ro": "Blenderul portabil și tot ce ține de el"
    },
    "template.one-product-store.chrome.seoTitle": {
        "cs": "Jeden produkt, žádný katalogový šum",
        "sk": "Jeden produkt, žiadny katalógový šum",
        "en": "One product without catalog noise",
        "de": "Ein Produkt ohne Katalograuschen",
        "es": "Un producto sin ruido de catálogo",
        "pl": "Jeden produkt bez katalogowego szumu",
        "hu": "Egyetlen termék katalóguszaj nélkül",
        "ro": "Un singur produs, fără zgomot de catalog"
    },
    "template.one-product-store.chrome.seoBody": {
        "cs": "Výkon, výdrž, čištění, varianty a obsah balení jsou součástí jednoho souvislého příběhu.",
        "sk": "Výkon, výdrž, čistenie, varianty a obsah balenia sú súčasťou jedného súvislého príbehu.",
        "en": "Power, battery, cleaning, variants and box contents form one continuous product story.",
        "de": "Leistung, Akkulaufzeit, Reinigung, Varianten und Lieferumfang ergeben eine zusammenhängende Produktgeschichte.",
        "es": "La potencia, la batería, la limpieza, las variantes y el contenido de la caja forman una única historia de producto.",
        "pl": "Moc, czas pracy baterii, czyszczenie, warianty i zawartość opakowania tworzą jedną spójną historię produktu.",
        "hu": "A teljesítmény, az üzemidő, a tisztítás, a változatok és a csomag tartalma egyetlen összefüggő terméktörténetet alkot.",
        "ro": "Puterea, bateria, curățarea, variantele și conținutul cutiei formează o singură poveste coerentă a produsului."
    },
    "template.one-product-store.chrome.seoDetails": {
        "cs": "Demonstrace reálného použití navazuje na přesné parametry a porovnání variant. Zákazník tak nemusí skládat důležité informace z několika nesouvisejících stránek.",
        "sk": "Ukážky reálneho používania nadväzujú na presné parametre a porovnanie variantov. Zákazník tak nemusí skladať dôležité informácie z niekoľkých nesúvisiacich stránok.",
        "en": "Real-use demonstrations connect directly to exact specifications and variant comparisons, keeping important information in one coherent place.",
        "de": "Anwendungsbeispiele aus dem Alltag sind direkt mit genauen technischen Daten und Variantenvergleichen verbunden. So bleiben alle wichtigen Informationen an einem stimmigen Ort.",
        "es": "Las demostraciones de uso real enlazan directamente con especificaciones exactas y comparativas de variantes, manteniendo toda la información importante en un único lugar coherente.",
        "pl": "Prezentacje rzeczywistego użycia prowadzą bezpośrednio do dokładnych parametrów i porównania wariantów, dzięki czemu wszystkie ważne informacje pozostają w jednym, spójnym miejscu.",
        "hu": "A valós használatot bemutató példák közvetlenül kapcsolódnak a pontos műszaki adatokhoz és a változatok összehasonlításához. Minden fontos információ egyetlen átlátható helyen marad.",
        "ro": "Demonstrațiile de utilizare reală se leagă direct de specificațiile exacte și comparațiile între variante, păstrând informațiile importante într-un singur loc coerent."
    },
    "template.one-product-store.chrome.newsletterBody": {
        "cs": "Nové recepty, způsoby použití a informace o příslušenství.",
        "sk": "Nové recepty, spôsoby použitia a informácie o príslušenstve.",
        "en": "New recipes, use cases and accessory information.",
        "de": "Neue Rezepte, Anwendungsideen und Informationen zu Zubehör.",
        "es": "Nuevas recetas, formas de uso e información sobre accesorios.",
        "pl": "Nowe przepisy, sposoby użycia i informacje o akcesoriach.",
        "hu": "Új receptek, felhasználási ötletek és tartozékinformációk.",
        "ro": "Rețete noi, moduri de utilizare și informații despre accesorii."
    },
    "template.one-product-store.chrome.benefitTitle": {
        "cs": "Výkon, výdrž a čištění v jednom pohledu",
        "sk": "Výkon, výdrž a čistenie na jednom mieste",
        "en": "Power, battery and cleaning in one view",
        "de": "Leistung, Akkulaufzeit und Reinigung auf einen Blick",
        "es": "Potencia, batería y limpieza de un vistazo",
        "pl": "Moc, bateria i czyszczenie w jednym widoku",
        "hu": "Teljesítmény, üzemidő és tisztítás egy nézetben",
        "ro": "Putere, baterie și curățare într-o singură privire"
    },
    "template.one-product-store.chrome.benefitBody": {
        "cs": "Varianty a obsah balení lze porovnat bez odvádění pozornosti k jinému sortimentu.",
        "sk": "Varianty a obsah balenia možno porovnať bez odvádzania pozornosti na iný sortiment.",
        "en": "Versions and box contents can be compared without distraction from unrelated products.",
        "de": "Varianten und Lieferumfang lassen sich vergleichen, ohne dass andere Produkte ablenken.",
        "es": "Las versiones y el contenido de la caja pueden compararse sin distracciones de productos ajenos.",
        "pl": "Warianty i zawartość opakowania można porównać bez rozpraszania uwagi niepowiązanymi produktami.",
        "hu": "A változatok és a csomag tartalma más termékek zavaró jelenléte nélkül hasonlíthatók össze.",
        "ro": "Variantele și conținutul cutiei pot fi comparate fără ca produsele fără legătură să distragă atenția."
    },
    "template.one-product-store.chrome.categoryEyebrow": {
        "cs": "PRODUKT A PŘÍSLUŠENSTVÍ",
        "sk": "PRODUKT A PRÍSLUŠENSTVO",
        "en": "PRODUCT AND ACCESSORIES",
        "de": "PRODUKT UND ZUBEHÖR",
        "es": "PRODUCTO Y ACCESORIOS",
        "pl": "PRODUKT I AKCESORIA",
        "hu": "TERMÉK ÉS TARTOZÉKOK",
        "ro": "PRODUS ȘI ACCESORII"
    },
    "template.one-product-store.chrome.footerGuide": {
        "cs": "Specifikace a použití",
        "sk": "Špecifikácie a použitie",
        "en": "Specifications and use",
        "de": "Technische Daten und Anwendung",
        "es": "Especificaciones y uso",
        "pl": "Specyfikacja i użytkowanie",
        "hu": "Műszaki adatok és használat",
        "ro": "Specificații și utilizare"
    },
    "template.handmade-store.home.eyebrow": {
        "cs": "MALÁ SÉRIE / RUČNÍ PRÁCE",
        "sk": "MALÁ SÉRIA / RUČNÁ PRÁCA",
        "en": "SMALL BATCH / MADE BY HAND",
        "de": "KLEINSERIE / HANDGEFERTIGT",
        "es": "SERIE CORTA / HECHO A MANO",
        "pl": "KRÓTKA SERIA / RĘCZNA PRACA",
        "hu": "KIS SZÉRIA / KÉZZEL KÉSZÜLT",
        "ro": "SERIE MICĂ / LUCRAT MANUAL"
    },
    "template.handmade-store.home.title": {
        "cs": "Věci, na kterých je vidět ruka autora.",
        "sk": "Veci, na ktorých vidno ruku autora.",
        "en": "Objects that show the hand of their maker.",
        "de": "Objekte, die die Handschrift ihrer Schöpfer tragen.",
        "es": "Objetos en los que se reconoce la mano de quien los crea.",
        "pl": "Przedmioty, na których widać rękę twórcy.",
        "hu": "Tárgyak, amelyek az alkotó keze nyomát viselik.",
        "ro": "Obiecte care poartă amprenta creatorului."
    },
    "template.handmade-store.home.body": {
        "cs": "Materiál, původ, přirozené odchylky a čas výroby jsou součástí produktu — ne poznámka schovaná na konci.",
        "sk": "Materiál, pôvod, prirodzené odchýlky a čas výroby sú súčasťou produktu — nie poznámka ukrytá na konci.",
        "en": "Material, origin, natural variation and making time are part of the product, not a hidden footnote.",
        "de": "Material, Herkunft, natürliche Abweichungen und Fertigungszeit gehören zum Produkt – nicht in eine versteckte Fußnote.",
        "es": "El material, el origen, las variaciones naturales y el tiempo de elaboración forman parte del producto, no de una nota escondida al pie.",
        "pl": "Materiał, pochodzenie, naturalne różnice i czas wykonania są częścią produktu, a nie przypisem ukrytym na końcu.",
        "hu": "Az anyag, a származás, a természetes eltérések és az elkészítési idő a termék részei, nem egy elrejtett lábjegyzet.",
        "ro": "Materialul, originea, variațiile naturale și timpul de realizare fac parte din produs, nu dintr-o notă ascunsă."
    },
    "template.handmade-store.home.action": {
        "cs": "Objevit nové kusy",
        "sk": "Objaviť nové kúsky",
        "en": "Discover new pieces",
        "de": "Neue Stücke entdecken",
        "es": "Descubrir nuevas piezas",
        "pl": "Odkryj nowe przedmioty",
        "hu": "Fedezze fel az új darabokat",
        "ro": "Descoperă piese noi"
    },
    "template.handmade-store.home.storyTitle": {
        "cs": "Od dílny až k bezpečnému balení",
        "sk": "Od dielne až po bezpečné balenie",
        "en": "From the workshop to secure packaging",
        "de": "Von der Werkstatt bis zur sicheren Verpackung",
        "es": "Del taller a un embalaje seguro",
        "pl": "Od pracowni po bezpieczne opakowanie",
        "hu": "A műhelytől a biztonságos csomagolásig",
        "ro": "De la atelier la ambalarea în siguranță"
    },
    "template.handmade-store.home.storyBody": {
        "cs": "Proces, profil autora a péče o výrobek dávají každému malému dropu skutečný kontext.",
        "sk": "Proces, profil autora a starostlivosť o výrobok dávajú každému malému dropu skutočný kontext.",
        "en": "Process, maker profile and product care give every small drop meaningful context.",
        "de": "Herstellungsprozess, Porträt der Schaffenden und Produktpflege geben jeder kleinen Serie einen echten Kontext.",
        "es": "El proceso, el perfil del creador y el cuidado del producto aportan contexto real a cada pequeña serie.",
        "pl": "Proces, profil twórcy i sposób pielęgnacji produktu nadają każdej krótkiej serii prawdziwy kontekst.",
        "hu": "A folyamat, az alkotó bemutatása és a termék ápolása minden kis szériának valódi hátteret ad.",
        "ro": "Procesul, profilul creatorului și îngrijirea produsului oferă fiecărei lansări în serie mică un context relevant."
    },
    "template.handmade-store.home.heroAlt": {
        "cs": "Řemeslník pracující v současné keramické a dřevěné dílně",
        "sk": "Remeselník pracujúci v modernej dielni na keramiku a drevo",
        "en": "Maker working in a contemporary ceramics and wood studio",
        "de": "Handwerker bei der Arbeit in einer modernen Keramik- und Holzwerkstatt",
        "es": "Artesano trabajando en un taller contemporáneo de cerámica y madera",
        "pl": "Twórca pracujący we współczesnej pracowni ceramiki i drewna",
        "hu": "Alkotó dolgozik egy modern kerámia- és faműhelyben",
        "ro": "Artizan lucrând într-un atelier contemporan de ceramică și lemn"
    },
    "template.handmade-store.home.editorialAlt": {
        "cs": "Detail ruční výroby a autentických přírodních materiálů",
        "sk": "Detail ručnej výroby a autentických prírodných materiálov",
        "en": "Detail of handcrafting and authentic natural materials",
        "de": "Detailaufnahme von Handarbeit und authentischen Naturmaterialien",
        "es": "Detalle de elaboración artesanal y materiales naturales auténticos",
        "pl": "Zbliżenie na ręczne wykonanie i autentyczne naturalne materiały",
        "hu": "Kézműves munka és eredeti természetes anyagok részlete",
        "ro": "Detaliu al lucrului manual și al materialelor naturale autentice"
    },
    "template.handmade-store.chrome.searchPlaceholder": {
        "cs": "Hledat výrobek, autora nebo materiál",
        "sk": "Hľadať výrobok, autora alebo materiál",
        "en": "Search by product, maker or material",
        "de": "Nach Produkt, Schaffenden oder Material suchen",
        "es": "Buscar por producto, creador o material",
        "pl": "Szukaj według produktu, twórcy lub materiału",
        "hu": "Keresés termék, alkotó vagy anyag szerint",
        "ro": "Caută după produs, creator sau material"
    },
    "template.handmade-store.chrome.promoMessage": {
        "cs": "Malé série podle autora, materiálu a způsobu výroby",
        "sk": "Malé série podľa autora, materiálu a spôsobu výroby",
        "en": "Small runs organized by maker, material and process",
        "de": "Kleinserien nach Schaffenden, Material und Herstellungsart",
        "es": "Series cortas organizadas por creador, material y proceso",
        "pl": "Krótkie serie uporządkowane według twórcy, materiału i procesu",
        "hu": "Kis szériák alkotó, anyag és készítési folyamat szerint",
        "ro": "Serii mici organizate după creator, material și proces"
    },
    "template.handmade-store.chrome.promoTag": {
        "cs": "RUČNÍ PRÁCE",
        "sk": "RUČNÁ PRÁCA",
        "en": "MADE BY HAND",
        "de": "HANDGEFERTIGT",
        "es": "HECHO A MANO",
        "pl": "WYKONANE RĘCZNIE",
        "hu": "KÉZZEL KÉSZÜLT",
        "ro": "LUCRAT MANUAL"
    },
    "template.handmade-store.chrome.productEyebrow": {
        "cs": "NOVĚ Z DÍLEN",
        "sk": "NOVINKY Z DIELNÍ",
        "en": "NEW FROM THE WORKSHOPS",
        "de": "NEU AUS DEN WERKSTÄTTEN",
        "es": "NOVEDADES DE LOS TALLERES",
        "pl": "NOWOŚCI Z PRACOWNI",
        "hu": "ÚJDONSÁGOK A MŰHELYEKBŐL",
        "ro": "NOUTĂȚI DIN ATELIERE"
    },
    "template.handmade-store.chrome.productTitle": {
        "cs": "Kusy s viditelným rukopisem autora",
        "sk": "Kúsky s viditeľným rukopisom autora",
        "en": "Pieces that show the maker's hand",
        "de": "Stücke mit sichtbarer Handschrift ihrer Schöpfer",
        "es": "Piezas que reflejan la mano de su creador",
        "pl": "Przedmioty noszące ślad ręki twórcy",
        "hu": "Darabok az alkotó felismerhető kézjegyével",
        "ro": "Piese care poartă amprenta creatorului"
    },
    "template.handmade-store.chrome.seoTitle": {
        "cs": "Materiál, původ a přirozená variace",
        "sk": "Materiál, pôvod a prirodzená variácia",
        "en": "Material, origin and natural variation",
        "de": "Material, Herkunft und natürliche Abweichungen",
        "es": "Material, origen y variaciones naturales",
        "pl": "Materiał, pochodzenie i naturalne różnice",
        "hu": "Anyag, származás és természetes eltérések",
        "ro": "Material, origine și variație naturală"
    },
    "template.handmade-store.chrome.seoBody": {
        "cs": "Každý výrobek může ukázat autora, proces, čas výroby i způsob péče.",
        "sk": "Každý výrobok môže ukázať autora, proces, čas výroby aj spôsob starostlivosti.",
        "en": "Every product can show its maker, process, making time and care.",
        "de": "Jedes Produkt kann die Schaffenden, den Prozess, die Fertigungszeit und die richtige Pflege zeigen.",
        "es": "Cada producto puede mostrar quién lo creó, su proceso, el tiempo de elaboración y sus cuidados.",
        "pl": "Przy każdym produkcie można pokazać jego twórcę, proces, czas wykonania i sposób pielęgnacji.",
        "hu": "Minden termék bemutathatja alkotóját, az elkészítés folyamatát, idejét és a megfelelő ápolást.",
        "ro": "Fiecare produs își poate prezenta creatorul, procesul, timpul de realizare și modul de îngrijire."
    },
    "template.handmade-store.chrome.seoDetails": {
        "cs": "Malé série a přirozené odchylky jsou vysvětlené jako součást charakteru produktu. Informace o balení, personalizaci a péči pomáhají nastavit správné očekávání.",
        "sk": "Malé série a prirodzené odchýlky sú vysvetlené ako súčasť charakteru produktu. Informácie o balení, personalizácii a starostlivosti pomáhajú nastaviť správne očakávania.",
        "en": "Small batches and natural variation are explained as part of the product character, with packaging, personalization and care setting clear expectations.",
        "de": "Kleinserien und natürliche Abweichungen werden als Teil des Produktcharakters erklärt. Angaben zu Verpackung, Personalisierung und Pflege schaffen klare Erwartungen.",
        "es": "Las series cortas y las variaciones naturales se explican como parte del carácter del producto, mientras que el embalaje, la personalización y los cuidados establecen expectativas claras.",
        "pl": "Krótkie serie i naturalne różnice są wyjaśnione jako część charakteru produktu, a informacje o opakowaniu, personalizacji i pielęgnacji pomagają jasno określić oczekiwania.",
        "hu": "A kis szériákat és a természetes eltéréseket a termék karakterének részeként magyarázzuk el. A csomagolásról, személyre szabásról és ápolásról szóló információk egyértelmű elvárásokat teremtenek.",
        "ro": "Seriile mici și variațiile naturale sunt explicate ca parte a caracterului produsului, iar ambalarea, personalizarea și îngrijirea stabilesc așteptări clare."
    },
    "template.handmade-store.chrome.newsletterBody": {
        "cs": "Nové malé série, profily autorů a příběhy materiálů.",
        "sk": "Nové malé série, profily autorov a príbehy materiálov.",
        "en": "New small runs, maker profiles and material stories.",
        "de": "Neue Kleinserien, Porträts von Schaffenden und Geschichten zu Materialien.",
        "es": "Nuevas series cortas, perfiles de creadores e historias de materiales.",
        "pl": "Nowe krótkie serie, profile twórców i historie materiałów.",
        "hu": "Új kis szériák, alkotói portrék és anyagtörténetek.",
        "ro": "Serii mici noi, profiluri de creatori și povești despre materiale."
    },
    "template.handmade-store.chrome.benefitTitle": {
        "cs": "Autor, proces a péče přímo u výrobku",
        "sk": "Autor, proces a starostlivosť priamo pri výrobku",
        "en": "Maker, process and care directly with the product",
        "de": "Schaffende, Prozess und Pflege direkt beim Produkt",
        "es": "Creador, proceso y cuidados junto al producto",
        "pl": "Twórca, proces i pielęgnacja bezpośrednio przy produkcie",
        "hu": "Alkotó, folyamat és ápolás közvetlenül a terméknél",
        "ro": "Creatorul, procesul și îngrijirea, direct lângă produs"
    },
    "template.handmade-store.chrome.benefitBody": {
        "cs": "Původ a způsob výroby dávají každému kusu kontext ještě před objednávkou.",
        "sk": "Pôvod a spôsob výroby dávajú každému kúsku kontext ešte pred objednávkou.",
        "en": "Origin and making process give every piece context before ordering.",
        "de": "Herkunft und Herstellungsprozess geben jedem Stück schon vor der Bestellung Kontext.",
        "es": "El origen y el proceso de elaboración dan contexto a cada pieza antes de hacer el pedido.",
        "pl": "Pochodzenie i proces wykonania nadają każdemu przedmiotowi kontekst jeszcze przed złożeniem zamówienia.",
        "hu": "A származás és az elkészítési folyamat már rendelés előtt hátteret ad minden darabnak.",
        "ro": "Originea și procesul de realizare oferă context fiecărei piese înainte de comandă."
    },
    "template.handmade-store.chrome.categoryEyebrow": {
        "cs": "PODLE AUTORA A MATERIÁLU",
        "sk": "PODĽA AUTORA A MATERIÁLU",
        "en": "BY MAKER AND MATERIAL",
        "de": "NACH SCHAFFENDEN UND MATERIAL",
        "es": "POR CREADOR Y MATERIAL",
        "pl": "WEDŁUG TWÓRCY I MATERIAŁU",
        "hu": "ALKOTÓ ÉS ANYAG SZERINT",
        "ro": "DUPĂ CREATOR ȘI MATERIAL"
    },
    "template.handmade-store.chrome.footerGuide": {
        "cs": "Materiály a péče",
        "sk": "Materiály a starostlivosť",
        "en": "Materials and care",
        "de": "Materialien und Pflege",
        "es": "Materiales y cuidados",
        "pl": "Materiały i pielęgnacja",
        "hu": "Anyagok és ápolás",
        "ro": "Materiale și îngrijire"
    },
    "template.b2b-wholesale.home.eyebrow": {
        "cs": "SKU / PARAMETR / DOSTUPNOST",
        "sk": "SKU / PARAMETER / DOSTUPNOSŤ",
        "en": "SKU / SPEC / AVAILABILITY",
        "de": "SKU / SPEZIFIKATION / VERFÜGBARKEIT",
        "es": "SKU / ESPECIFICACIÓN / DISPONIBILIDAD",
        "pl": "SKU / SPECYFIKACJA / DOSTĘPNOŚĆ",
        "hu": "SKU / SPECIFIKÁCIÓ / ELÉRHETŐSÉG",
        "ro": "SKU / SPECIFICAȚIE / DISPONIBILITATE"
    },
    "template.b2b-wholesale.home.title": {
        "cs": "Nákupní pult pro lidi, kteří přesně vědí, co potřebují.",
        "sk": "Nákupný pult pre ľudí, ktorí presne vedia, čo potrebujú.",
        "en": "A procurement desk for people who know exactly what they need.",
        "de": "Eine Beschaffungsplattform für Menschen, die genau wissen, was sie brauchen.",
        "es": "Un área de compras para profesionales que saben exactamente lo que necesitan.",
        "pl": "Strefa zakupów dla profesjonalistów, którzy dokładnie wiedzą, czego potrzebują.",
        "hu": "Beszerzési felület azoknak, akik pontosan tudják, mire van szükségük.",
        "ro": "Un punct de achiziții pentru cei care știu exact de ce au nevoie."
    },
    "template.b2b-wholesale.home.body": {
        "cs": "Vyhledávání podle názvu, dílu nebo kódu vede rovnou k technickým údajům, balení a dostupnosti.",
        "sk": "Vyhľadávanie podľa názvu, dielu alebo kódu vedie priamo k technickým údajom, baleniu a dostupnosti.",
        "en": "Search by name, part or code leads directly to specifications, pack size and availability.",
        "de": "Die Suche nach Name, Bauteil oder Code führt direkt zu technischen Daten, Verpackungseinheit und Verfügbarkeit.",
        "es": "La búsqueda por nombre, pieza o código lleva directamente a las especificaciones, las unidades por paquete y la disponibilidad.",
        "pl": "Wyszukiwanie według nazwy, części lub kodu prowadzi prosto do specyfikacji, wielkości opakowania i dostępności.",
        "hu": "A név, alkatrész vagy kód szerinti keresés közvetlenül a műszaki adatokhoz, a kiszereléshez és az elérhetőséghez vezet.",
        "ro": "Căutarea după nume, piesă sau cod duce direct la specificații, cantitatea per ambalaj și disponibilitate."
    },
    "template.b2b-wholesale.home.action": {
        "cs": "Otevřít technický katalog",
        "sk": "Otvoriť technický katalóg",
        "en": "Open the technical catalog",
        "de": "Technischen Katalog öffnen",
        "es": "Abrir el catálogo técnico",
        "pl": "Otwórz katalog techniczny",
        "hu": "Műszaki katalógus megnyitása",
        "ro": "Deschide catalogul tehnic"
    },
    "template.b2b-wholesale.home.storyTitle": {
        "cs": "Rychlá objednávka bez zbytečných kroků",
        "sk": "Rýchla objednávka bez zbytočných krokov",
        "en": "Fast ordering without unnecessary steps",
        "de": "Schnelle Bestellung ohne unnötige Schritte",
        "es": "Pedidos rápidos sin pasos innecesarios",
        "pl": "Szybkie zamawianie bez zbędnych kroków",
        "hu": "Gyors rendelés felesleges lépések nélkül",
        "ro": "Comenzi rapide, fără pași inutili"
    },
    "template.b2b-wholesale.home.storyBody": {
        "cs": "Kompaktní výpisy, množství, dokumenty a kontakt na podporu drží nákupní proces pohromadě.",
        "sk": "Kompaktné výpisy, množstvá, dokumenty a kontakt na podporu držia nákupný proces pokope.",
        "en": "Compact lists, quantities, documents and expert contact keep procurement together.",
        "de": "Kompakte Listen, Mengenangaben, Dokumente und fachkundige Ansprechpartner bündeln den gesamten Beschaffungsprozess.",
        "es": "Listados compactos, cantidades, documentos y contacto especializado mantienen todo el proceso de compra en un solo lugar.",
        "pl": "Kompaktowe listy, ilości, dokumenty i kontakt z ekspertem skupiają cały proces zaopatrzenia w jednym miejscu.",
        "hu": "A tömör listák, mennyiségek, dokumentumok és a szakértői kapcsolattartó egyben tartják a beszerzési folyamatot.",
        "ro": "Listele compacte, cantitățile, documentele și contactul cu un specialist mențin întregul proces de achiziție într-un singur loc."
    },
    "template.b2b-wholesale.home.heroAlt": {
        "cs": "Přesně uspořádaný profesionální velkoobchodní sklad a technické díly",
        "sk": "Presne usporiadaný profesionálny veľkoobchodný sklad a technické diely",
        "en": "Precisely organized professional wholesale warehouse and technical parts",
        "de": "Präzise organisiertes professionelles Großhandelslager mit technischen Bauteilen",
        "es": "Almacén mayorista profesional y componentes técnicos organizados con precisión",
        "pl": "Precyzyjnie zorganizowany profesjonalny magazyn hurtowy i części techniczne",
        "hu": "Pontosan rendszerezett professzionális nagykereskedelmi raktár és műszaki alkatrészek",
        "ro": "Depozit angro profesional și componente tehnice organizate cu precizie"
    },
    "template.b2b-wholesale.home.editorialAlt": {
        "cs": "Detail označených technických součástek a profesionální expedice",
        "sk": "Detail označených technických súčiastok a profesionálnej expedície",
        "en": "Detail of labeled technical components and professional dispatch",
        "de": "Detailaufnahme gekennzeichneter technischer Komponenten und professioneller Versandabwicklung",
        "es": "Detalle de componentes técnicos etiquetados y expedición profesional",
        "pl": "Zbliżenie na oznaczone elementy techniczne i profesjonalną wysyłkę",
        "hu": "Felcímkézett műszaki alkatrészek és szakszerű expediálás részlete",
        "ro": "Detaliu cu componente tehnice etichetate și expediere profesională"
    },
    "template.b2b-wholesale.chrome.searchPlaceholder": {
        "cs": "Hledat název, díl, SKU nebo parametr",
        "sk": "Hľadať názov, diel, SKU alebo parameter",
        "en": "Search by name, part, SKU or specification",
        "de": "Nach Name, Bauteil, SKU oder Spezifikation suchen",
        "es": "Buscar por nombre, pieza, SKU o especificación",
        "pl": "Szukaj według nazwy, części, SKU lub parametru",
        "hu": "Keresés név, alkatrész, SKU vagy specifikáció szerint",
        "ro": "Caută după nume, piesă, SKU sau specificație"
    },
    "template.b2b-wholesale.chrome.promoMessage": {
        "cs": "Technický katalog podle SKU, parametru a balení",
        "sk": "Technický katalóg podľa SKU, parametra a balenia",
        "en": "A technical catalog organized by SKU, specification and pack",
        "de": "Technischer Katalog nach SKU, Spezifikation und Verpackungseinheit",
        "es": "Un catálogo técnico organizado por SKU, especificación y formato",
        "pl": "Katalog techniczny uporządkowany według SKU, parametrów i opakowań",
        "hu": "Műszaki katalógus SKU, specifikáció és kiszerelés szerint",
        "ro": "Catalog tehnic organizat după SKU, specificație și ambalaj"
    },
    "template.b2b-wholesale.chrome.promoTag": {
        "cs": "B2B KATALOG",
        "sk": "B2B KATALÓG",
        "en": "B2B CATALOG",
        "de": "B2B-KATALOG",
        "es": "CATÁLOGO B2B",
        "pl": "KATALOG B2B",
        "hu": "B2B KATALÓGUS",
        "ro": "CATALOG B2B"
    },
    "template.b2b-wholesale.chrome.productEyebrow": {
        "cs": "RYCHLÁ OBJEDNÁVKA",
        "sk": "RÝCHLA OBJEDNÁVKA",
        "en": "QUICK ORDER",
        "de": "SCHNELLBESTELLUNG",
        "es": "PEDIDO RÁPIDO",
        "pl": "SZYBKIE ZAMÓWIENIE",
        "hu": "GYORSRENDELÉS",
        "ro": "COMANDĂ RAPIDĂ"
    },
    "template.b2b-wholesale.chrome.productTitle": {
        "cs": "Položky připravené pro přesný nákup",
        "sk": "Položky pripravené na presný nákup",
        "en": "Items prepared for precise procurement",
        "de": "Artikel für eine präzise Beschaffung",
        "es": "Artículos preparados para un aprovisionamiento preciso",
        "pl": "Pozycje przygotowane z myślą o precyzyjnych zakupach",
        "hu": "Pontos beszerzésre előkészített tételek",
        "ro": "Articole pregătite pentru achiziții precise"
    },
    "template.b2b-wholesale.chrome.seoTitle": {
        "cs": "Technický nákup bez zbytečných mezikroků",
        "sk": "Technický nákup bez zbytočných medzikrokov",
        "en": "Technical procurement without unnecessary steps",
        "de": "Technische Beschaffung ohne unnötige Schritte",
        "es": "Compras técnicas sin pasos innecesarios",
        "pl": "Zakupy techniczne bez zbędnych kroków",
        "hu": "Műszaki beszerzés felesleges lépések nélkül",
        "ro": "Achiziții tehnice fără pași inutili"
    },
    "template.b2b-wholesale.chrome.seoBody": {
        "cs": "SKU, parametry, balení a dostupnost tvoří kompaktní a srovnatelný záznam.",
        "sk": "SKU, parametre, balenie a dostupnosť tvoria kompaktný a porovnateľný záznam.",
        "en": "SKU, specifications, pack size and availability form a compact, comparable record.",
        "de": "SKU, Spezifikationen, Verpackungseinheit und Verfügbarkeit ergeben einen kompakten, vergleichbaren Datensatz.",
        "es": "El SKU, las especificaciones, las unidades por paquete y la disponibilidad forman una ficha compacta y comparable.",
        "pl": "SKU, parametry, wielkość opakowania i dostępność tworzą zwięzłą, łatwą do porównania kartę.",
        "hu": "Az SKU, a specifikációk, a kiszerelés és az elérhetőség tömör, összehasonlítható adatlapot alkot.",
        "ro": "SKU-ul, specificațiile, cantitatea per ambalaj și disponibilitatea formează o fișă compactă și ușor de comparat."
    },
    "template.b2b-wholesale.chrome.seoDetails": {
        "cs": "Vyhledávání podle kódu vede přímo k položce, dokumentům a množstevnímu zadání. Odborný kontakt zůstává dostupný pro případy, které vyžadují konzultaci.",
        "sk": "Vyhľadávanie podľa kódu vedie priamo k položke, dokumentom a zadaniu množstva. Odborný kontakt zostáva dostupný pre prípady, ktoré si vyžadujú konzultáciu.",
        "en": "Code-based search leads directly to the item, documents and quantity entry, with expert contact available when consultation is needed.",
        "de": "Die Codesuche führt direkt zum Artikel, zu Dokumenten und zur Mengeneingabe. Für Fälle mit Beratungsbedarf bleibt ein fachkundiger Kontakt erreichbar.",
        "es": "La búsqueda por código lleva directamente al artículo, los documentos y la introducción de cantidades, con un contacto especializado disponible cuando se necesita asesoramiento.",
        "pl": "Wyszukiwanie po kodzie prowadzi bezpośrednio do pozycji, dokumentów i pola ilości, a kontakt z ekspertem jest dostępny zawsze, gdy potrzebna jest konsultacja.",
        "hu": "A kódalapú keresés közvetlenül a tételhez, a dokumentumokhoz és a mennyiség megadásához vezet. Ha konzultációra van szükség, szakértői kapcsolattartó is elérhető.",
        "ro": "Căutarea după cod duce direct la articol, documente și introducerea cantității, iar contactul cu un specialist este disponibil atunci când ai nevoie de consultanță."
    },
    "template.b2b-wholesale.chrome.newsletterBody": {
        "cs": "Změny sortimentu, technické dokumenty a důležité katalogové informace.",
        "sk": "Zmeny sortimentu, technické dokumenty a dôležité katalógové informácie.",
        "en": "Range updates, technical documents and important catalog information.",
        "de": "Sortimentsänderungen, technische Dokumente und wichtige Kataloginformationen.",
        "es": "Actualizaciones del catálogo, documentos técnicos e información importante sobre la oferta.",
        "pl": "Zmiany w asortymencie, dokumenty techniczne i ważne informacje katalogowe.",
        "hu": "Változások a kínálatban, műszaki dokumentumok és fontos katalógusinformációk.",
        "ro": "Actualizări ale gamei, documente tehnice și informații importante din catalog."
    },
    "template.b2b-wholesale.chrome.benefitTitle": {
        "cs": "SKU, balení a dokumentace v jednom řádku",
        "sk": "SKU, balenie a dokumentácia v jednom riadku",
        "en": "SKU, pack size and documents in one line",
        "de": "SKU, Verpackungseinheit und Dokumente in einer Zeile",
        "es": "SKU, unidades por paquete y documentos en una sola línea",
        "pl": "SKU, opakowanie i dokumenty w jednym wierszu",
        "hu": "SKU, kiszerelés és dokumentumok egy sorban",
        "ro": "SKU, cantitatea per ambalaj și documentele pe un singur rând"
    },
    "template.b2b-wholesale.chrome.benefitBody": {
        "cs": "Kompaktní data a rychlé zadání množství drží opakovaný nákup přehledný.",
        "sk": "Kompaktné údaje a rýchle zadanie množstva udržiavajú prehľad pri opakovaných nákupoch.",
        "en": "Compact data and fast quantity entry keep repeat procurement clear.",
        "de": "Kompakte Daten und eine schnelle Mengeneingabe sorgen bei wiederkehrenden Bestellungen für Übersicht.",
        "es": "Los datos compactos y la introducción rápida de cantidades mantienen claras las compras recurrentes.",
        "pl": "Kompaktowe dane i szybkie wprowadzanie ilości ułatwiają powtarzalne zakupy.",
        "hu": "A tömör adatok és a gyors mennyiségmegadás átláthatóvá teszik az ismételt beszerzéseket.",
        "ro": "Datele compacte și introducerea rapidă a cantității păstrează claritatea achizițiilor repetate."
    },
    "template.b2b-wholesale.chrome.categoryEyebrow": {
        "cs": "PODLE OBORU A PARAMETRU",
        "sk": "PODĽA ODVETVIA A PARAMETRA",
        "en": "BY INDUSTRY AND SPECIFICATION",
        "de": "NACH BRANCHE UND SPEZIFIKATION",
        "es": "POR SECTOR Y ESPECIFICACIÓN",
        "pl": "WEDŁUG BRANŻY I SPECYFIKACJI",
        "hu": "IPARÁG ÉS SPECIFIKÁCIÓ SZERINT",
        "ro": "DUPĂ INDUSTRIE ȘI SPECIFICAȚIE"
    },
    "template.b2b-wholesale.chrome.footerGuide": {
        "cs": "Technické dokumenty",
        "sk": "Technické dokumenty",
        "en": "Technical documents",
        "de": "Technische Dokumente",
        "es": "Documentos técnicos",
        "pl": "Dokumenty techniczne",
        "hu": "Műszaki dokumentumok",
        "ro": "Documente tehnice"
    },
    "template.b2b-wholesale.chrome.bestsellerTitle": {
        "cs": "Nejprodávanější",
        "sk": "Najpredávanejšie",
        "en": "Best selling",
        "de": "Bestseller",
        "es": "Más vendidos",
        "pl": "Bestsellery",
        "hu": "Legnépszerűbb",
        "ro": "Cele mai vândute"
    },
    "template.b2b-wholesale.chrome.bestsellerAction": {
        "cs": "Zobrazit produkty",
        "sk": "Zobraziť produkty",
        "en": "Show products",
        "de": "Produkte anzeigen",
        "es": "Mostrar productos",
        "pl": "Pokaż produkty",
        "hu": "Termékek megjelenítése",
        "ro": "Afișați produsele"
    }
};
